
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire42e1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire42e1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jtku2", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e2d09d5cb29f5b9c$export$ffb0004e005737fa, (v) => $e2d09d5cb29f5b9c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $e2d09d5cb29f5b9c$export$34b9dba7ce09269b, (v) => $e2d09d5cb29f5b9c$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $e2d09d5cb29f5b9c$export$25062201e9e25d76, (v) => $e2d09d5cb29f5b9c$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e2d09d5cb29f5b9c$export$ffb0004e005737fa;
var $e2d09d5cb29f5b9c$export$34b9dba7ce09269b;
var $e2d09d5cb29f5b9c$export$25062201e9e25d76;
"use strict";
var $e2d09d5cb29f5b9c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e2d09d5cb29f5b9c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $e2d09d5cb29f5b9c$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $e2d09d5cb29f5b9c$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$e2d09d5cb29f5b9c$export$ffb0004e005737fa = $e2d09d5cb29f5b9c$var$REACT_FRAGMENT_TYPE;
$e2d09d5cb29f5b9c$export$34b9dba7ce09269b = $e2d09d5cb29f5b9c$var$jsxProd;
$e2d09d5cb29f5b9c$export$25062201e9e25d76 = $e2d09d5cb29f5b9c$var$jsxProd;

});

parcelRegister("7AdSc", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $5856a82543d511fb$export$9c16c1426311996d, (v) => $5856a82543d511fb$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $5856a82543d511fb$export$dca3b0875bd9a954, (v) => $5856a82543d511fb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $5856a82543d511fb$export$16fa2f45be04daa8, (v) => $5856a82543d511fb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $5856a82543d511fb$export$ffb0004e005737fa, (v) => $5856a82543d511fb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $5856a82543d511fb$export$e2c29f18771995cb, (v) => $5856a82543d511fb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $5856a82543d511fb$export$221d75b3f55bb0bd, (v) => $5856a82543d511fb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $5856a82543d511fb$export$5f8d39834fd61797, (v) => $5856a82543d511fb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $5856a82543d511fb$export$74bf444e3cd11ea5, (v) => $5856a82543d511fb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $5856a82543d511fb$export$1ced07cd6b1985ce, (v) => $5856a82543d511fb$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $5856a82543d511fb$export$abd8e32b826d7ea7, (v) => $5856a82543d511fb$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $5856a82543d511fb$export$69a3209f1a06c04d, (v) => $5856a82543d511fb$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $5856a82543d511fb$export$8c538325882c7eec, (v) => $5856a82543d511fb$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $5856a82543d511fb$export$e530037191fcd5d7, (v) => $5856a82543d511fb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $5856a82543d511fb$export$fd42f52fd3ae1109, (v) => $5856a82543d511fb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $5856a82543d511fb$export$c8a8987d4410bf2d, (v) => $5856a82543d511fb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $5856a82543d511fb$export$7d1e3a5e95ceca43, (v) => $5856a82543d511fb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $5856a82543d511fb$export$257a8862b851cb5b, (v) => $5856a82543d511fb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $5856a82543d511fb$export$a8257692ac88316c, (v) => $5856a82543d511fb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $5856a82543d511fb$export$488013bae63b21da, (v) => $5856a82543d511fb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $5856a82543d511fb$export$7c73462e0d25e514, (v) => $5856a82543d511fb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $5856a82543d511fb$export$7568632d0d33d16d, (v) => $5856a82543d511fb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $5856a82543d511fb$export$f93f40ac0ca7e3a8, (v) => $5856a82543d511fb$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $5856a82543d511fb$export$1f96ae73734a86cc, (v) => $5856a82543d511fb$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $5856a82543d511fb$export$9a47ced3238df325, (v) => $5856a82543d511fb$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $5856a82543d511fb$export$35808ee640e87ca7, (v) => $5856a82543d511fb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $5856a82543d511fb$export$fae74005e78b1a27, (v) => $5856a82543d511fb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $5856a82543d511fb$export$dc8fbce3eb94dc1e, (v) => $5856a82543d511fb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $5856a82543d511fb$export$6a7bc4e911dc01cf, (v) => $5856a82543d511fb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $5856a82543d511fb$export$6d9c69b0de29b591, (v) => $5856a82543d511fb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $5856a82543d511fb$export$7f54fc3180508a52, (v) => $5856a82543d511fb$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $5856a82543d511fb$export$f680877a34711e37, (v) => $5856a82543d511fb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $5856a82543d511fb$export$d5a552a76deda3c2, (v) => $5856a82543d511fb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $5856a82543d511fb$export$aaabe4eda9ed9969, (v) => $5856a82543d511fb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $5856a82543d511fb$export$e5c5a5f917a5871c, (v) => $5856a82543d511fb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $5856a82543d511fb$export$1538c33de8887b59, (v) => $5856a82543d511fb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $5856a82543d511fb$export$fca7f784ae7a249a, (v) => $5856a82543d511fb$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $5856a82543d511fb$export$13e3392192263954, (v) => $5856a82543d511fb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $5856a82543d511fb$export$b8f5890fc79d6aca, (v) => $5856a82543d511fb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $5856a82543d511fb$export$60241385465d0a34, (v) => $5856a82543d511fb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $5856a82543d511fb$export$306c0aa65ff9ec16, (v) => $5856a82543d511fb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $5856a82543d511fb$export$7b286972b8d8ccbf, (v) => $5856a82543d511fb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $5856a82543d511fb$export$83d89fbfd8236492, (v) => $5856a82543d511fb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5856a82543d511fb$export$9c16c1426311996d;
var $5856a82543d511fb$export$dca3b0875bd9a954;
var $5856a82543d511fb$export$16fa2f45be04daa8;
var $5856a82543d511fb$export$ffb0004e005737fa;
var $5856a82543d511fb$export$e2c29f18771995cb;
var $5856a82543d511fb$export$221d75b3f55bb0bd;
var $5856a82543d511fb$export$5f8d39834fd61797;
var $5856a82543d511fb$export$74bf444e3cd11ea5;
var $5856a82543d511fb$export$1ced07cd6b1985ce;
var $5856a82543d511fb$export$abd8e32b826d7ea7;
var $5856a82543d511fb$export$69a3209f1a06c04d;
var $5856a82543d511fb$export$8c538325882c7eec;
var $5856a82543d511fb$export$e530037191fcd5d7;
var $5856a82543d511fb$export$fd42f52fd3ae1109;
var $5856a82543d511fb$export$c8a8987d4410bf2d;
var $5856a82543d511fb$export$7d1e3a5e95ceca43;
var $5856a82543d511fb$export$257a8862b851cb5b;
var $5856a82543d511fb$export$a8257692ac88316c;
var $5856a82543d511fb$export$488013bae63b21da;
var $5856a82543d511fb$export$7c73462e0d25e514;
var $5856a82543d511fb$export$7568632d0d33d16d;
var $5856a82543d511fb$export$f93f40ac0ca7e3a8;
var $5856a82543d511fb$export$1f96ae73734a86cc;
var $5856a82543d511fb$export$9a47ced3238df325;
var $5856a82543d511fb$export$35808ee640e87ca7;
var $5856a82543d511fb$export$fae74005e78b1a27;
var $5856a82543d511fb$export$dc8fbce3eb94dc1e;
var $5856a82543d511fb$export$6a7bc4e911dc01cf;
var $5856a82543d511fb$export$6d9c69b0de29b591;
var $5856a82543d511fb$export$7f54fc3180508a52;
var $5856a82543d511fb$export$f680877a34711e37;
var $5856a82543d511fb$export$d5a552a76deda3c2;
var $5856a82543d511fb$export$aaabe4eda9ed9969;
var $5856a82543d511fb$export$e5c5a5f917a5871c;
var $5856a82543d511fb$export$1538c33de8887b59;
var $5856a82543d511fb$export$fca7f784ae7a249a;
var $5856a82543d511fb$export$13e3392192263954;
var $5856a82543d511fb$export$b8f5890fc79d6aca;
var $5856a82543d511fb$export$60241385465d0a34;
var $5856a82543d511fb$export$306c0aa65ff9ec16;
var $5856a82543d511fb$export$7b286972b8d8ccbf;
var $5856a82543d511fb$export$83d89fbfd8236492;
"use strict";
var $5856a82543d511fb$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5856a82543d511fb$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5856a82543d511fb$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $5856a82543d511fb$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $5856a82543d511fb$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $5856a82543d511fb$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $5856a82543d511fb$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $5856a82543d511fb$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $5856a82543d511fb$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $5856a82543d511fb$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $5856a82543d511fb$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $5856a82543d511fb$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $5856a82543d511fb$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $5856a82543d511fb$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $5856a82543d511fb$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$5856a82543d511fb$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $5856a82543d511fb$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5856a82543d511fb$var$assign = Object.assign, $5856a82543d511fb$var$emptyObject = {};
function $5856a82543d511fb$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5856a82543d511fb$var$emptyObject;
    this.updater = updater || $5856a82543d511fb$var$ReactNoopUpdateQueue;
}
$5856a82543d511fb$var$Component.prototype.isReactComponent = {};
$5856a82543d511fb$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$5856a82543d511fb$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $5856a82543d511fb$var$ComponentDummy() {}
$5856a82543d511fb$var$ComponentDummy.prototype = $5856a82543d511fb$var$Component.prototype;
function $5856a82543d511fb$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5856a82543d511fb$var$emptyObject;
    this.updater = updater || $5856a82543d511fb$var$ReactNoopUpdateQueue;
}
var $5856a82543d511fb$var$pureComponentPrototype = $5856a82543d511fb$var$PureComponent.prototype = new $5856a82543d511fb$var$ComponentDummy();
$5856a82543d511fb$var$pureComponentPrototype.constructor = $5856a82543d511fb$var$PureComponent;
$5856a82543d511fb$var$assign($5856a82543d511fb$var$pureComponentPrototype, $5856a82543d511fb$var$Component.prototype);
$5856a82543d511fb$var$pureComponentPrototype.isPureReactComponent = !0;
var $5856a82543d511fb$var$isArrayImpl = Array.isArray;
function $5856a82543d511fb$var$noop() {}
var $5856a82543d511fb$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $5856a82543d511fb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $5856a82543d511fb$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $5856a82543d511fb$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $5856a82543d511fb$var$cloneAndReplaceKey(oldElement, newKey) {
    return $5856a82543d511fb$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $5856a82543d511fb$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $5856a82543d511fb$var$REACT_ELEMENT_TYPE;
}
function $5856a82543d511fb$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $5856a82543d511fb$var$userProvidedKeyEscapeRegex = /\/+/g;
function $5856a82543d511fb$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $5856a82543d511fb$var$escape("" + element.key) : index.toString(36);
}
function $5856a82543d511fb$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($5856a82543d511fb$var$noop, $5856a82543d511fb$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $5856a82543d511fb$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $5856a82543d511fb$var$REACT_ELEMENT_TYPE:
                case $5856a82543d511fb$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $5856a82543d511fb$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $5856a82543d511fb$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $5856a82543d511fb$var$getElementKey(children, 0) : nameSoFar, $5856a82543d511fb$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($5856a82543d511fb$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $5856a82543d511fb$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($5856a82543d511fb$var$isValidElement(callback) && (callback = $5856a82543d511fb$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($5856a82543d511fb$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($5856a82543d511fb$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $5856a82543d511fb$var$getElementKey(nameSoFar, i), invokeCallback += $5856a82543d511fb$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $5856a82543d511fb$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $5856a82543d511fb$var$getElementKey(nameSoFar, i++), invokeCallback += $5856a82543d511fb$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $5856a82543d511fb$var$mapIntoArray($5856a82543d511fb$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $5856a82543d511fb$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $5856a82543d511fb$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $5856a82543d511fb$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $5856a82543d511fb$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $5856a82543d511fb$var$Children = {
    map: $5856a82543d511fb$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $5856a82543d511fb$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $5856a82543d511fb$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $5856a82543d511fb$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$5856a82543d511fb$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$5856a82543d511fb$export$9c16c1426311996d = $5856a82543d511fb$var$REACT_ACTIVITY_TYPE;
$5856a82543d511fb$export$dca3b0875bd9a954 = $5856a82543d511fb$var$Children;
$5856a82543d511fb$export$16fa2f45be04daa8 = $5856a82543d511fb$var$Component;
$5856a82543d511fb$export$ffb0004e005737fa = $5856a82543d511fb$var$REACT_FRAGMENT_TYPE;
$5856a82543d511fb$export$e2c29f18771995cb = $5856a82543d511fb$var$REACT_PROFILER_TYPE;
$5856a82543d511fb$export$221d75b3f55bb0bd = $5856a82543d511fb$var$PureComponent;
$5856a82543d511fb$export$5f8d39834fd61797 = $5856a82543d511fb$var$REACT_STRICT_MODE_TYPE;
$5856a82543d511fb$export$74bf444e3cd11ea5 = $5856a82543d511fb$var$REACT_SUSPENSE_TYPE;
$5856a82543d511fb$export$1ced07cd6b1985ce = $5856a82543d511fb$var$ReactSharedInternals;
$5856a82543d511fb$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $5856a82543d511fb$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$5856a82543d511fb$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$5856a82543d511fb$export$8c538325882c7eec = function() {
    return null;
};
$5856a82543d511fb$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $5856a82543d511fb$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$5856a82543d511fb$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $5856a82543d511fb$var$ReactElement(element.type, key, props);
};
$5856a82543d511fb$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $5856a82543d511fb$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $5856a82543d511fb$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$5856a82543d511fb$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$5856a82543d511fb$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $5856a82543d511fb$var$ReactElement(type, key, props);
};
$5856a82543d511fb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5856a82543d511fb$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $5856a82543d511fb$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$5856a82543d511fb$export$a8257692ac88316c = $5856a82543d511fb$var$isValidElement;
$5856a82543d511fb$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $5856a82543d511fb$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $5856a82543d511fb$var$lazyInitializer
    };
};
$5856a82543d511fb$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $5856a82543d511fb$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$5856a82543d511fb$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $5856a82543d511fb$var$ReactSharedInternals.T, currentTransition = {};
    $5856a82543d511fb$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $5856a82543d511fb$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($5856a82543d511fb$var$noop, $5856a82543d511fb$var$reportGlobalError);
    } catch (error) {
        $5856a82543d511fb$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5856a82543d511fb$var$ReactSharedInternals.T = prevTransition;
    }
};
$5856a82543d511fb$export$f93f40ac0ca7e3a8 = function() {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useCacheRefresh();
};
$5856a82543d511fb$export$1f96ae73734a86cc = function(usable) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.use(usable);
};
$5856a82543d511fb$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$5856a82543d511fb$export$35808ee640e87ca7 = function(callback, deps) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$5856a82543d511fb$export$fae74005e78b1a27 = function(Context) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useContext(Context);
};
$5856a82543d511fb$export$dc8fbce3eb94dc1e = function() {};
$5856a82543d511fb$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$5856a82543d511fb$export$6d9c69b0de29b591 = function(create, deps) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useEffect(create, deps);
};
$5856a82543d511fb$export$7f54fc3180508a52 = function(callback) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$5856a82543d511fb$export$f680877a34711e37 = function() {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useId();
};
$5856a82543d511fb$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$5856a82543d511fb$export$aaabe4eda9ed9969 = function(create, deps) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$5856a82543d511fb$export$e5c5a5f917a5871c = function(create, deps) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$5856a82543d511fb$export$1538c33de8887b59 = function(create, deps) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useMemo(create, deps);
};
$5856a82543d511fb$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$5856a82543d511fb$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$5856a82543d511fb$export$b8f5890fc79d6aca = function(initialValue) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useRef(initialValue);
};
$5856a82543d511fb$export$60241385465d0a34 = function(initialState) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useState(initialState);
};
$5856a82543d511fb$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$5856a82543d511fb$export$7b286972b8d8ccbf = function() {
    return $5856a82543d511fb$var$ReactSharedInternals.H.useTransition();
};
$5856a82543d511fb$export$83d89fbfd8236492 = "19.2.0";

});

parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("daXOJ", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $997a9c03857cd60f$export$882461b6382ed46c, (v) => $997a9c03857cd60f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $997a9c03857cd60f$export$757ceba2d55c277e, (v) => $997a9c03857cd60f$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $997a9c03857cd60f$export$83d89fbfd8236492, (v) => $997a9c03857cd60f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $997a9c03857cd60f$export$882461b6382ed46c;
var $997a9c03857cd60f$export$757ceba2d55c277e;
var $997a9c03857cd60f$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $3xFFA = parcelRequire("3xFFA");

var $J181o = parcelRequire("J181o");
function $997a9c03857cd60f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $997a9c03857cd60f$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $997a9c03857cd60f$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $997a9c03857cd60f$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $997a9c03857cd60f$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $997a9c03857cd60f$var$assertIsMounted(fiber) {
    if ($997a9c03857cd60f$var$getNearestMountedFiber(fiber) !== fiber) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(188));
}
function $997a9c03857cd60f$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $997a9c03857cd60f$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $997a9c03857cd60f$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $997a9c03857cd60f$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $997a9c03857cd60f$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $997a9c03857cd60f$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $997a9c03857cd60f$var$assign = Object.assign, $997a9c03857cd60f$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $997a9c03857cd60f$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $997a9c03857cd60f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $997a9c03857cd60f$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $997a9c03857cd60f$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $997a9c03857cd60f$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $997a9c03857cd60f$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $997a9c03857cd60f$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $997a9c03857cd60f$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $997a9c03857cd60f$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $997a9c03857cd60f$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $997a9c03857cd60f$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $997a9c03857cd60f$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $997a9c03857cd60f$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $997a9c03857cd60f$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $997a9c03857cd60f$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $997a9c03857cd60f$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$997a9c03857cd60f$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $997a9c03857cd60f$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $997a9c03857cd60f$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $997a9c03857cd60f$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $997a9c03857cd60f$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $997a9c03857cd60f$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $997a9c03857cd60f$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $997a9c03857cd60f$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $997a9c03857cd60f$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $997a9c03857cd60f$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $997a9c03857cd60f$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $997a9c03857cd60f$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $997a9c03857cd60f$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $997a9c03857cd60f$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $997a9c03857cd60f$var$getComponentNameFromType(type.type) || "Memo";
        case $997a9c03857cd60f$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $997a9c03857cd60f$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $997a9c03857cd60f$var$isArrayImpl = Array.isArray, $997a9c03857cd60f$var$ReactSharedInternals = $3xFFA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $997a9c03857cd60f$var$ReactDOMSharedInternals = $J181o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $997a9c03857cd60f$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $997a9c03857cd60f$var$valueStack = [], $997a9c03857cd60f$var$index = -1;
function $997a9c03857cd60f$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $997a9c03857cd60f$var$pop(cursor) {
    0 > $997a9c03857cd60f$var$index || (cursor.current = $997a9c03857cd60f$var$valueStack[$997a9c03857cd60f$var$index], $997a9c03857cd60f$var$valueStack[$997a9c03857cd60f$var$index] = null, $997a9c03857cd60f$var$index--);
}
function $997a9c03857cd60f$var$push(cursor, value) {
    $997a9c03857cd60f$var$index++;
    $997a9c03857cd60f$var$valueStack[$997a9c03857cd60f$var$index] = cursor.current;
    cursor.current = value;
}
var $997a9c03857cd60f$var$contextStackCursor = $997a9c03857cd60f$var$createCursor(null), $997a9c03857cd60f$var$contextFiberStackCursor = $997a9c03857cd60f$var$createCursor(null), $997a9c03857cd60f$var$rootInstanceStackCursor = $997a9c03857cd60f$var$createCursor(null), $997a9c03857cd60f$var$hostTransitionProviderCursor = $997a9c03857cd60f$var$createCursor(null);
function $997a9c03857cd60f$var$pushHostContainer(fiber, nextRootInstance) {
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$rootInstanceStackCursor, nextRootInstance);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$contextFiberStackCursor, fiber);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $997a9c03857cd60f$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $997a9c03857cd60f$var$getOwnHostContext(nextRootInstance), fiber = $997a9c03857cd60f$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$contextStackCursor);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$contextStackCursor, fiber);
}
function $997a9c03857cd60f$var$popHostContainer() {
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$contextStackCursor);
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$contextFiberStackCursor);
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$rootInstanceStackCursor);
}
function $997a9c03857cd60f$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $997a9c03857cd60f$var$push($997a9c03857cd60f$var$hostTransitionProviderCursor, fiber);
    var context = $997a9c03857cd60f$var$contextStackCursor.current;
    var JSCompiler_inline_result = $997a9c03857cd60f$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($997a9c03857cd60f$var$push($997a9c03857cd60f$var$contextFiberStackCursor, fiber), $997a9c03857cd60f$var$push($997a9c03857cd60f$var$contextStackCursor, JSCompiler_inline_result));
}
function $997a9c03857cd60f$var$popHostContext(fiber) {
    $997a9c03857cd60f$var$contextFiberStackCursor.current === fiber && ($997a9c03857cd60f$var$pop($997a9c03857cd60f$var$contextStackCursor), $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$contextFiberStackCursor));
    $997a9c03857cd60f$var$hostTransitionProviderCursor.current === fiber && ($997a9c03857cd60f$var$pop($997a9c03857cd60f$var$hostTransitionProviderCursor), $997a9c03857cd60f$var$HostTransitionContext._currentValue = $997a9c03857cd60f$var$sharedNotPendingObject);
}
var $997a9c03857cd60f$var$prefix, $997a9c03857cd60f$var$suffix;
function $997a9c03857cd60f$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $997a9c03857cd60f$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $997a9c03857cd60f$var$prefix = match && match[1] || "";
        $997a9c03857cd60f$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $997a9c03857cd60f$var$prefix + name + $997a9c03857cd60f$var$suffix;
}
var $997a9c03857cd60f$var$reentry = !1;
function $997a9c03857cd60f$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $997a9c03857cd60f$var$reentry) return "";
    $997a9c03857cd60f$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $997a9c03857cd60f$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $997a9c03857cd60f$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $997a9c03857cd60f$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $997a9c03857cd60f$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $997a9c03857cd60f$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $997a9c03857cd60f$var$describeBuiltInComponentFrame("Suspense Fallback") : $997a9c03857cd60f$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $997a9c03857cd60f$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $997a9c03857cd60f$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $997a9c03857cd60f$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $997a9c03857cd60f$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $997a9c03857cd60f$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $997a9c03857cd60f$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $997a9c03857cd60f$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $997a9c03857cd60f$var$hasOwnProperty = Object.prototype.hasOwnProperty, $997a9c03857cd60f$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $997a9c03857cd60f$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $997a9c03857cd60f$var$shouldYield = $bIbqH.unstable_shouldYield, $997a9c03857cd60f$var$requestPaint = $bIbqH.unstable_requestPaint, $997a9c03857cd60f$var$now = $bIbqH.unstable_now, $997a9c03857cd60f$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $997a9c03857cd60f$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $997a9c03857cd60f$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $997a9c03857cd60f$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $997a9c03857cd60f$var$LowPriority = $bIbqH.unstable_LowPriority, $997a9c03857cd60f$var$IdlePriority = $bIbqH.unstable_IdlePriority, $997a9c03857cd60f$var$log$1 = $bIbqH.log, $997a9c03857cd60f$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $997a9c03857cd60f$var$rendererID = null, $997a9c03857cd60f$var$injectedHook = null;
function $997a9c03857cd60f$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $997a9c03857cd60f$var$log$1 && $997a9c03857cd60f$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($997a9c03857cd60f$var$injectedHook && "function" === typeof $997a9c03857cd60f$var$injectedHook.setStrictMode) try {
        $997a9c03857cd60f$var$injectedHook.setStrictMode($997a9c03857cd60f$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $997a9c03857cd60f$var$clz32 = Math.clz32 ? Math.clz32 : $997a9c03857cd60f$var$clz32Fallback, $997a9c03857cd60f$var$log = Math.log, $997a9c03857cd60f$var$LN2 = Math.LN2;
function $997a9c03857cd60f$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($997a9c03857cd60f$var$log(x) / $997a9c03857cd60f$var$LN2 | 0) | 0;
}
var $997a9c03857cd60f$var$nextTransitionUpdateLane = 256, $997a9c03857cd60f$var$nextTransitionDeferredLane = 262144, $997a9c03857cd60f$var$nextRetryLane = 4194304;
function $997a9c03857cd60f$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $997a9c03857cd60f$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $997a9c03857cd60f$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $997a9c03857cd60f$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $997a9c03857cd60f$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $997a9c03857cd60f$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $997a9c03857cd60f$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $997a9c03857cd60f$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $997a9c03857cd60f$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $997a9c03857cd60f$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $997a9c03857cd60f$var$claimNextRetryLane() {
    var lane = $997a9c03857cd60f$var$nextRetryLane;
    $997a9c03857cd60f$var$nextRetryLane <<= 1;
    0 === ($997a9c03857cd60f$var$nextRetryLane & 62914560) && ($997a9c03857cd60f$var$nextRetryLane = 4194304);
    return lane;
}
function $997a9c03857cd60f$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $997a9c03857cd60f$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $997a9c03857cd60f$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $997a9c03857cd60f$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $997a9c03857cd60f$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $997a9c03857cd60f$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $997a9c03857cd60f$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $997a9c03857cd60f$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $997a9c03857cd60f$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $997a9c03857cd60f$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $997a9c03857cd60f$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $997a9c03857cd60f$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $997a9c03857cd60f$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $997a9c03857cd60f$var$resolveUpdatePriority() {
    var updatePriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $997a9c03857cd60f$var$getEventPriority(updatePriority.type);
}
function $997a9c03857cd60f$var$runWithPriority(priority, fn) {
    var previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
    try {
        return $997a9c03857cd60f$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $997a9c03857cd60f$var$randomKey = Math.random().toString(36).slice(2), $997a9c03857cd60f$var$internalInstanceKey = "__reactFiber$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalPropsKey = "__reactProps$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalContainerInstanceKey = "__reactContainer$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalEventHandlersKey = "__reactEvents$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalEventHandlerListenersKey = "__reactListeners$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalEventHandlesSetKey = "__reactHandles$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalRootNodeResourcesKey = "__reactResources$" + $997a9c03857cd60f$var$randomKey, $997a9c03857cd60f$var$internalHoistableMarker = "__reactMarker$" + $997a9c03857cd60f$var$randomKey;
function $997a9c03857cd60f$var$detachDeletedInstance(node) {
    delete node[$997a9c03857cd60f$var$internalInstanceKey];
    delete node[$997a9c03857cd60f$var$internalPropsKey];
    delete node[$997a9c03857cd60f$var$internalEventHandlersKey];
    delete node[$997a9c03857cd60f$var$internalEventHandlerListenersKey];
    delete node[$997a9c03857cd60f$var$internalEventHandlesSetKey];
}
function $997a9c03857cd60f$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$997a9c03857cd60f$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$997a9c03857cd60f$var$internalContainerInstanceKey] || parentNode[$997a9c03857cd60f$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $997a9c03857cd60f$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$997a9c03857cd60f$var$internalInstanceKey]) return parentNode;
                targetNode = $997a9c03857cd60f$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $997a9c03857cd60f$var$getInstanceFromNode(node) {
    if (node = node[$997a9c03857cd60f$var$internalInstanceKey] || node[$997a9c03857cd60f$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $997a9c03857cd60f$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(33));
}
function $997a9c03857cd60f$var$getResourcesFromRoot(root) {
    var resources = root[$997a9c03857cd60f$var$internalRootNodeResourcesKey];
    resources || (resources = root[$997a9c03857cd60f$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $997a9c03857cd60f$var$markNodeAsHoistable(node) {
    node[$997a9c03857cd60f$var$internalHoistableMarker] = !0;
}
var $997a9c03857cd60f$var$allNativeEvents = new Set(), $997a9c03857cd60f$var$registrationNameDependencies = {};
function $997a9c03857cd60f$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $997a9c03857cd60f$var$registerDirectEvent(registrationName, dependencies);
    $997a9c03857cd60f$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $997a9c03857cd60f$var$registerDirectEvent(registrationName, dependencies) {
    $997a9c03857cd60f$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$997a9c03857cd60f$var$allNativeEvents.add(dependencies[registrationName]);
}
var $997a9c03857cd60f$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $997a9c03857cd60f$var$illegalAttributeNameCache = {}, $997a9c03857cd60f$var$validatedAttributeNameCache = {};
function $997a9c03857cd60f$var$isAttributeNameSafe(attributeName) {
    if ($997a9c03857cd60f$var$hasOwnProperty.call($997a9c03857cd60f$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($997a9c03857cd60f$var$hasOwnProperty.call($997a9c03857cd60f$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($997a9c03857cd60f$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $997a9c03857cd60f$var$validatedAttributeNameCache[attributeName] = !0;
    $997a9c03857cd60f$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $997a9c03857cd60f$var$setValueForAttribute(node, name, value) {
    if ($997a9c03857cd60f$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $997a9c03857cd60f$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $997a9c03857cd60f$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $997a9c03857cd60f$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $997a9c03857cd60f$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $997a9c03857cd60f$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $997a9c03857cd60f$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $997a9c03857cd60f$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $997a9c03857cd60f$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $997a9c03857cd60f$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $997a9c03857cd60f$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $997a9c03857cd60f$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $997a9c03857cd60f$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $997a9c03857cd60f$var$getToStringValue(value);
        } else element.value !== "" + $997a9c03857cd60f$var$getToStringValue(value) && (element.value = "" + $997a9c03857cd60f$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $997a9c03857cd60f$var$setDefaultValue(element, type, $997a9c03857cd60f$var$getToStringValue(value)) : null != defaultValue ? $997a9c03857cd60f$var$setDefaultValue(element, type, $997a9c03857cd60f$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $997a9c03857cd60f$var$getToStringValue(name) : element.removeAttribute("name");
}
function $997a9c03857cd60f$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $997a9c03857cd60f$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $997a9c03857cd60f$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $997a9c03857cd60f$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $997a9c03857cd60f$var$track(element);
}
function $997a9c03857cd60f$var$setDefaultValue(node, type, value) {
    "number" === type && $997a9c03857cd60f$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $997a9c03857cd60f$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $997a9c03857cd60f$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $997a9c03857cd60f$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $997a9c03857cd60f$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $997a9c03857cd60f$var$getToStringValue(defaultValue) : "";
}
function $997a9c03857cd60f$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(92));
            if ($997a9c03857cd60f$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $997a9c03857cd60f$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $997a9c03857cd60f$var$track(element);
}
function $997a9c03857cd60f$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $997a9c03857cd60f$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $997a9c03857cd60f$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $997a9c03857cd60f$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $997a9c03857cd60f$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $997a9c03857cd60f$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $997a9c03857cd60f$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $997a9c03857cd60f$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $997a9c03857cd60f$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $997a9c03857cd60f$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $997a9c03857cd60f$var$sanitizeURL(url) {
    return $997a9c03857cd60f$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $997a9c03857cd60f$var$noop$1() {}
var $997a9c03857cd60f$var$currentReplayingEvent = null;
function $997a9c03857cd60f$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $997a9c03857cd60f$var$restoreTarget = null, $997a9c03857cd60f$var$restoreQueue = null;
function $997a9c03857cd60f$var$restoreStateOfTarget(target) {
    var internalInstance = $997a9c03857cd60f$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$997a9c03857cd60f$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $997a9c03857cd60f$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$997a9c03857cd60f$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(90));
                            $997a9c03857cd60f$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $997a9c03857cd60f$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $997a9c03857cd60f$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $997a9c03857cd60f$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $997a9c03857cd60f$var$isInsideEventHandler = !1;
function $997a9c03857cd60f$var$batchedUpdates$1(fn, a, b) {
    if ($997a9c03857cd60f$var$isInsideEventHandler) return fn(a, b);
    $997a9c03857cd60f$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($997a9c03857cd60f$var$isInsideEventHandler = !1, null !== $997a9c03857cd60f$var$restoreTarget || null !== $997a9c03857cd60f$var$restoreQueue) {
            if ($997a9c03857cd60f$var$flushSyncWork$1(), $997a9c03857cd60f$var$restoreTarget && (a = $997a9c03857cd60f$var$restoreTarget, fn = $997a9c03857cd60f$var$restoreQueue, $997a9c03857cd60f$var$restoreQueue = $997a9c03857cd60f$var$restoreTarget = null, $997a9c03857cd60f$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$997a9c03857cd60f$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $997a9c03857cd60f$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$997a9c03857cd60f$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $997a9c03857cd60f$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $997a9c03857cd60f$var$passiveBrowserEventsSupported = !1;
if ($997a9c03857cd60f$var$canUseDOM) try {
    var $997a9c03857cd60f$var$options = {};
    Object.defineProperty($997a9c03857cd60f$var$options, "passive", {
        get: function() {
            $997a9c03857cd60f$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $997a9c03857cd60f$var$options, $997a9c03857cd60f$var$options);
    window.removeEventListener("test", $997a9c03857cd60f$var$options, $997a9c03857cd60f$var$options);
} catch (e) {
    $997a9c03857cd60f$var$passiveBrowserEventsSupported = !1;
}
var $997a9c03857cd60f$var$root = null, $997a9c03857cd60f$var$startText = null, $997a9c03857cd60f$var$fallbackText = null;
function $997a9c03857cd60f$var$getData() {
    if ($997a9c03857cd60f$var$fallbackText) return $997a9c03857cd60f$var$fallbackText;
    var start, startValue = $997a9c03857cd60f$var$startText, startLength = startValue.length, end, endValue = "value" in $997a9c03857cd60f$var$root ? $997a9c03857cd60f$var$root.value : $997a9c03857cd60f$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $997a9c03857cd60f$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $997a9c03857cd60f$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $997a9c03857cd60f$var$functionThatReturnsTrue() {
    return !0;
}
function $997a9c03857cd60f$var$functionThatReturnsFalse() {
    return !1;
}
function $997a9c03857cd60f$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $997a9c03857cd60f$var$functionThatReturnsTrue : $997a9c03857cd60f$var$functionThatReturnsFalse;
        this.isPropagationStopped = $997a9c03857cd60f$var$functionThatReturnsFalse;
        return this;
    }
    $997a9c03857cd60f$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $997a9c03857cd60f$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $997a9c03857cd60f$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $997a9c03857cd60f$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $997a9c03857cd60f$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $997a9c03857cd60f$var$SyntheticEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$EventInterface), $997a9c03857cd60f$var$UIEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$EventInterface, {
    view: 0,
    detail: 0
}), $997a9c03857cd60f$var$SyntheticUIEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$UIEventInterface), $997a9c03857cd60f$var$lastMovementX, $997a9c03857cd60f$var$lastMovementY, $997a9c03857cd60f$var$lastMouseEvent, $997a9c03857cd60f$var$MouseEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $997a9c03857cd60f$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $997a9c03857cd60f$var$lastMouseEvent && ($997a9c03857cd60f$var$lastMouseEvent && "mousemove" === event.type ? ($997a9c03857cd60f$var$lastMovementX = event.screenX - $997a9c03857cd60f$var$lastMouseEvent.screenX, $997a9c03857cd60f$var$lastMovementY = event.screenY - $997a9c03857cd60f$var$lastMouseEvent.screenY) : $997a9c03857cd60f$var$lastMovementY = $997a9c03857cd60f$var$lastMovementX = 0, $997a9c03857cd60f$var$lastMouseEvent = event);
        return $997a9c03857cd60f$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $997a9c03857cd60f$var$lastMovementY;
    }
}), $997a9c03857cd60f$var$SyntheticMouseEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$MouseEventInterface), $997a9c03857cd60f$var$DragEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$MouseEventInterface, {
    dataTransfer: 0
}), $997a9c03857cd60f$var$SyntheticDragEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$DragEventInterface), $997a9c03857cd60f$var$FocusEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$UIEventInterface, {
    relatedTarget: 0
}), $997a9c03857cd60f$var$SyntheticFocusEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$FocusEventInterface), $997a9c03857cd60f$var$AnimationEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $997a9c03857cd60f$var$SyntheticAnimationEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$AnimationEventInterface), $997a9c03857cd60f$var$ClipboardEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $997a9c03857cd60f$var$SyntheticClipboardEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$ClipboardEventInterface), $997a9c03857cd60f$var$CompositionEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$EventInterface, {
    data: 0
}), $997a9c03857cd60f$var$SyntheticCompositionEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$CompositionEventInterface), $997a9c03857cd60f$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $997a9c03857cd60f$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $997a9c03857cd60f$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $997a9c03857cd60f$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $997a9c03857cd60f$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $997a9c03857cd60f$var$getEventModifierState() {
    return $997a9c03857cd60f$var$modifierStateGetter;
}
var $997a9c03857cd60f$var$KeyboardEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $997a9c03857cd60f$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $997a9c03857cd60f$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $997a9c03857cd60f$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $997a9c03857cd60f$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $997a9c03857cd60f$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $997a9c03857cd60f$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $997a9c03857cd60f$var$SyntheticKeyboardEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$KeyboardEventInterface), $997a9c03857cd60f$var$PointerEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $997a9c03857cd60f$var$SyntheticPointerEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$PointerEventInterface), $997a9c03857cd60f$var$TouchEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $997a9c03857cd60f$var$getEventModifierState
}), $997a9c03857cd60f$var$SyntheticTouchEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$TouchEventInterface), $997a9c03857cd60f$var$TransitionEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $997a9c03857cd60f$var$SyntheticTransitionEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$TransitionEventInterface), $997a9c03857cd60f$var$WheelEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $997a9c03857cd60f$var$SyntheticWheelEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$WheelEventInterface), $997a9c03857cd60f$var$ToggleEventInterface = $997a9c03857cd60f$var$assign({}, $997a9c03857cd60f$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $997a9c03857cd60f$var$SyntheticToggleEvent = $997a9c03857cd60f$var$createSyntheticEvent($997a9c03857cd60f$var$ToggleEventInterface), $997a9c03857cd60f$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $997a9c03857cd60f$var$canUseCompositionEvent = $997a9c03857cd60f$var$canUseDOM && "CompositionEvent" in window, $997a9c03857cd60f$var$documentMode = null;
$997a9c03857cd60f$var$canUseDOM && "documentMode" in document && ($997a9c03857cd60f$var$documentMode = document.documentMode);
var $997a9c03857cd60f$var$canUseTextInputEvent = $997a9c03857cd60f$var$canUseDOM && "TextEvent" in window && !$997a9c03857cd60f$var$documentMode, $997a9c03857cd60f$var$useFallbackCompositionData = $997a9c03857cd60f$var$canUseDOM && (!$997a9c03857cd60f$var$canUseCompositionEvent || $997a9c03857cd60f$var$documentMode && 8 < $997a9c03857cd60f$var$documentMode && 11 >= $997a9c03857cd60f$var$documentMode), $997a9c03857cd60f$var$SPACEBAR_CHAR = String.fromCharCode(32), $997a9c03857cd60f$var$hasSpaceKeypress = !1;
function $997a9c03857cd60f$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $997a9c03857cd60f$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $997a9c03857cd60f$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $997a9c03857cd60f$var$isComposing = !1;
function $997a9c03857cd60f$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $997a9c03857cd60f$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $997a9c03857cd60f$var$hasSpaceKeypress = !0;
            return $997a9c03857cd60f$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $997a9c03857cd60f$var$SPACEBAR_CHAR && $997a9c03857cd60f$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $997a9c03857cd60f$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($997a9c03857cd60f$var$isComposing) return "compositionend" === domEventName || !$997a9c03857cd60f$var$canUseCompositionEvent && $997a9c03857cd60f$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $997a9c03857cd60f$var$getData(), $997a9c03857cd60f$var$fallbackText = $997a9c03857cd60f$var$startText = $997a9c03857cd60f$var$root = null, $997a9c03857cd60f$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $997a9c03857cd60f$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $997a9c03857cd60f$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $997a9c03857cd60f$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$997a9c03857cd60f$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $997a9c03857cd60f$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $997a9c03857cd60f$var$restoreTarget ? $997a9c03857cd60f$var$restoreQueue ? $997a9c03857cd60f$var$restoreQueue.push(target) : $997a9c03857cd60f$var$restoreQueue = [
        target
    ] : $997a9c03857cd60f$var$restoreTarget = target;
    inst = $997a9c03857cd60f$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $997a9c03857cd60f$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $997a9c03857cd60f$var$activeElement$1 = null, $997a9c03857cd60f$var$activeElementInst$1 = null;
function $997a9c03857cd60f$var$runEventInBatch(dispatchQueue) {
    $997a9c03857cd60f$var$processDispatchQueue(dispatchQueue, 0);
}
function $997a9c03857cd60f$var$getInstIfValueChanged(targetInst) {
    var targetNode = $997a9c03857cd60f$var$getNodeFromInstance(targetInst);
    if ($997a9c03857cd60f$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $997a9c03857cd60f$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $997a9c03857cd60f$var$isInputEventSupported = !1;
if ($997a9c03857cd60f$var$canUseDOM) {
    var $997a9c03857cd60f$var$JSCompiler_inline_result$jscomp$286;
    if ($997a9c03857cd60f$var$canUseDOM) {
        var $997a9c03857cd60f$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$997a9c03857cd60f$var$isSupported$jscomp$inline_427) {
            var $997a9c03857cd60f$var$element$jscomp$inline_428 = document.createElement("div");
            $997a9c03857cd60f$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $997a9c03857cd60f$var$isSupported$jscomp$inline_427 = "function" === typeof $997a9c03857cd60f$var$element$jscomp$inline_428.oninput;
        }
        $997a9c03857cd60f$var$JSCompiler_inline_result$jscomp$286 = $997a9c03857cd60f$var$isSupported$jscomp$inline_427;
    } else $997a9c03857cd60f$var$JSCompiler_inline_result$jscomp$286 = !1;
    $997a9c03857cd60f$var$isInputEventSupported = $997a9c03857cd60f$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $997a9c03857cd60f$var$stopWatchingForValueChange() {
    $997a9c03857cd60f$var$activeElement$1 && ($997a9c03857cd60f$var$activeElement$1.detachEvent("onpropertychange", $997a9c03857cd60f$var$handlePropertyChange), $997a9c03857cd60f$var$activeElementInst$1 = $997a9c03857cd60f$var$activeElement$1 = null);
}
function $997a9c03857cd60f$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $997a9c03857cd60f$var$getInstIfValueChanged($997a9c03857cd60f$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $997a9c03857cd60f$var$createAndAccumulateChangeEvent(dispatchQueue, $997a9c03857cd60f$var$activeElementInst$1, nativeEvent, $997a9c03857cd60f$var$getEventTarget(nativeEvent));
        $997a9c03857cd60f$var$batchedUpdates$1($997a9c03857cd60f$var$runEventInBatch, dispatchQueue);
    }
}
function $997a9c03857cd60f$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($997a9c03857cd60f$var$stopWatchingForValueChange(), $997a9c03857cd60f$var$activeElement$1 = target, $997a9c03857cd60f$var$activeElementInst$1 = targetInst, $997a9c03857cd60f$var$activeElement$1.attachEvent("onpropertychange", $997a9c03857cd60f$var$handlePropertyChange)) : "focusout" === domEventName && $997a9c03857cd60f$var$stopWatchingForValueChange();
}
function $997a9c03857cd60f$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $997a9c03857cd60f$var$getInstIfValueChanged($997a9c03857cd60f$var$activeElementInst$1);
}
function $997a9c03857cd60f$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $997a9c03857cd60f$var$getInstIfValueChanged(targetInst);
}
function $997a9c03857cd60f$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $997a9c03857cd60f$var$getInstIfValueChanged(targetInst);
}
function $997a9c03857cd60f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $997a9c03857cd60f$var$objectIs = "function" === typeof Object.is ? Object.is : $997a9c03857cd60f$var$is;
function $997a9c03857cd60f$var$shallowEqual(objA, objB) {
    if ($997a9c03857cd60f$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$997a9c03857cd60f$var$hasOwnProperty.call(objB, currentKey) || !$997a9c03857cd60f$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $997a9c03857cd60f$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $997a9c03857cd60f$var$getNodeForCharacterOffset(root, offset) {
    var node = $997a9c03857cd60f$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $997a9c03857cd60f$var$getLeafNode(node);
    }
}
function $997a9c03857cd60f$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $997a9c03857cd60f$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $997a9c03857cd60f$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $997a9c03857cd60f$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $997a9c03857cd60f$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $997a9c03857cd60f$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $997a9c03857cd60f$var$skipSelectionChangeEvent = $997a9c03857cd60f$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $997a9c03857cd60f$var$activeElement = null, $997a9c03857cd60f$var$activeElementInst = null, $997a9c03857cd60f$var$lastSelection = null, $997a9c03857cd60f$var$mouseDown = !1;
function $997a9c03857cd60f$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $997a9c03857cd60f$var$mouseDown || null == $997a9c03857cd60f$var$activeElement || $997a9c03857cd60f$var$activeElement !== $997a9c03857cd60f$var$getActiveElement(doc) || (doc = $997a9c03857cd60f$var$activeElement, "selectionStart" in doc && $997a9c03857cd60f$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $997a9c03857cd60f$var$lastSelection && $997a9c03857cd60f$var$shallowEqual($997a9c03857cd60f$var$lastSelection, doc) || ($997a9c03857cd60f$var$lastSelection = doc, doc = $997a9c03857cd60f$var$accumulateTwoPhaseListeners($997a9c03857cd60f$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $997a9c03857cd60f$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $997a9c03857cd60f$var$activeElement)));
}
function $997a9c03857cd60f$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $997a9c03857cd60f$var$vendorPrefixes = {
    animationend: $997a9c03857cd60f$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $997a9c03857cd60f$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $997a9c03857cd60f$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $997a9c03857cd60f$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $997a9c03857cd60f$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $997a9c03857cd60f$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $997a9c03857cd60f$var$makePrefixMap("Transition", "TransitionEnd")
}, $997a9c03857cd60f$var$prefixedEventNames = {}, $997a9c03857cd60f$var$style = {};
$997a9c03857cd60f$var$canUseDOM && ($997a9c03857cd60f$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $997a9c03857cd60f$var$vendorPrefixes.animationend.animation, delete $997a9c03857cd60f$var$vendorPrefixes.animationiteration.animation, delete $997a9c03857cd60f$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $997a9c03857cd60f$var$vendorPrefixes.transitionend.transition);
function $997a9c03857cd60f$var$getVendorPrefixedEventName(eventName) {
    if ($997a9c03857cd60f$var$prefixedEventNames[eventName]) return $997a9c03857cd60f$var$prefixedEventNames[eventName];
    if (!$997a9c03857cd60f$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $997a9c03857cd60f$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $997a9c03857cd60f$var$style) return $997a9c03857cd60f$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $997a9c03857cd60f$var$ANIMATION_END = $997a9c03857cd60f$var$getVendorPrefixedEventName("animationend"), $997a9c03857cd60f$var$ANIMATION_ITERATION = $997a9c03857cd60f$var$getVendorPrefixedEventName("animationiteration"), $997a9c03857cd60f$var$ANIMATION_START = $997a9c03857cd60f$var$getVendorPrefixedEventName("animationstart"), $997a9c03857cd60f$var$TRANSITION_RUN = $997a9c03857cd60f$var$getVendorPrefixedEventName("transitionrun"), $997a9c03857cd60f$var$TRANSITION_START = $997a9c03857cd60f$var$getVendorPrefixedEventName("transitionstart"), $997a9c03857cd60f$var$TRANSITION_CANCEL = $997a9c03857cd60f$var$getVendorPrefixedEventName("transitioncancel"), $997a9c03857cd60f$var$TRANSITION_END = $997a9c03857cd60f$var$getVendorPrefixedEventName("transitionend"), $997a9c03857cd60f$var$topLevelEventsToReactNames = new Map(), $997a9c03857cd60f$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$997a9c03857cd60f$var$simpleEventPluginEvents.push("scrollEnd");
function $997a9c03857cd60f$var$registerSimpleEvent(domEventName, reactName) {
    $997a9c03857cd60f$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $997a9c03857cd60f$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $997a9c03857cd60f$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $997a9c03857cd60f$var$concurrentQueues = [], $997a9c03857cd60f$var$concurrentQueuesIndex = 0, $997a9c03857cd60f$var$concurrentlyUpdatedLanes = 0;
function $997a9c03857cd60f$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $997a9c03857cd60f$var$concurrentQueuesIndex, i = $997a9c03857cd60f$var$concurrentlyUpdatedLanes = $997a9c03857cd60f$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $997a9c03857cd60f$var$concurrentQueues[i];
        $997a9c03857cd60f$var$concurrentQueues[i++] = null;
        var queue = $997a9c03857cd60f$var$concurrentQueues[i];
        $997a9c03857cd60f$var$concurrentQueues[i++] = null;
        var update = $997a9c03857cd60f$var$concurrentQueues[i];
        $997a9c03857cd60f$var$concurrentQueues[i++] = null;
        var lane = $997a9c03857cd60f$var$concurrentQueues[i];
        $997a9c03857cd60f$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $997a9c03857cd60f$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $997a9c03857cd60f$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $997a9c03857cd60f$var$concurrentQueues[$997a9c03857cd60f$var$concurrentQueuesIndex++] = fiber;
    $997a9c03857cd60f$var$concurrentQueues[$997a9c03857cd60f$var$concurrentQueuesIndex++] = queue;
    $997a9c03857cd60f$var$concurrentQueues[$997a9c03857cd60f$var$concurrentQueuesIndex++] = update;
    $997a9c03857cd60f$var$concurrentQueues[$997a9c03857cd60f$var$concurrentQueuesIndex++] = lane;
    $997a9c03857cd60f$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $997a9c03857cd60f$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $997a9c03857cd60f$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $997a9c03857cd60f$var$getRootForUpdatedFiber(fiber);
}
function $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $997a9c03857cd60f$var$enqueueUpdate$1(fiber, null, null, lane);
    return $997a9c03857cd60f$var$getRootForUpdatedFiber(fiber);
}
function $997a9c03857cd60f$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $997a9c03857cd60f$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $997a9c03857cd60f$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $997a9c03857cd60f$var$nestedUpdateCount) throw $997a9c03857cd60f$var$nestedUpdateCount = 0, $997a9c03857cd60f$var$rootWithNestedUpdates = null, Error($997a9c03857cd60f$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $997a9c03857cd60f$var$emptyContextObject = {};
function $997a9c03857cd60f$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $997a9c03857cd60f$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $997a9c03857cd60f$var$FiberNode(tag, pendingProps, key, mode);
}
function $997a9c03857cd60f$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $997a9c03857cd60f$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $997a9c03857cd60f$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $997a9c03857cd60f$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $997a9c03857cd60f$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $997a9c03857cd60f$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $997a9c03857cd60f$var$isHostHoistableType(type, pendingProps, $997a9c03857cd60f$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $997a9c03857cd60f$var$REACT_ACTIVITY_TYPE:
            return type = $997a9c03857cd60f$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $997a9c03857cd60f$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE:
            return $997a9c03857cd60f$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $997a9c03857cd60f$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $997a9c03857cd60f$var$REACT_PROFILER_TYPE:
            return type = $997a9c03857cd60f$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $997a9c03857cd60f$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $997a9c03857cd60f$var$REACT_SUSPENSE_TYPE:
            return type = $997a9c03857cd60f$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $997a9c03857cd60f$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $997a9c03857cd60f$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $997a9c03857cd60f$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $997a9c03857cd60f$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $997a9c03857cd60f$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $997a9c03857cd60f$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $997a9c03857cd60f$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $997a9c03857cd60f$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $997a9c03857cd60f$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($997a9c03857cd60f$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $997a9c03857cd60f$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $997a9c03857cd60f$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $997a9c03857cd60f$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $997a9c03857cd60f$var$createFiberFromText(content, mode, lanes) {
    content = $997a9c03857cd60f$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $997a9c03857cd60f$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $997a9c03857cd60f$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $997a9c03857cd60f$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $997a9c03857cd60f$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $997a9c03857cd60f$var$CapturedStacks = new WeakMap();
function $997a9c03857cd60f$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $997a9c03857cd60f$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $997a9c03857cd60f$var$getStackByFiberInDevAndProd(source)
        };
        $997a9c03857cd60f$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $997a9c03857cd60f$var$getStackByFiberInDevAndProd(source)
    };
}
var $997a9c03857cd60f$var$forkStack = [], $997a9c03857cd60f$var$forkStackIndex = 0, $997a9c03857cd60f$var$treeForkProvider = null, $997a9c03857cd60f$var$treeForkCount = 0, $997a9c03857cd60f$var$idStack = [], $997a9c03857cd60f$var$idStackIndex = 0, $997a9c03857cd60f$var$treeContextProvider = null, $997a9c03857cd60f$var$treeContextId = 1, $997a9c03857cd60f$var$treeContextOverflow = "";
function $997a9c03857cd60f$var$pushTreeFork(workInProgress, totalChildren) {
    $997a9c03857cd60f$var$forkStack[$997a9c03857cd60f$var$forkStackIndex++] = $997a9c03857cd60f$var$treeForkCount;
    $997a9c03857cd60f$var$forkStack[$997a9c03857cd60f$var$forkStackIndex++] = $997a9c03857cd60f$var$treeForkProvider;
    $997a9c03857cd60f$var$treeForkProvider = workInProgress;
    $997a9c03857cd60f$var$treeForkCount = totalChildren;
}
function $997a9c03857cd60f$var$pushTreeId(workInProgress, totalChildren, index) {
    $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex++] = $997a9c03857cd60f$var$treeContextId;
    $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex++] = $997a9c03857cd60f$var$treeContextOverflow;
    $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex++] = $997a9c03857cd60f$var$treeContextProvider;
    $997a9c03857cd60f$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $997a9c03857cd60f$var$treeContextId;
    workInProgress = $997a9c03857cd60f$var$treeContextOverflow;
    var baseLength = 32 - $997a9c03857cd60f$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $997a9c03857cd60f$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $997a9c03857cd60f$var$treeContextId = 1 << 32 - $997a9c03857cd60f$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $997a9c03857cd60f$var$treeContextOverflow = length + workInProgress;
    } else $997a9c03857cd60f$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $997a9c03857cd60f$var$treeContextOverflow = workInProgress;
}
function $997a9c03857cd60f$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($997a9c03857cd60f$var$pushTreeFork(workInProgress, 1), $997a9c03857cd60f$var$pushTreeId(workInProgress, 1, 0));
}
function $997a9c03857cd60f$var$popTreeContext(workInProgress) {
    for(; workInProgress === $997a9c03857cd60f$var$treeForkProvider;)$997a9c03857cd60f$var$treeForkProvider = $997a9c03857cd60f$var$forkStack[--$997a9c03857cd60f$var$forkStackIndex], $997a9c03857cd60f$var$forkStack[$997a9c03857cd60f$var$forkStackIndex] = null, $997a9c03857cd60f$var$treeForkCount = $997a9c03857cd60f$var$forkStack[--$997a9c03857cd60f$var$forkStackIndex], $997a9c03857cd60f$var$forkStack[$997a9c03857cd60f$var$forkStackIndex] = null;
    for(; workInProgress === $997a9c03857cd60f$var$treeContextProvider;)$997a9c03857cd60f$var$treeContextProvider = $997a9c03857cd60f$var$idStack[--$997a9c03857cd60f$var$idStackIndex], $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex] = null, $997a9c03857cd60f$var$treeContextOverflow = $997a9c03857cd60f$var$idStack[--$997a9c03857cd60f$var$idStackIndex], $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex] = null, $997a9c03857cd60f$var$treeContextId = $997a9c03857cd60f$var$idStack[--$997a9c03857cd60f$var$idStackIndex], $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex] = null;
}
function $997a9c03857cd60f$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex++] = $997a9c03857cd60f$var$treeContextId;
    $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex++] = $997a9c03857cd60f$var$treeContextOverflow;
    $997a9c03857cd60f$var$idStack[$997a9c03857cd60f$var$idStackIndex++] = $997a9c03857cd60f$var$treeContextProvider;
    $997a9c03857cd60f$var$treeContextId = suspendedContext.id;
    $997a9c03857cd60f$var$treeContextOverflow = suspendedContext.overflow;
    $997a9c03857cd60f$var$treeContextProvider = workInProgress;
}
var $997a9c03857cd60f$var$hydrationParentFiber = null, $997a9c03857cd60f$var$nextHydratableInstance = null, $997a9c03857cd60f$var$isHydrating = !1, $997a9c03857cd60f$var$hydrationErrors = null, $997a9c03857cd60f$var$rootOrSingletonContext = !1, $997a9c03857cd60f$var$HydrationMismatchException = Error($997a9c03857cd60f$var$formatProdErrorMessage(519));
function $997a9c03857cd60f$var$throwOnHydrationMismatch(fiber) {
    var error = Error($997a9c03857cd60f$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $997a9c03857cd60f$var$queueHydrationError($997a9c03857cd60f$var$createCapturedValueAtFiber(error, fiber));
    throw $997a9c03857cd60f$var$HydrationMismatchException;
}
function $997a9c03857cd60f$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$997a9c03857cd60f$var$internalInstanceKey] = fiber;
    instance[$997a9c03857cd60f$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("cancel", instance);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $997a9c03857cd60f$var$mediaEventTypes.length; type++)$997a9c03857cd60f$var$listenToNonDelegatedEvent($997a9c03857cd60f$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("error", instance);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("invalid", instance);
            $997a9c03857cd60f$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("invalid", instance), $997a9c03857cd60f$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $997a9c03857cd60f$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($997a9c03857cd60f$var$listenToNonDelegatedEvent("beforetoggle", instance), $997a9c03857cd60f$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $997a9c03857cd60f$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $997a9c03857cd60f$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $997a9c03857cd60f$var$noop$1), instance = !0) : instance = !1;
    instance || $997a9c03857cd60f$var$throwOnHydrationMismatch(fiber, !0);
}
function $997a9c03857cd60f$var$popToNextHostParent(fiber) {
    for($997a9c03857cd60f$var$hydrationParentFiber = fiber.return; $997a9c03857cd60f$var$hydrationParentFiber;)switch($997a9c03857cd60f$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $997a9c03857cd60f$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $997a9c03857cd60f$var$rootOrSingletonContext = !0;
            return;
        default:
            $997a9c03857cd60f$var$hydrationParentFiber = $997a9c03857cd60f$var$hydrationParentFiber.return;
    }
}
function $997a9c03857cd60f$var$popHydrationState(fiber) {
    if (fiber !== $997a9c03857cd60f$var$hydrationParentFiber) return !1;
    if (!$997a9c03857cd60f$var$isHydrating) return $997a9c03857cd60f$var$popToNextHostParent(fiber), $997a9c03857cd60f$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $997a9c03857cd60f$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $997a9c03857cd60f$var$nextHydratableInstance && $997a9c03857cd60f$var$throwOnHydrationMismatch(fiber);
    $997a9c03857cd60f$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(317));
        $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(317));
        $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $997a9c03857cd60f$var$nextHydratableInstance, $997a9c03857cd60f$var$isSingletonScope(fiber.type) ? (fiber = $997a9c03857cd60f$var$previousHydratableOnEnteringScopedSingleton, $997a9c03857cd60f$var$previousHydratableOnEnteringScopedSingleton = null, $997a9c03857cd60f$var$nextHydratableInstance = fiber) : $997a9c03857cd60f$var$nextHydratableInstance = tag) : $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$hydrationParentFiber ? $997a9c03857cd60f$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $997a9c03857cd60f$var$resetHydrationState() {
    $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$hydrationParentFiber = null;
    $997a9c03857cd60f$var$isHydrating = !1;
}
function $997a9c03857cd60f$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $997a9c03857cd60f$var$hydrationErrors;
    null !== queuedErrors && (null === $997a9c03857cd60f$var$workInProgressRootRecoverableErrors ? $997a9c03857cd60f$var$workInProgressRootRecoverableErrors = queuedErrors : $997a9c03857cd60f$var$workInProgressRootRecoverableErrors.push.apply($997a9c03857cd60f$var$workInProgressRootRecoverableErrors, queuedErrors), $997a9c03857cd60f$var$hydrationErrors = null);
    return queuedErrors;
}
function $997a9c03857cd60f$var$queueHydrationError(error) {
    null === $997a9c03857cd60f$var$hydrationErrors ? $997a9c03857cd60f$var$hydrationErrors = [
        error
    ] : $997a9c03857cd60f$var$hydrationErrors.push(error);
}
var $997a9c03857cd60f$var$valueCursor = $997a9c03857cd60f$var$createCursor(null), $997a9c03857cd60f$var$currentlyRenderingFiber$1 = null, $997a9c03857cd60f$var$lastContextDependency = null;
function $997a9c03857cd60f$var$pushProvider(providerFiber, context, nextValue) {
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $997a9c03857cd60f$var$popProvider(context) {
    context._currentValue = $997a9c03857cd60f$var$valueCursor.current;
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$valueCursor);
}
function $997a9c03857cd60f$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $997a9c03857cd60f$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $997a9c03857cd60f$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $997a9c03857cd60f$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $997a9c03857cd60f$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $997a9c03857cd60f$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $997a9c03857cd60f$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($997a9c03857cd60f$var$HostTransitionContext) : current = [
                $997a9c03857cd60f$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $997a9c03857cd60f$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $997a9c03857cd60f$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$997a9c03857cd60f$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $997a9c03857cd60f$var$prepareToReadContext(workInProgress) {
    $997a9c03857cd60f$var$currentlyRenderingFiber$1 = workInProgress;
    $997a9c03857cd60f$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $997a9c03857cd60f$var$readContext(context) {
    return $997a9c03857cd60f$var$readContextForConsumer($997a9c03857cd60f$var$currentlyRenderingFiber$1, context);
}
function $997a9c03857cd60f$var$readContextDuringReconciliation(consumer, context) {
    null === $997a9c03857cd60f$var$currentlyRenderingFiber$1 && $997a9c03857cd60f$var$prepareToReadContext(consumer);
    return $997a9c03857cd60f$var$readContextForConsumer(consumer, context);
}
function $997a9c03857cd60f$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $997a9c03857cd60f$var$lastContextDependency) {
        if (null === consumer) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(308));
        $997a9c03857cd60f$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $997a9c03857cd60f$var$lastContextDependency = $997a9c03857cd60f$var$lastContextDependency.next = context;
    return value;
}
var $997a9c03857cd60f$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $997a9c03857cd60f$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $997a9c03857cd60f$var$NormalPriority = $bIbqH.unstable_NormalPriority, $997a9c03857cd60f$var$CacheContext = {
    $$typeof: $997a9c03857cd60f$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $997a9c03857cd60f$var$createCache() {
    return {
        controller: new $997a9c03857cd60f$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $997a9c03857cd60f$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $997a9c03857cd60f$var$scheduleCallback$2($997a9c03857cd60f$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $997a9c03857cd60f$var$currentEntangledListeners = null, $997a9c03857cd60f$var$currentEntangledPendingCount = 0, $997a9c03857cd60f$var$currentEntangledLane = 0, $997a9c03857cd60f$var$currentEntangledActionThenable = null;
function $997a9c03857cd60f$var$entangleAsyncAction(transition, thenable) {
    if (null === $997a9c03857cd60f$var$currentEntangledListeners) {
        var entangledListeners = $997a9c03857cd60f$var$currentEntangledListeners = [];
        $997a9c03857cd60f$var$currentEntangledPendingCount = 0;
        $997a9c03857cd60f$var$currentEntangledLane = $997a9c03857cd60f$var$requestTransitionLane();
        $997a9c03857cd60f$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $997a9c03857cd60f$var$currentEntangledPendingCount++;
    thenable.then($997a9c03857cd60f$var$pingEngtangledActionScope, $997a9c03857cd60f$var$pingEngtangledActionScope);
    return thenable;
}
function $997a9c03857cd60f$var$pingEngtangledActionScope() {
    if (0 === --$997a9c03857cd60f$var$currentEntangledPendingCount && null !== $997a9c03857cd60f$var$currentEntangledListeners) {
        null !== $997a9c03857cd60f$var$currentEntangledActionThenable && ($997a9c03857cd60f$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $997a9c03857cd60f$var$currentEntangledListeners;
        $997a9c03857cd60f$var$currentEntangledListeners = null;
        $997a9c03857cd60f$var$currentEntangledLane = 0;
        $997a9c03857cd60f$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $997a9c03857cd60f$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $997a9c03857cd60f$var$prevOnStartTransitionFinish = $997a9c03857cd60f$var$ReactSharedInternals.S;
$997a9c03857cd60f$var$ReactSharedInternals.S = function(transition, returnValue) {
    $997a9c03857cd60f$var$globalMostRecentTransitionTime = $997a9c03857cd60f$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $997a9c03857cd60f$var$entangleAsyncAction(transition, returnValue);
    null !== $997a9c03857cd60f$var$prevOnStartTransitionFinish && $997a9c03857cd60f$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $997a9c03857cd60f$var$resumedCache = $997a9c03857cd60f$var$createCursor(null);
function $997a9c03857cd60f$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $997a9c03857cd60f$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $997a9c03857cd60f$var$workInProgressRoot.pooledCache;
}
function $997a9c03857cd60f$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $997a9c03857cd60f$var$push($997a9c03857cd60f$var$resumedCache, $997a9c03857cd60f$var$resumedCache.current) : $997a9c03857cd60f$var$push($997a9c03857cd60f$var$resumedCache, prevCachePool.pool);
}
function $997a9c03857cd60f$var$getSuspendedCache() {
    var cacheFromPool = $997a9c03857cd60f$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $997a9c03857cd60f$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $997a9c03857cd60f$var$SuspenseException = Error($997a9c03857cd60f$var$formatProdErrorMessage(460)), $997a9c03857cd60f$var$SuspenseyCommitException = Error($997a9c03857cd60f$var$formatProdErrorMessage(474)), $997a9c03857cd60f$var$SuspenseActionException = Error($997a9c03857cd60f$var$formatProdErrorMessage(542)), $997a9c03857cd60f$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $997a9c03857cd60f$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $997a9c03857cd60f$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($997a9c03857cd60f$var$noop$1, $997a9c03857cd60f$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $997a9c03857cd60f$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($997a9c03857cd60f$var$noop$1, $997a9c03857cd60f$var$noop$1);
            else {
                thenableState = $997a9c03857cd60f$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $997a9c03857cd60f$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $997a9c03857cd60f$var$suspendedThenable = thenable;
            throw $997a9c03857cd60f$var$SuspenseException;
    }
}
function $997a9c03857cd60f$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $997a9c03857cd60f$var$suspendedThenable = x, $997a9c03857cd60f$var$SuspenseException;
        throw x;
    }
}
var $997a9c03857cd60f$var$suspendedThenable = null;
function $997a9c03857cd60f$var$getSuspendedThenable() {
    if (null === $997a9c03857cd60f$var$suspendedThenable) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(459));
    var thenable = $997a9c03857cd60f$var$suspendedThenable;
    $997a9c03857cd60f$var$suspendedThenable = null;
    return thenable;
}
function $997a9c03857cd60f$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $997a9c03857cd60f$var$SuspenseException || rejectedReason === $997a9c03857cd60f$var$SuspenseActionException) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(483));
}
var $997a9c03857cd60f$var$thenableState$1 = null, $997a9c03857cd60f$var$thenableIndexCounter$1 = 0;
function $997a9c03857cd60f$var$unwrapThenable(thenable) {
    var index = $997a9c03857cd60f$var$thenableIndexCounter$1;
    $997a9c03857cd60f$var$thenableIndexCounter$1 += 1;
    null === $997a9c03857cd60f$var$thenableState$1 && ($997a9c03857cd60f$var$thenableState$1 = []);
    return $997a9c03857cd60f$var$trackUsedThenable($997a9c03857cd60f$var$thenableState$1, thenable, index);
}
function $997a9c03857cd60f$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $997a9c03857cd60f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $997a9c03857cd60f$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $997a9c03857cd60f$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $997a9c03857cd60f$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $997a9c03857cd60f$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $997a9c03857cd60f$var$REACT_LAZY_TYPE && $997a9c03857cd60f$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $997a9c03857cd60f$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $997a9c03857cd60f$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $997a9c03857cd60f$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $997a9c03857cd60f$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $997a9c03857cd60f$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $997a9c03857cd60f$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $997a9c03857cd60f$var$REACT_ELEMENT_TYPE:
                    return lanes = $997a9c03857cd60f$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $997a9c03857cd60f$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $997a9c03857cd60f$var$REACT_PORTAL_TYPE:
                    return newChild = $997a9c03857cd60f$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $997a9c03857cd60f$var$REACT_LAZY_TYPE:
                    return newChild = $997a9c03857cd60f$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($997a9c03857cd60f$var$isArrayImpl(newChild) || $997a9c03857cd60f$var$getIteratorFn(newChild)) return newChild = $997a9c03857cd60f$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $997a9c03857cd60f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $997a9c03857cd60f$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $997a9c03857cd60f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $997a9c03857cd60f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $997a9c03857cd60f$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $997a9c03857cd60f$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $997a9c03857cd60f$var$REACT_LAZY_TYPE:
                    return newChild = $997a9c03857cd60f$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($997a9c03857cd60f$var$isArrayImpl(newChild) || $997a9c03857cd60f$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $997a9c03857cd60f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $997a9c03857cd60f$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $997a9c03857cd60f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $997a9c03857cd60f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $997a9c03857cd60f$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $997a9c03857cd60f$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $997a9c03857cd60f$var$REACT_LAZY_TYPE:
                    return newChild = $997a9c03857cd60f$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($997a9c03857cd60f$var$isArrayImpl(newChild) || $997a9c03857cd60f$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $997a9c03857cd60f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $997a9c03857cd60f$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $997a9c03857cd60f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $997a9c03857cd60f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $997a9c03857cd60f$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $997a9c03857cd60f$var$REACT_LAZY_TYPE && $997a9c03857cd60f$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $997a9c03857cd60f$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $997a9c03857cd60f$var$REACT_FRAGMENT_TYPE ? (lanes = $997a9c03857cd60f$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $997a9c03857cd60f$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $997a9c03857cd60f$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $997a9c03857cd60f$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $997a9c03857cd60f$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $997a9c03857cd60f$var$REACT_LAZY_TYPE:
                    return newChild = $997a9c03857cd60f$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($997a9c03857cd60f$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($997a9c03857cd60f$var$getIteratorFn(newChild)) {
                key = $997a9c03857cd60f$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $997a9c03857cd60f$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $997a9c03857cd60f$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $997a9c03857cd60f$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $997a9c03857cd60f$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $997a9c03857cd60f$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $997a9c03857cd60f$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $997a9c03857cd60f$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $997a9c03857cd60f$var$SuspenseException || x === $997a9c03857cd60f$var$SuspenseActionException) throw x;
            var fiber = $997a9c03857cd60f$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $997a9c03857cd60f$var$reconcileChildFibers = $997a9c03857cd60f$var$createChildReconciler(!0), $997a9c03857cd60f$var$mountChildFibers = $997a9c03857cd60f$var$createChildReconciler(!1), $997a9c03857cd60f$var$hasForceUpdate = !1;
function $997a9c03857cd60f$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $997a9c03857cd60f$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $997a9c03857cd60f$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $997a9c03857cd60f$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($997a9c03857cd60f$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $997a9c03857cd60f$var$getRootForUpdatedFiber(fiber);
        $997a9c03857cd60f$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $997a9c03857cd60f$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $997a9c03857cd60f$var$getRootForUpdatedFiber(fiber);
}
function $997a9c03857cd60f$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $997a9c03857cd60f$var$markRootEntangled(root, lane);
    }
}
function $997a9c03857cd60f$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $997a9c03857cd60f$var$didReadFromEntangledAsyncAction = !1;
function $997a9c03857cd60f$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($997a9c03857cd60f$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $997a9c03857cd60f$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $997a9c03857cd60f$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $997a9c03857cd60f$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $997a9c03857cd60f$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($997a9c03857cd60f$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $997a9c03857cd60f$var$currentEntangledLane && ($997a9c03857cd60f$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $997a9c03857cd60f$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $997a9c03857cd60f$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $997a9c03857cd60f$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $997a9c03857cd60f$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $997a9c03857cd60f$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$997a9c03857cd60f$var$callCallback(callbacks[updateQueue], context);
}
var $997a9c03857cd60f$var$currentTreeHiddenStackCursor = $997a9c03857cd60f$var$createCursor(null), $997a9c03857cd60f$var$prevEntangledRenderLanesCursor = $997a9c03857cd60f$var$createCursor(0);
function $997a9c03857cd60f$var$pushHiddenContext(fiber, context) {
    fiber = $997a9c03857cd60f$var$entangledRenderLanes;
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$prevEntangledRenderLanesCursor, fiber);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$currentTreeHiddenStackCursor, context);
    $997a9c03857cd60f$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $997a9c03857cd60f$var$reuseHiddenContextOnStack() {
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$prevEntangledRenderLanesCursor, $997a9c03857cd60f$var$entangledRenderLanes);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$currentTreeHiddenStackCursor, $997a9c03857cd60f$var$currentTreeHiddenStackCursor.current);
}
function $997a9c03857cd60f$var$popHiddenContext() {
    $997a9c03857cd60f$var$entangledRenderLanes = $997a9c03857cd60f$var$prevEntangledRenderLanesCursor.current;
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$currentTreeHiddenStackCursor);
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$prevEntangledRenderLanesCursor);
}
var $997a9c03857cd60f$var$suspenseHandlerStackCursor = $997a9c03857cd60f$var$createCursor(null), $997a9c03857cd60f$var$shellBoundary = null;
function $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, $997a9c03857cd60f$var$suspenseStackCursor.current & 1);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseHandlerStackCursor, handler);
    null === $997a9c03857cd60f$var$shellBoundary && (null === current || null !== $997a9c03857cd60f$var$currentTreeHiddenStackCursor.current ? $997a9c03857cd60f$var$shellBoundary = handler : null !== current.memoizedState && ($997a9c03857cd60f$var$shellBoundary = handler));
}
function $997a9c03857cd60f$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, $997a9c03857cd60f$var$suspenseStackCursor.current);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseHandlerStackCursor, fiber);
    null === $997a9c03857cd60f$var$shellBoundary && ($997a9c03857cd60f$var$shellBoundary = fiber);
}
function $997a9c03857cd60f$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, $997a9c03857cd60f$var$suspenseStackCursor.current), $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseHandlerStackCursor, fiber), null === $997a9c03857cd60f$var$shellBoundary && ($997a9c03857cd60f$var$shellBoundary = fiber)) : $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(fiber);
}
function $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack() {
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, $997a9c03857cd60f$var$suspenseStackCursor.current);
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseHandlerStackCursor, $997a9c03857cd60f$var$suspenseHandlerStackCursor.current);
}
function $997a9c03857cd60f$var$popSuspenseHandler(fiber) {
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$suspenseHandlerStackCursor);
    $997a9c03857cd60f$var$shellBoundary === fiber && ($997a9c03857cd60f$var$shellBoundary = null);
    $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$suspenseStackCursor);
}
var $997a9c03857cd60f$var$suspenseStackCursor = $997a9c03857cd60f$var$createCursor(0);
function $997a9c03857cd60f$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $997a9c03857cd60f$var$isSuspenseInstancePending(state) || $997a9c03857cd60f$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $997a9c03857cd60f$var$renderLanes = 0, $997a9c03857cd60f$var$currentlyRenderingFiber = null, $997a9c03857cd60f$var$currentHook = null, $997a9c03857cd60f$var$workInProgressHook = null, $997a9c03857cd60f$var$didScheduleRenderPhaseUpdate = !1, $997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $997a9c03857cd60f$var$localIdCounter = 0, $997a9c03857cd60f$var$thenableIndexCounter = 0, $997a9c03857cd60f$var$thenableState = null, $997a9c03857cd60f$var$globalClientIdCounter = 0;
function $997a9c03857cd60f$var$throwInvalidHookError() {
    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(321));
}
function $997a9c03857cd60f$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$997a9c03857cd60f$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $997a9c03857cd60f$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $997a9c03857cd60f$var$renderLanes = nextRenderLanes;
    $997a9c03857cd60f$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $997a9c03857cd60f$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $997a9c03857cd60f$var$HooksDispatcherOnMount : $997a9c03857cd60f$var$HooksDispatcherOnUpdate;
    $997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $997a9c03857cd60f$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $997a9c03857cd60f$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $997a9c03857cd60f$var$finishRenderingHooks(current) {
    $997a9c03857cd60f$var$ReactSharedInternals.H = $997a9c03857cd60f$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $997a9c03857cd60f$var$currentHook && null !== $997a9c03857cd60f$var$currentHook.next;
    $997a9c03857cd60f$var$renderLanes = 0;
    $997a9c03857cd60f$var$workInProgressHook = $997a9c03857cd60f$var$currentHook = $997a9c03857cd60f$var$currentlyRenderingFiber = null;
    $997a9c03857cd60f$var$didScheduleRenderPhaseUpdate = !1;
    $997a9c03857cd60f$var$thenableIndexCounter = 0;
    $997a9c03857cd60f$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(300));
    null === current || $997a9c03857cd60f$var$didReceiveUpdate || (current = current.dependencies, null !== current && $997a9c03857cd60f$var$checkIfContextChanged(current) && ($997a9c03857cd60f$var$didReceiveUpdate = !0));
}
function $997a9c03857cd60f$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $997a9c03857cd60f$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass && ($997a9c03857cd60f$var$thenableState = null);
        $997a9c03857cd60f$var$thenableIndexCounter = 0;
        $997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $997a9c03857cd60f$var$workInProgressHook = $997a9c03857cd60f$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $997a9c03857cd60f$var$ReactSharedInternals.H = $997a9c03857cd60f$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $997a9c03857cd60f$var$TransitionAwareHostComponent() {
    var dispatcher = $997a9c03857cd60f$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $997a9c03857cd60f$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $997a9c03857cd60f$var$currentHook ? $997a9c03857cd60f$var$currentHook.memoizedState : null) !== dispatcher && ($997a9c03857cd60f$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $997a9c03857cd60f$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $997a9c03857cd60f$var$localIdCounter;
    $997a9c03857cd60f$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $997a9c03857cd60f$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $997a9c03857cd60f$var$resetHooksOnUnwind(workInProgress) {
    if ($997a9c03857cd60f$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $997a9c03857cd60f$var$didScheduleRenderPhaseUpdate = !1;
    }
    $997a9c03857cd60f$var$renderLanes = 0;
    $997a9c03857cd60f$var$workInProgressHook = $997a9c03857cd60f$var$currentHook = $997a9c03857cd60f$var$currentlyRenderingFiber = null;
    $997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $997a9c03857cd60f$var$thenableIndexCounter = $997a9c03857cd60f$var$localIdCounter = 0;
    $997a9c03857cd60f$var$thenableState = null;
}
function $997a9c03857cd60f$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $997a9c03857cd60f$var$workInProgressHook ? $997a9c03857cd60f$var$currentlyRenderingFiber.memoizedState = $997a9c03857cd60f$var$workInProgressHook = hook : $997a9c03857cd60f$var$workInProgressHook = $997a9c03857cd60f$var$workInProgressHook.next = hook;
    return $997a9c03857cd60f$var$workInProgressHook;
}
function $997a9c03857cd60f$var$updateWorkInProgressHook() {
    if (null === $997a9c03857cd60f$var$currentHook) {
        var nextCurrentHook = $997a9c03857cd60f$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $997a9c03857cd60f$var$currentHook.next;
    var nextWorkInProgressHook = null === $997a9c03857cd60f$var$workInProgressHook ? $997a9c03857cd60f$var$currentlyRenderingFiber.memoizedState : $997a9c03857cd60f$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $997a9c03857cd60f$var$workInProgressHook = nextWorkInProgressHook, $997a9c03857cd60f$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $997a9c03857cd60f$var$currentlyRenderingFiber.alternate) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(467));
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(310));
        }
        $997a9c03857cd60f$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $997a9c03857cd60f$var$currentHook.memoizedState,
            baseState: $997a9c03857cd60f$var$currentHook.baseState,
            baseQueue: $997a9c03857cd60f$var$currentHook.baseQueue,
            queue: $997a9c03857cd60f$var$currentHook.queue,
            next: null
        };
        null === $997a9c03857cd60f$var$workInProgressHook ? $997a9c03857cd60f$var$currentlyRenderingFiber.memoizedState = $997a9c03857cd60f$var$workInProgressHook = nextCurrentHook : $997a9c03857cd60f$var$workInProgressHook = $997a9c03857cd60f$var$workInProgressHook.next = nextCurrentHook;
    }
    return $997a9c03857cd60f$var$workInProgressHook;
}
function $997a9c03857cd60f$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $997a9c03857cd60f$var$useThenable(thenable) {
    var index = $997a9c03857cd60f$var$thenableIndexCounter;
    $997a9c03857cd60f$var$thenableIndexCounter += 1;
    null === $997a9c03857cd60f$var$thenableState && ($997a9c03857cd60f$var$thenableState = []);
    thenable = $997a9c03857cd60f$var$trackUsedThenable($997a9c03857cd60f$var$thenableState, thenable, index);
    index = $997a9c03857cd60f$var$currentlyRenderingFiber;
    null === (null === $997a9c03857cd60f$var$workInProgressHook ? index.memoizedState : $997a9c03857cd60f$var$workInProgressHook.next) && (index = index.alternate, $997a9c03857cd60f$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $997a9c03857cd60f$var$HooksDispatcherOnMount : $997a9c03857cd60f$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $997a9c03857cd60f$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $997a9c03857cd60f$var$useThenable(usable);
        if (usable.$$typeof === $997a9c03857cd60f$var$REACT_CONTEXT_TYPE) return $997a9c03857cd60f$var$readContext(usable);
    }
    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(438, String(usable)));
}
function $997a9c03857cd60f$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $997a9c03857cd60f$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $997a9c03857cd60f$var$createFunctionComponentUpdateQueue(), $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $997a9c03857cd60f$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $997a9c03857cd60f$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $997a9c03857cd60f$var$updateReducer(reducer) {
    var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    return $997a9c03857cd60f$var$updateReducerImpl(hook, $997a9c03857cd60f$var$currentHook, reducer);
}
function $997a9c03857cd60f$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($997a9c03857cd60f$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($997a9c03857cd60f$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $997a9c03857cd60f$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($997a9c03857cd60f$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $997a9c03857cd60f$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $997a9c03857cd60f$var$currentlyRenderingFiber.lanes |= revertLane, $997a9c03857cd60f$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $997a9c03857cd60f$var$currentlyRenderingFiber.lanes |= updateLane, $997a9c03857cd60f$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$997a9c03857cd60f$var$objectIs(pendingQueue, hook.memoizedState) && ($997a9c03857cd60f$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $997a9c03857cd60f$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $997a9c03857cd60f$var$rerenderReducer(reducer) {
    var hook = $997a9c03857cd60f$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $997a9c03857cd60f$var$objectIs(newState, hook.memoizedState) || ($997a9c03857cd60f$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $997a9c03857cd60f$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $997a9c03857cd60f$var$currentlyRenderingFiber, hook = $997a9c03857cd60f$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $997a9c03857cd60f$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$997a9c03857cd60f$var$objectIs(($997a9c03857cd60f$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $997a9c03857cd60f$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $997a9c03857cd60f$var$updateEffect($997a9c03857cd60f$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $997a9c03857cd60f$var$workInProgressHook && $997a9c03857cd60f$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $997a9c03857cd60f$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $997a9c03857cd60f$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $997a9c03857cd60f$var$workInProgressRoot) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($997a9c03857cd60f$var$renderLanes & 127) || $997a9c03857cd60f$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $997a9c03857cd60f$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $997a9c03857cd60f$var$createFunctionComponentUpdateQueue(), $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $997a9c03857cd60f$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $997a9c03857cd60f$var$checkIfSnapshotChanged(inst) && $997a9c03857cd60f$var$forceStoreRerender(fiber);
}
function $997a9c03857cd60f$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $997a9c03857cd60f$var$checkIfSnapshotChanged(inst) && $997a9c03857cd60f$var$forceStoreRerender(fiber);
    });
}
function $997a9c03857cd60f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$997a9c03857cd60f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $997a9c03857cd60f$var$forceStoreRerender(fiber) {
    var root = $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $997a9c03857cd60f$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $997a9c03857cd60f$var$mountStateImpl(initialState) {
    var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $997a9c03857cd60f$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $997a9c03857cd60f$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $997a9c03857cd60f$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $997a9c03857cd60f$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $997a9c03857cd60f$var$updateReducerImpl(hook, $997a9c03857cd60f$var$currentHook, "function" === typeof reducer ? reducer : $997a9c03857cd60f$var$basicStateReducer);
}
function $997a9c03857cd60f$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($997a9c03857cd60f$var$isRenderPhaseUpdate(fiber)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $997a9c03857cd60f$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $997a9c03857cd60f$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $997a9c03857cd60f$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $997a9c03857cd60f$var$ReactSharedInternals.T, currentTransition = {};
        $997a9c03857cd60f$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $997a9c03857cd60f$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $997a9c03857cd60f$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $997a9c03857cd60f$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $997a9c03857cd60f$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $997a9c03857cd60f$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $997a9c03857cd60f$var$onActionError(actionQueue, node, error$66);
    }
}
function $997a9c03857cd60f$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $997a9c03857cd60f$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $997a9c03857cd60f$var$onActionError(actionQueue, node, error);
    }) : $997a9c03857cd60f$var$onActionSuccess(actionQueue, node, returnValue);
}
function $997a9c03857cd60f$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $997a9c03857cd60f$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $997a9c03857cd60f$var$runActionStateAction(actionQueue, nextState)));
}
function $997a9c03857cd60f$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $997a9c03857cd60f$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $997a9c03857cd60f$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $997a9c03857cd60f$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $997a9c03857cd60f$var$mountActionState(action, initialStateProp) {
    if ($997a9c03857cd60f$var$isHydrating) {
        var ssrFormState = $997a9c03857cd60f$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $997a9c03857cd60f$var$currentlyRenderingFiber;
                if ($997a9c03857cd60f$var$isHydrating) {
                    if ($997a9c03857cd60f$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $997a9c03857cd60f$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $997a9c03857cd60f$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $997a9c03857cd60f$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $997a9c03857cd60f$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $997a9c03857cd60f$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $997a9c03857cd60f$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $997a9c03857cd60f$var$dispatchSetState.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $997a9c03857cd60f$var$mountStateImpl(!1);
    inRootOrSingleton = $997a9c03857cd60f$var$dispatchOptimisticSetState.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $997a9c03857cd60f$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $997a9c03857cd60f$var$dispatchActionState.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $997a9c03857cd60f$var$updateActionState(action) {
    var stateHook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    return $997a9c03857cd60f$var$updateActionStateImpl(stateHook, $997a9c03857cd60f$var$currentHook, action);
}
function $997a9c03857cd60f$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $997a9c03857cd60f$var$updateReducerImpl(stateHook, currentStateHook, $997a9c03857cd60f$var$actionStateReducer)[0];
    stateHook = $997a9c03857cd60f$var$updateReducer($997a9c03857cd60f$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $997a9c03857cd60f$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $997a9c03857cd60f$var$SuspenseException) throw $997a9c03857cd60f$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($997a9c03857cd60f$var$currentlyRenderingFiber.flags |= 2048, $997a9c03857cd60f$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $997a9c03857cd60f$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $997a9c03857cd60f$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $997a9c03857cd60f$var$rerenderActionState(action) {
    var stateHook = $997a9c03857cd60f$var$updateWorkInProgressHook(), currentStateHook = $997a9c03857cd60f$var$currentHook;
    if (null !== currentStateHook) return $997a9c03857cd60f$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $997a9c03857cd60f$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $997a9c03857cd60f$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $997a9c03857cd60f$var$createFunctionComponentUpdateQueue(), $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $997a9c03857cd60f$var$updateRef() {
    return $997a9c03857cd60f$var$updateWorkInProgressHook().memoizedState;
}
function $997a9c03857cd60f$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
    $997a9c03857cd60f$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $997a9c03857cd60f$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $997a9c03857cd60f$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $997a9c03857cd60f$var$currentHook && null !== deps && $997a9c03857cd60f$var$areHookInputsEqual(deps, $997a9c03857cd60f$var$currentHook.memoizedState.deps) ? hook.memoizedState = $997a9c03857cd60f$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($997a9c03857cd60f$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $997a9c03857cd60f$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $997a9c03857cd60f$var$mountEffect(create, deps) {
    $997a9c03857cd60f$var$mountEffectImpl(8390656, 8, create, deps);
}
function $997a9c03857cd60f$var$updateEffect(create, deps) {
    $997a9c03857cd60f$var$updateEffectImpl(2048, 8, create, deps);
}
function $997a9c03857cd60f$var$useEffectEventImpl(payload) {
    $997a9c03857cd60f$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $997a9c03857cd60f$var$createFunctionComponentUpdateQueue(), $997a9c03857cd60f$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $997a9c03857cd60f$var$updateEvent(callback) {
    var ref = $997a9c03857cd60f$var$updateWorkInProgressHook().memoizedState;
    $997a9c03857cd60f$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($997a9c03857cd60f$var$executionContext & 2)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $997a9c03857cd60f$var$updateInsertionEffect(create, deps) {
    return $997a9c03857cd60f$var$updateEffectImpl(4, 2, create, deps);
}
function $997a9c03857cd60f$var$updateLayoutEffect(create, deps) {
    return $997a9c03857cd60f$var$updateEffectImpl(4, 4, create, deps);
}
function $997a9c03857cd60f$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $997a9c03857cd60f$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $997a9c03857cd60f$var$updateEffectImpl(4, 4, $997a9c03857cd60f$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $997a9c03857cd60f$var$mountDebugValue() {}
function $997a9c03857cd60f$var$updateCallback(callback, deps) {
    var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $997a9c03857cd60f$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $997a9c03857cd60f$var$updateMemo(nextCreate, deps) {
    var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $997a9c03857cd60f$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $997a9c03857cd60f$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $997a9c03857cd60f$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $997a9c03857cd60f$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($997a9c03857cd60f$var$renderLanes & 1073741824) && 0 === ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $997a9c03857cd60f$var$requestDeferredLane();
    $997a9c03857cd60f$var$currentlyRenderingFiber.lanes |= hook;
    $997a9c03857cd60f$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $997a9c03857cd60f$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($997a9c03857cd60f$var$objectIs(value, prevValue)) return value;
    if (null !== $997a9c03857cd60f$var$currentTreeHiddenStackCursor.current) return hook = $997a9c03857cd60f$var$mountDeferredValueImpl(hook, value, initialValue), $997a9c03857cd60f$var$objectIs(hook, prevValue) || ($997a9c03857cd60f$var$didReceiveUpdate = !0), hook;
    if (0 === ($997a9c03857cd60f$var$renderLanes & 42) || 0 !== ($997a9c03857cd60f$var$renderLanes & 1073741824) && 0 === ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 261930)) return $997a9c03857cd60f$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $997a9c03857cd60f$var$requestDeferredLane();
    $997a9c03857cd60f$var$currentlyRenderingFiber.lanes |= hook;
    $997a9c03857cd60f$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $997a9c03857cd60f$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
    $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $997a9c03857cd60f$var$ReactSharedInternals.T, currentTransition = {};
    $997a9c03857cd60f$var$ReactSharedInternals.T = currentTransition;
    $997a9c03857cd60f$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $997a9c03857cd60f$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $997a9c03857cd60f$var$chainThenableValue(returnValue, finishedState);
            $997a9c03857cd60f$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $997a9c03857cd60f$var$requestUpdateLane(fiber));
        } else $997a9c03857cd60f$var$dispatchSetStateInternal(fiber, queue, finishedState, $997a9c03857cd60f$var$requestUpdateLane(fiber));
    } catch (error) {
        $997a9c03857cd60f$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $997a9c03857cd60f$var$requestUpdateLane());
    } finally{
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $997a9c03857cd60f$var$ReactSharedInternals.T = prevTransition;
    }
}
function $997a9c03857cd60f$var$noop() {}
function $997a9c03857cd60f$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(476));
    var queue = $997a9c03857cd60f$var$ensureFormComponentIsStateful(formFiber).queue;
    $997a9c03857cd60f$var$startTransition(formFiber, queue, pendingState, $997a9c03857cd60f$var$sharedNotPendingObject, null === action ? $997a9c03857cd60f$var$noop : function() {
        $997a9c03857cd60f$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $997a9c03857cd60f$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $997a9c03857cd60f$var$sharedNotPendingObject,
        baseState: $997a9c03857cd60f$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $997a9c03857cd60f$var$basicStateReducer,
            lastRenderedState: $997a9c03857cd60f$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $997a9c03857cd60f$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $997a9c03857cd60f$var$requestFormReset$1(formFiber) {
    var stateHook = $997a9c03857cd60f$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $997a9c03857cd60f$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $997a9c03857cd60f$var$requestUpdateLane());
}
function $997a9c03857cd60f$var$useHostTransitionStatus() {
    return $997a9c03857cd60f$var$readContext($997a9c03857cd60f$var$HostTransitionContext);
}
function $997a9c03857cd60f$var$updateId() {
    return $997a9c03857cd60f$var$updateWorkInProgressHook().memoizedState;
}
function $997a9c03857cd60f$var$updateRefresh() {
    return $997a9c03857cd60f$var$updateWorkInProgressHook().memoizedState;
}
function $997a9c03857cd60f$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $997a9c03857cd60f$var$requestUpdateLane();
                fiber = $997a9c03857cd60f$var$createUpdate(lane);
                var root$69 = $997a9c03857cd60f$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($997a9c03857cd60f$var$scheduleUpdateOnFiber(root$69, provider, lane), $997a9c03857cd60f$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $997a9c03857cd60f$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $997a9c03857cd60f$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $997a9c03857cd60f$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $997a9c03857cd60f$var$isRenderPhaseUpdate(fiber) ? $997a9c03857cd60f$var$enqueueRenderPhaseUpdate(queue, action) : (action = $997a9c03857cd60f$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($997a9c03857cd60f$var$scheduleUpdateOnFiber(action, fiber, lane), $997a9c03857cd60f$var$entangleTransitionUpdate(action, queue, lane)));
}
function $997a9c03857cd60f$var$dispatchSetState(fiber, queue, action) {
    var lane = $997a9c03857cd60f$var$requestUpdateLane();
    $997a9c03857cd60f$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $997a9c03857cd60f$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($997a9c03857cd60f$var$isRenderPhaseUpdate(fiber)) $997a9c03857cd60f$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($997a9c03857cd60f$var$objectIs(eagerState, currentState)) return $997a9c03857cd60f$var$enqueueUpdate$1(fiber, queue, update, 0), null === $997a9c03857cd60f$var$workInProgressRoot && $997a9c03857cd60f$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $997a9c03857cd60f$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $997a9c03857cd60f$var$scheduleUpdateOnFiber(action, fiber, lane), $997a9c03857cd60f$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $997a9c03857cd60f$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $997a9c03857cd60f$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($997a9c03857cd60f$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $997a9c03857cd60f$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $997a9c03857cd60f$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $997a9c03857cd60f$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $997a9c03857cd60f$var$currentlyRenderingFiber || null !== alternate && alternate === $997a9c03857cd60f$var$currentlyRenderingFiber;
}
function $997a9c03857cd60f$var$enqueueRenderPhaseUpdate(queue, update) {
    $997a9c03857cd60f$var$didScheduleRenderPhaseUpdateDuringThisPass = $997a9c03857cd60f$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $997a9c03857cd60f$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $997a9c03857cd60f$var$markRootEntangled(root, lane);
    }
}
var $997a9c03857cd60f$var$ContextOnlyDispatcher = {
    readContext: $997a9c03857cd60f$var$readContext,
    use: $997a9c03857cd60f$var$use,
    useCallback: $997a9c03857cd60f$var$throwInvalidHookError,
    useContext: $997a9c03857cd60f$var$throwInvalidHookError,
    useEffect: $997a9c03857cd60f$var$throwInvalidHookError,
    useImperativeHandle: $997a9c03857cd60f$var$throwInvalidHookError,
    useLayoutEffect: $997a9c03857cd60f$var$throwInvalidHookError,
    useInsertionEffect: $997a9c03857cd60f$var$throwInvalidHookError,
    useMemo: $997a9c03857cd60f$var$throwInvalidHookError,
    useReducer: $997a9c03857cd60f$var$throwInvalidHookError,
    useRef: $997a9c03857cd60f$var$throwInvalidHookError,
    useState: $997a9c03857cd60f$var$throwInvalidHookError,
    useDebugValue: $997a9c03857cd60f$var$throwInvalidHookError,
    useDeferredValue: $997a9c03857cd60f$var$throwInvalidHookError,
    useTransition: $997a9c03857cd60f$var$throwInvalidHookError,
    useSyncExternalStore: $997a9c03857cd60f$var$throwInvalidHookError,
    useId: $997a9c03857cd60f$var$throwInvalidHookError,
    useHostTransitionStatus: $997a9c03857cd60f$var$throwInvalidHookError,
    useFormState: $997a9c03857cd60f$var$throwInvalidHookError,
    useActionState: $997a9c03857cd60f$var$throwInvalidHookError,
    useOptimistic: $997a9c03857cd60f$var$throwInvalidHookError,
    useMemoCache: $997a9c03857cd60f$var$throwInvalidHookError,
    useCacheRefresh: $997a9c03857cd60f$var$throwInvalidHookError
};
$997a9c03857cd60f$var$ContextOnlyDispatcher.useEffectEvent = $997a9c03857cd60f$var$throwInvalidHookError;
var $997a9c03857cd60f$var$HooksDispatcherOnMount = {
    readContext: $997a9c03857cd60f$var$readContext,
    use: $997a9c03857cd60f$var$use,
    useCallback: function(callback, deps) {
        $997a9c03857cd60f$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $997a9c03857cd60f$var$readContext,
    useEffect: $997a9c03857cd60f$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $997a9c03857cd60f$var$mountEffectImpl(4194308, 4, $997a9c03857cd60f$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $997a9c03857cd60f$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $997a9c03857cd60f$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $997a9c03857cd60f$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $997a9c03857cd60f$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($997a9c03857cd60f$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $997a9c03857cd60f$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $997a9c03857cd60f$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $997a9c03857cd60f$var$dispatchReducerAction.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $997a9c03857cd60f$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $997a9c03857cd60f$var$dispatchSetState.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $997a9c03857cd60f$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
        return $997a9c03857cd60f$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $997a9c03857cd60f$var$mountStateImpl(!1);
        stateHook = $997a9c03857cd60f$var$startTransition.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $997a9c03857cd60f$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $997a9c03857cd60f$var$currentlyRenderingFiber, hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
        if ($997a9c03857cd60f$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $997a9c03857cd60f$var$workInProgressRoot) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(349));
            0 !== ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 127) || $997a9c03857cd60f$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $997a9c03857cd60f$var$mountEffect($997a9c03857cd60f$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $997a9c03857cd60f$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $997a9c03857cd60f$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook(), identifierPrefix = $997a9c03857cd60f$var$workInProgressRoot.identifierPrefix;
        if ($997a9c03857cd60f$var$isHydrating) {
            var JSCompiler_inline_result = $997a9c03857cd60f$var$treeContextOverflow;
            var idWithLeadingBit = $997a9c03857cd60f$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $997a9c03857cd60f$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $997a9c03857cd60f$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $997a9c03857cd60f$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $997a9c03857cd60f$var$useHostTransitionStatus,
    useFormState: $997a9c03857cd60f$var$mountActionState,
    useActionState: $997a9c03857cd60f$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $997a9c03857cd60f$var$dispatchOptimisticSetState.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $997a9c03857cd60f$var$useMemoCache,
    useCacheRefresh: function() {
        return $997a9c03857cd60f$var$mountWorkInProgressHook().memoizedState = $997a9c03857cd60f$var$refreshCache.bind(null, $997a9c03857cd60f$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $997a9c03857cd60f$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($997a9c03857cd60f$var$executionContext & 2)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $997a9c03857cd60f$var$HooksDispatcherOnUpdate = {
    readContext: $997a9c03857cd60f$var$readContext,
    use: $997a9c03857cd60f$var$use,
    useCallback: $997a9c03857cd60f$var$updateCallback,
    useContext: $997a9c03857cd60f$var$readContext,
    useEffect: $997a9c03857cd60f$var$updateEffect,
    useImperativeHandle: $997a9c03857cd60f$var$updateImperativeHandle,
    useInsertionEffect: $997a9c03857cd60f$var$updateInsertionEffect,
    useLayoutEffect: $997a9c03857cd60f$var$updateLayoutEffect,
    useMemo: $997a9c03857cd60f$var$updateMemo,
    useReducer: $997a9c03857cd60f$var$updateReducer,
    useRef: $997a9c03857cd60f$var$updateRef,
    useState: function() {
        return $997a9c03857cd60f$var$updateReducer($997a9c03857cd60f$var$basicStateReducer);
    },
    useDebugValue: $997a9c03857cd60f$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
        return $997a9c03857cd60f$var$updateDeferredValueImpl(hook, $997a9c03857cd60f$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $997a9c03857cd60f$var$updateReducer($997a9c03857cd60f$var$basicStateReducer)[0], start = $997a9c03857cd60f$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $997a9c03857cd60f$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $997a9c03857cd60f$var$updateSyncExternalStore,
    useId: $997a9c03857cd60f$var$updateId,
    useHostTransitionStatus: $997a9c03857cd60f$var$useHostTransitionStatus,
    useFormState: $997a9c03857cd60f$var$updateActionState,
    useActionState: $997a9c03857cd60f$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
        return $997a9c03857cd60f$var$updateOptimisticImpl(hook, $997a9c03857cd60f$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $997a9c03857cd60f$var$useMemoCache,
    useCacheRefresh: $997a9c03857cd60f$var$updateRefresh
};
$997a9c03857cd60f$var$HooksDispatcherOnUpdate.useEffectEvent = $997a9c03857cd60f$var$updateEvent;
var $997a9c03857cd60f$var$HooksDispatcherOnRerender = {
    readContext: $997a9c03857cd60f$var$readContext,
    use: $997a9c03857cd60f$var$use,
    useCallback: $997a9c03857cd60f$var$updateCallback,
    useContext: $997a9c03857cd60f$var$readContext,
    useEffect: $997a9c03857cd60f$var$updateEffect,
    useImperativeHandle: $997a9c03857cd60f$var$updateImperativeHandle,
    useInsertionEffect: $997a9c03857cd60f$var$updateInsertionEffect,
    useLayoutEffect: $997a9c03857cd60f$var$updateLayoutEffect,
    useMemo: $997a9c03857cd60f$var$updateMemo,
    useReducer: $997a9c03857cd60f$var$rerenderReducer,
    useRef: $997a9c03857cd60f$var$updateRef,
    useState: function() {
        return $997a9c03857cd60f$var$rerenderReducer($997a9c03857cd60f$var$basicStateReducer);
    },
    useDebugValue: $997a9c03857cd60f$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
        return null === $997a9c03857cd60f$var$currentHook ? $997a9c03857cd60f$var$mountDeferredValueImpl(hook, value, initialValue) : $997a9c03857cd60f$var$updateDeferredValueImpl(hook, $997a9c03857cd60f$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $997a9c03857cd60f$var$rerenderReducer($997a9c03857cd60f$var$basicStateReducer)[0], start = $997a9c03857cd60f$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $997a9c03857cd60f$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $997a9c03857cd60f$var$updateSyncExternalStore,
    useId: $997a9c03857cd60f$var$updateId,
    useHostTransitionStatus: $997a9c03857cd60f$var$useHostTransitionStatus,
    useFormState: $997a9c03857cd60f$var$rerenderActionState,
    useActionState: $997a9c03857cd60f$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $997a9c03857cd60f$var$updateWorkInProgressHook();
        if (null !== $997a9c03857cd60f$var$currentHook) return $997a9c03857cd60f$var$updateOptimisticImpl(hook, $997a9c03857cd60f$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $997a9c03857cd60f$var$useMemoCache,
    useCacheRefresh: $997a9c03857cd60f$var$updateRefresh
};
$997a9c03857cd60f$var$HooksDispatcherOnRerender.useEffectEvent = $997a9c03857cd60f$var$updateEvent;
function $997a9c03857cd60f$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $997a9c03857cd60f$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $997a9c03857cd60f$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $997a9c03857cd60f$var$requestUpdateLane(), update = $997a9c03857cd60f$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $997a9c03857cd60f$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($997a9c03857cd60f$var$scheduleUpdateOnFiber(payload, inst, lane), $997a9c03857cd60f$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $997a9c03857cd60f$var$requestUpdateLane(), update = $997a9c03857cd60f$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $997a9c03857cd60f$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($997a9c03857cd60f$var$scheduleUpdateOnFiber(payload, inst, lane), $997a9c03857cd60f$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $997a9c03857cd60f$var$requestUpdateLane(), update = $997a9c03857cd60f$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $997a9c03857cd60f$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($997a9c03857cd60f$var$scheduleUpdateOnFiber(callback, inst, lane), $997a9c03857cd60f$var$entangleTransitions(callback, inst, lane));
    }
};
function $997a9c03857cd60f$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$997a9c03857cd60f$var$shallowEqual(oldProps, newProps) || !$997a9c03857cd60f$var$shallowEqual(oldState, newState) : !0;
}
function $997a9c03857cd60f$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $997a9c03857cd60f$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $997a9c03857cd60f$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $997a9c03857cd60f$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $997a9c03857cd60f$var$defaultOnUncaughtError(error) {
    $997a9c03857cd60f$var$reportGlobalError(error);
}
function $997a9c03857cd60f$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $997a9c03857cd60f$var$defaultOnRecoverableError(error) {
    $997a9c03857cd60f$var$reportGlobalError(error);
}
function $997a9c03857cd60f$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $997a9c03857cd60f$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $997a9c03857cd60f$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $997a9c03857cd60f$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $997a9c03857cd60f$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $997a9c03857cd60f$var$createClassErrorUpdate(lane) {
    lane = $997a9c03857cd60f$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $997a9c03857cd60f$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $997a9c03857cd60f$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $997a9c03857cd60f$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed ? $997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $997a9c03857cd60f$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $997a9c03857cd60f$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $997a9c03857cd60f$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $997a9c03857cd60f$var$shellBoundary ? $997a9c03857cd60f$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $997a9c03857cd60f$var$workInProgressRootExitStatus && ($997a9c03857cd60f$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $997a9c03857cd60f$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $997a9c03857cd60f$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $997a9c03857cd60f$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $997a9c03857cd60f$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $997a9c03857cd60f$var$attachPingListener(root, value, rootRenderLanes);
        $997a9c03857cd60f$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($997a9c03857cd60f$var$isHydrating) return returnFiber = $997a9c03857cd60f$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $997a9c03857cd60f$var$HydrationMismatchException && (root = Error($997a9c03857cd60f$var$formatProdErrorMessage(422), {
        cause: value
    }), $997a9c03857cd60f$var$queueHydrationError($997a9c03857cd60f$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $997a9c03857cd60f$var$HydrationMismatchException && (returnFiber = Error($997a9c03857cd60f$var$formatProdErrorMessage(423), {
        cause: value
    }), $997a9c03857cd60f$var$queueHydrationError($997a9c03857cd60f$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $997a9c03857cd60f$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $997a9c03857cd60f$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $997a9c03857cd60f$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $997a9c03857cd60f$var$workInProgressRootExitStatus && ($997a9c03857cd60f$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($997a9c03857cd60f$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $997a9c03857cd60f$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $997a9c03857cd60f$var$workInProgressRootConcurrentErrors ? $997a9c03857cd60f$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $997a9c03857cd60f$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $997a9c03857cd60f$var$workInProgressRootExitStatus && ($997a9c03857cd60f$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $997a9c03857cd60f$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $997a9c03857cd60f$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $997a9c03857cd60f$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed || !$997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $997a9c03857cd60f$var$createClassErrorUpdate(rootRenderLanes), $997a9c03857cd60f$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $997a9c03857cd60f$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $997a9c03857cd60f$var$SelectiveHydrationException = Error($997a9c03857cd60f$var$formatProdErrorMessage(461)), $997a9c03857cd60f$var$didReceiveUpdate = !1;
function $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $997a9c03857cd60f$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $997a9c03857cd60f$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $997a9c03857cd60f$var$prepareToReadContext(workInProgress);
    nextProps = $997a9c03857cd60f$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $997a9c03857cd60f$var$checkDidRenderIdHook();
    if (null !== current && !$997a9c03857cd60f$var$didReceiveUpdate) return $997a9c03857cd60f$var$bailoutHooks(current, workInProgress, renderLanes), $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $997a9c03857cd60f$var$isHydrating && key && $997a9c03857cd60f$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $997a9c03857cd60f$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$997a9c03857cd60f$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $997a9c03857cd60f$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $997a9c03857cd60f$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$997a9c03857cd60f$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $997a9c03857cd60f$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $997a9c03857cd60f$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $997a9c03857cd60f$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($997a9c03857cd60f$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($997a9c03857cd60f$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $997a9c03857cd60f$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($997a9c03857cd60f$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $997a9c03857cd60f$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $997a9c03857cd60f$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $997a9c03857cd60f$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $997a9c03857cd60f$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $997a9c03857cd60f$var$pushHiddenContext(workInProgress, prevState) : $997a9c03857cd60f$var$reuseHiddenContextOnStack(), $997a9c03857cd60f$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $997a9c03857cd60f$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($997a9c03857cd60f$var$pushTransition(workInProgress, prevState.cachePool), $997a9c03857cd60f$var$pushHiddenContext(workInProgress, prevState), $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $997a9c03857cd60f$var$pushTransition(workInProgress, null), $997a9c03857cd60f$var$reuseHiddenContextOnStack(), $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress));
    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $997a9c03857cd60f$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $997a9c03857cd60f$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $997a9c03857cd60f$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $997a9c03857cd60f$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $997a9c03857cd60f$var$pushTransition(workInProgress, null);
    $997a9c03857cd60f$var$reuseHiddenContextOnStack();
    $997a9c03857cd60f$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $997a9c03857cd60f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $997a9c03857cd60f$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $997a9c03857cd60f$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $997a9c03857cd60f$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $997a9c03857cd60f$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $997a9c03857cd60f$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $997a9c03857cd60f$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($997a9c03857cd60f$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $997a9c03857cd60f$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $997a9c03857cd60f$var$bailoutOffscreenComponent(null, current);
            $997a9c03857cd60f$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $997a9c03857cd60f$var$nextHydratableInstance) ? (current = $997a9c03857cd60f$var$canHydrateHydrationBoundary(current, $997a9c03857cd60f$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $997a9c03857cd60f$var$treeContextProvider ? {
                    id: $997a9c03857cd60f$var$treeContextId,
                    overflow: $997a9c03857cd60f$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $997a9c03857cd60f$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $997a9c03857cd60f$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $997a9c03857cd60f$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $997a9c03857cd60f$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $997a9c03857cd60f$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($997a9c03857cd60f$var$formatProdErrorMessage(558));
        } else if ($997a9c03857cd60f$var$didReceiveUpdate || $997a9c03857cd60f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $997a9c03857cd60f$var$didReceiveUpdate || didSuspend) {
            nextProps = $997a9c03857cd60f$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $997a9c03857cd60f$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(current, dehydrated), $997a9c03857cd60f$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $997a9c03857cd60f$var$SelectiveHydrationException;
            $997a9c03857cd60f$var$renderDidSuspendDelayIfPossible();
            workInProgress = $997a9c03857cd60f$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratable(dehydrated.nextSibling), $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$isHydrating = !0, $997a9c03857cd60f$var$hydrationErrors = null, $997a9c03857cd60f$var$rootOrSingletonContext = !1, null !== current && $997a9c03857cd60f$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $997a9c03857cd60f$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $997a9c03857cd60f$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $997a9c03857cd60f$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $997a9c03857cd60f$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $997a9c03857cd60f$var$prepareToReadContext(workInProgress);
    Component = $997a9c03857cd60f$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $997a9c03857cd60f$var$checkDidRenderIdHook();
    if (null !== current && !$997a9c03857cd60f$var$didReceiveUpdate) return $997a9c03857cd60f$var$bailoutHooks(current, workInProgress, renderLanes), $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $997a9c03857cd60f$var$isHydrating && nextProps && $997a9c03857cd60f$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $997a9c03857cd60f$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $997a9c03857cd60f$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $997a9c03857cd60f$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $997a9c03857cd60f$var$finishRenderingHooks(current);
    Component = $997a9c03857cd60f$var$checkDidRenderIdHook();
    if (null !== current && !$997a9c03857cd60f$var$didReceiveUpdate) return $997a9c03857cd60f$var$bailoutHooks(current, workInProgress, renderLanes), $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $997a9c03857cd60f$var$isHydrating && Component && $997a9c03857cd60f$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $997a9c03857cd60f$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $997a9c03857cd60f$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $997a9c03857cd60f$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $997a9c03857cd60f$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $997a9c03857cd60f$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $997a9c03857cd60f$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $997a9c03857cd60f$var$readContext(contextType) : $997a9c03857cd60f$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($997a9c03857cd60f$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $997a9c03857cd60f$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $997a9c03857cd60f$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $997a9c03857cd60f$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $997a9c03857cd60f$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $997a9c03857cd60f$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $997a9c03857cd60f$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $997a9c03857cd60f$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $997a9c03857cd60f$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $997a9c03857cd60f$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $997a9c03857cd60f$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $997a9c03857cd60f$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($997a9c03857cd60f$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $997a9c03857cd60f$var$hasForceUpdate || $997a9c03857cd60f$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $997a9c03857cd60f$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $997a9c03857cd60f$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $997a9c03857cd60f$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $997a9c03857cd60f$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $997a9c03857cd60f$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $997a9c03857cd60f$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $997a9c03857cd60f$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $997a9c03857cd60f$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $997a9c03857cd60f$var$hasForceUpdate || null !== current && null !== current.dependencies && $997a9c03857cd60f$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($997a9c03857cd60f$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $997a9c03857cd60f$var$hasForceUpdate || $997a9c03857cd60f$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $997a9c03857cd60f$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $997a9c03857cd60f$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $997a9c03857cd60f$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $997a9c03857cd60f$var$resetHydrationState();
    workInProgress.flags |= 256;
    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $997a9c03857cd60f$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $997a9c03857cd60f$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $997a9c03857cd60f$var$getSuspendedCache()
    };
}
function $997a9c03857cd60f$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $997a9c03857cd60f$var$workInProgressDeferredLane);
    return current;
}
function $997a9c03857cd60f$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($997a9c03857cd60f$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($997a9c03857cd60f$var$isHydrating) {
            showFallback ? $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $997a9c03857cd60f$var$nextHydratableInstance) ? (current = $997a9c03857cd60f$var$canHydrateHydrationBoundary(current, $997a9c03857cd60f$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $997a9c03857cd60f$var$treeContextProvider ? {
                    id: $997a9c03857cd60f$var$treeContextId,
                    overflow: $997a9c03857cd60f$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $997a9c03857cd60f$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $997a9c03857cd60f$var$throwOnHydrationMismatch(workInProgress);
            $997a9c03857cd60f$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $997a9c03857cd60f$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $997a9c03857cd60f$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $997a9c03857cd60f$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $997a9c03857cd60f$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $997a9c03857cd60f$var$SUSPENDED_MARKER, $997a9c03857cd60f$var$bailoutOffscreenComponent(null, nextProps);
        $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $997a9c03857cd60f$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $997a9c03857cd60f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $997a9c03857cd60f$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $997a9c03857cd60f$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $997a9c03857cd60f$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $997a9c03857cd60f$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $997a9c03857cd60f$var$SUSPENDED_MARKER, workInProgress = $997a9c03857cd60f$var$bailoutOffscreenComponent(null, nextProps));
        else if ($997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress), $997a9c03857cd60f$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($997a9c03857cd60f$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $997a9c03857cd60f$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $997a9c03857cd60f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($997a9c03857cd60f$var$didReceiveUpdate || $997a9c03857cd60f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $997a9c03857cd60f$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $997a9c03857cd60f$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $997a9c03857cd60f$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(current, nextProps), $997a9c03857cd60f$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $997a9c03857cd60f$var$SelectiveHydrationException;
            $997a9c03857cd60f$var$isSuspenseInstancePending(nextPrimaryChildren) || $997a9c03857cd60f$var$renderDidSuspendDelayIfPossible();
            workInProgress = $997a9c03857cd60f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $997a9c03857cd60f$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratable(nextPrimaryChildren.nextSibling), $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$isHydrating = !0, $997a9c03857cd60f$var$hydrationErrors = null, $997a9c03857cd60f$var$rootOrSingletonContext = !1, null !== current && $997a9c03857cd60f$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $997a9c03857cd60f$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $997a9c03857cd60f$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $997a9c03857cd60f$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $997a9c03857cd60f$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $997a9c03857cd60f$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $997a9c03857cd60f$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $997a9c03857cd60f$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $997a9c03857cd60f$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $997a9c03857cd60f$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $997a9c03857cd60f$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $997a9c03857cd60f$var$SUSPENDED_MARKER, $997a9c03857cd60f$var$bailoutOffscreenComponent(current.child, nextProps);
    $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $997a9c03857cd60f$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $997a9c03857cd60f$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $997a9c03857cd60f$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $997a9c03857cd60f$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $997a9c03857cd60f$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $997a9c03857cd60f$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $997a9c03857cd60f$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $997a9c03857cd60f$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $997a9c03857cd60f$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $997a9c03857cd60f$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $997a9c03857cd60f$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $997a9c03857cd60f$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, suspenseContext);
    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $997a9c03857cd60f$var$isHydrating ? $997a9c03857cd60f$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $997a9c03857cd60f$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $997a9c03857cd60f$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $997a9c03857cd60f$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $997a9c03857cd60f$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $997a9c03857cd60f$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $997a9c03857cd60f$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $997a9c03857cd60f$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $997a9c03857cd60f$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($997a9c03857cd60f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $997a9c03857cd60f$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $997a9c03857cd60f$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $997a9c03857cd60f$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $997a9c03857cd60f$var$checkIfContextChanged(current) ? !0 : !1;
}
function $997a9c03857cd60f$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $997a9c03857cd60f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $997a9c03857cd60f$var$pushProvider(workInProgress, $997a9c03857cd60f$var$CacheContext, current.memoizedState.cache);
            $997a9c03857cd60f$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $997a9c03857cd60f$var$pushHostContext(workInProgress);
            break;
        case 4:
            $997a9c03857cd60f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $997a9c03857cd60f$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $997a9c03857cd60f$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $997a9c03857cd60f$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $997a9c03857cd60f$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($997a9c03857cd60f$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $997a9c03857cd60f$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, $997a9c03857cd60f$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $997a9c03857cd60f$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $997a9c03857cd60f$var$pushProvider(workInProgress, $997a9c03857cd60f$var$CacheContext, current.memoizedState.cache);
    }
    return $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $997a9c03857cd60f$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $997a9c03857cd60f$var$didReceiveUpdate = !0;
        else {
            if (!$997a9c03857cd60f$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $997a9c03857cd60f$var$didReceiveUpdate = !1, $997a9c03857cd60f$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $997a9c03857cd60f$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $997a9c03857cd60f$var$didReceiveUpdate = !1, $997a9c03857cd60f$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $997a9c03857cd60f$var$pushTreeId(workInProgress, $997a9c03857cd60f$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $997a9c03857cd60f$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $997a9c03857cd60f$var$shouldConstruct(current) ? (props = $997a9c03857cd60f$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $997a9c03857cd60f$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $997a9c03857cd60f$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $997a9c03857cd60f$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $997a9c03857cd60f$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $997a9c03857cd60f$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $997a9c03857cd60f$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $997a9c03857cd60f$var$getComponentNameFromType(current) || current;
                    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $997a9c03857cd60f$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $997a9c03857cd60f$var$resolveClassComponentProps(props, workInProgress.pendingProps), $997a9c03857cd60f$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $997a9c03857cd60f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $997a9c03857cd60f$var$cloneUpdateQueue(current, workInProgress);
                $997a9c03857cd60f$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $997a9c03857cd60f$var$pushProvider(workInProgress, $997a9c03857cd60f$var$CacheContext, props);
                props !== prevState.cache && $997a9c03857cd60f$var$propagateContextChanges(workInProgress, [
                    $997a9c03857cd60f$var$CacheContext
                ], renderLanes, !0);
                $997a9c03857cd60f$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $997a9c03857cd60f$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $997a9c03857cd60f$var$createCapturedValueAtFiber(Error($997a9c03857cd60f$var$formatProdErrorMessage(424)), workInProgress);
                        $997a9c03857cd60f$var$queueHydrationError($$typeof);
                        workInProgress = $997a9c03857cd60f$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratable(current.firstChild);
                        $997a9c03857cd60f$var$hydrationParentFiber = workInProgress;
                        $997a9c03857cd60f$var$isHydrating = !0;
                        $997a9c03857cd60f$var$hydrationErrors = null;
                        $997a9c03857cd60f$var$rootOrSingletonContext = !0;
                        renderLanes = $997a9c03857cd60f$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $997a9c03857cd60f$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $997a9c03857cd60f$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $997a9c03857cd60f$var$markRef(current, workInProgress), null === current ? (renderLanes = $997a9c03857cd60f$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $997a9c03857cd60f$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $997a9c03857cd60f$var$getOwnerDocumentFromRootContainer($997a9c03857cd60f$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$997a9c03857cd60f$var$internalInstanceKey] = workInProgress, props[$997a9c03857cd60f$var$internalPropsKey] = current, $997a9c03857cd60f$var$setInitialProperties(props, renderLanes, current), $997a9c03857cd60f$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $997a9c03857cd60f$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $997a9c03857cd60f$var$pushHostContext(workInProgress), null === current && $997a9c03857cd60f$var$isHydrating && (props = workInProgress.stateNode = $997a9c03857cd60f$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $997a9c03857cd60f$var$rootInstanceStackCursor.current), $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$rootOrSingletonContext = !0, $$typeof = $997a9c03857cd60f$var$nextHydratableInstance, $997a9c03857cd60f$var$isSingletonScope(workInProgress.type) ? ($997a9c03857cd60f$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratable(props.firstChild)) : $997a9c03857cd60f$var$nextHydratableInstance = $$typeof), $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $997a9c03857cd60f$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $997a9c03857cd60f$var$isHydrating) {
                if ($$typeof = props = $997a9c03857cd60f$var$nextHydratableInstance) props = $997a9c03857cd60f$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $997a9c03857cd60f$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$nextHydratableInstance = $997a9c03857cd60f$var$getNextHydratable(props.firstChild), $997a9c03857cd60f$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $997a9c03857cd60f$var$throwOnHydrationMismatch(workInProgress);
            }
            $997a9c03857cd60f$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $997a9c03857cd60f$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $997a9c03857cd60f$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $997a9c03857cd60f$var$renderWithHooks(current, workInProgress, $997a9c03857cd60f$var$TransitionAwareHostComponent, null, null, renderLanes), $997a9c03857cd60f$var$HostTransitionContext._currentValue = $$typeof);
            $997a9c03857cd60f$var$markRef(current, workInProgress);
            $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $997a9c03857cd60f$var$isHydrating) {
                if (current = renderLanes = $997a9c03857cd60f$var$nextHydratableInstance) renderLanes = $997a9c03857cd60f$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $997a9c03857cd60f$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $997a9c03857cd60f$var$hydrationParentFiber = workInProgress, $997a9c03857cd60f$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $997a9c03857cd60f$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $997a9c03857cd60f$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $997a9c03857cd60f$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $997a9c03857cd60f$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $997a9c03857cd60f$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $997a9c03857cd60f$var$pushProvider(workInProgress, workInProgress.type, props.value), $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $997a9c03857cd60f$var$prepareToReadContext(workInProgress), $$typeof = $997a9c03857cd60f$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $997a9c03857cd60f$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $997a9c03857cd60f$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $997a9c03857cd60f$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $997a9c03857cd60f$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $997a9c03857cd60f$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $997a9c03857cd60f$var$prepareToReadContext(workInProgress), props = $997a9c03857cd60f$var$readContext($997a9c03857cd60f$var$CacheContext), null === current ? ($$typeof = $997a9c03857cd60f$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $997a9c03857cd60f$var$workInProgressRoot, prevState = $997a9c03857cd60f$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $997a9c03857cd60f$var$initializeUpdateQueue(workInProgress), $997a9c03857cd60f$var$pushProvider(workInProgress, $997a9c03857cd60f$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($997a9c03857cd60f$var$cloneUpdateQueue(current, workInProgress), $997a9c03857cd60f$var$processUpdateQueue(workInProgress, null, null, renderLanes), $997a9c03857cd60f$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $997a9c03857cd60f$var$pushProvider(workInProgress, $997a9c03857cd60f$var$CacheContext, props)) : (props = prevState.cache, $997a9c03857cd60f$var$pushProvider(workInProgress, $997a9c03857cd60f$var$CacheContext, props), props !== $$typeof.cache && $997a9c03857cd60f$var$propagateContextChanges(workInProgress, [
                $997a9c03857cd60f$var$CacheContext
            ], renderLanes, !0))), $997a9c03857cd60f$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $997a9c03857cd60f$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $997a9c03857cd60f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($997a9c03857cd60f$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $997a9c03857cd60f$var$suspendedThenable = $997a9c03857cd60f$var$noopSuspenseyCommitThenable, $997a9c03857cd60f$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $997a9c03857cd60f$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$997a9c03857cd60f$var$preloadResource(resource)) {
        if ($997a9c03857cd60f$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $997a9c03857cd60f$var$suspendedThenable = $997a9c03857cd60f$var$noopSuspenseyCommitThenable, $997a9c03857cd60f$var$SuspenseyCommitException;
    }
}
function $997a9c03857cd60f$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $997a9c03857cd60f$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $997a9c03857cd60f$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $997a9c03857cd60f$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$997a9c03857cd60f$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $997a9c03857cd60f$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $997a9c03857cd60f$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $997a9c03857cd60f$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
        case 1:
            return $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $997a9c03857cd60f$var$popProvider($997a9c03857cd60f$var$CacheContext);
            $997a9c03857cd60f$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $997a9c03857cd60f$var$popHydrationState(workInProgress) ? $997a9c03857cd60f$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $997a9c03857cd60f$var$upgradeHydrationErrorsToRecoverable());
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($997a9c03857cd60f$var$markUpdate(workInProgress), null !== nextResource ? ($997a9c03857cd60f$var$bubbleProperties(workInProgress), $997a9c03857cd60f$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($997a9c03857cd60f$var$bubbleProperties(workInProgress), $997a9c03857cd60f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($997a9c03857cd60f$var$markUpdate(workInProgress), $997a9c03857cd60f$var$bubbleProperties(workInProgress), $997a9c03857cd60f$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($997a9c03857cd60f$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $997a9c03857cd60f$var$markUpdate(workInProgress), $997a9c03857cd60f$var$bubbleProperties(workInProgress), $997a9c03857cd60f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $997a9c03857cd60f$var$popHostContext(workInProgress);
            renderLanes = $997a9c03857cd60f$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $997a9c03857cd60f$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(166));
                    $997a9c03857cd60f$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $997a9c03857cd60f$var$contextStackCursor.current;
                $997a9c03857cd60f$var$popHydrationState(workInProgress) ? $997a9c03857cd60f$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $997a9c03857cd60f$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $997a9c03857cd60f$var$markUpdate(workInProgress));
            }
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $997a9c03857cd60f$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $997a9c03857cd60f$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(166));
                    $997a9c03857cd60f$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $997a9c03857cd60f$var$contextStackCursor.current;
                if ($997a9c03857cd60f$var$popHydrationState(workInProgress)) $997a9c03857cd60f$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $997a9c03857cd60f$var$getOwnerDocumentFromRootContainer($997a9c03857cd60f$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$997a9c03857cd60f$var$internalInstanceKey] = workInProgress;
                    nextResource[$997a9c03857cd60f$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($997a9c03857cd60f$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $997a9c03857cd60f$var$markUpdate(workInProgress);
                }
            }
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            $997a9c03857cd60f$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $997a9c03857cd60f$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(166));
                current = $997a9c03857cd60f$var$rootInstanceStackCursor.current;
                if ($997a9c03857cd60f$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $997a9c03857cd60f$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$997a9c03857cd60f$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $997a9c03857cd60f$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $997a9c03857cd60f$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $997a9c03857cd60f$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$997a9c03857cd60f$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $997a9c03857cd60f$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(557));
                        current[$997a9c03857cd60f$var$internalInstanceKey] = workInProgress;
                    } else $997a9c03857cd60f$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $997a9c03857cd60f$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $997a9c03857cd60f$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $997a9c03857cd60f$var$popSuspenseHandler(workInProgress), workInProgress;
                    $997a9c03857cd60f$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(558));
            }
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $997a9c03857cd60f$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(317));
                        type[$997a9c03857cd60f$var$internalInstanceKey] = workInProgress;
                    } else $997a9c03857cd60f$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $997a9c03857cd60f$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $997a9c03857cd60f$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $997a9c03857cd60f$var$popSuspenseHandler(workInProgress), workInProgress;
                    $997a9c03857cd60f$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $997a9c03857cd60f$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $997a9c03857cd60f$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $997a9c03857cd60f$var$popHostContainer(), null === current && $997a9c03857cd60f$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
        case 10:
            return $997a9c03857cd60f$var$popProvider(workInProgress.type), $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
        case 19:
            $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $997a9c03857cd60f$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $997a9c03857cd60f$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $997a9c03857cd60f$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $997a9c03857cd60f$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $997a9c03857cd60f$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$997a9c03857cd60f$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, $997a9c03857cd60f$var$suspenseStackCursor.current & 1 | 2);
                            $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $997a9c03857cd60f$var$now() > $997a9c03857cd60f$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $997a9c03857cd60f$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $997a9c03857cd60f$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $997a9c03857cd60f$var$scheduleRetryEffect(workInProgress, current), $997a9c03857cd60f$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$997a9c03857cd60f$var$isHydrating) return $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
                    } else 2 * $997a9c03857cd60f$var$now() - newProps.renderingStartTime > $997a9c03857cd60f$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $997a9c03857cd60f$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $997a9c03857cd60f$var$now(), current.sibling = null, renderLanes = $997a9c03857cd60f$var$suspenseStackCursor.current, $997a9c03857cd60f$var$push($997a9c03857cd60f$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $997a9c03857cd60f$var$isHydrating && $997a9c03857cd60f$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $997a9c03857cd60f$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $997a9c03857cd60f$var$popSuspenseHandler(workInProgress), $997a9c03857cd60f$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($997a9c03857cd60f$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $997a9c03857cd60f$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $997a9c03857cd60f$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $997a9c03857cd60f$var$popProvider($997a9c03857cd60f$var$CacheContext), $997a9c03857cd60f$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $997a9c03857cd60f$var$unwindWork(current, workInProgress) {
    $997a9c03857cd60f$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $997a9c03857cd60f$var$popProvider($997a9c03857cd60f$var$CacheContext), $997a9c03857cd60f$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $997a9c03857cd60f$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $997a9c03857cd60f$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(340));
                $997a9c03857cd60f$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $997a9c03857cd60f$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(340));
                $997a9c03857cd60f$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$suspenseStackCursor), null;
        case 4:
            return $997a9c03857cd60f$var$popHostContainer(), null;
        case 10:
            return $997a9c03857cd60f$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $997a9c03857cd60f$var$popSuspenseHandler(workInProgress), $997a9c03857cd60f$var$popHiddenContext(), null !== current && $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $997a9c03857cd60f$var$popProvider($997a9c03857cd60f$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $997a9c03857cd60f$var$unwindInterruptedWork(current, interruptedWork) {
    $997a9c03857cd60f$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $997a9c03857cd60f$var$popProvider($997a9c03857cd60f$var$CacheContext);
            $997a9c03857cd60f$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $997a9c03857cd60f$var$popHostContext(interruptedWork);
            break;
        case 4:
            $997a9c03857cd60f$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $997a9c03857cd60f$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $997a9c03857cd60f$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$suspenseStackCursor);
            break;
        case 10:
            $997a9c03857cd60f$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $997a9c03857cd60f$var$popSuspenseHandler(interruptedWork);
            $997a9c03857cd60f$var$popHiddenContext();
            null !== current && $997a9c03857cd60f$var$pop($997a9c03857cd60f$var$resumedCache);
            break;
        case 24:
            $997a9c03857cd60f$var$popProvider($997a9c03857cd60f$var$CacheContext);
    }
}
function $997a9c03857cd60f$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $997a9c03857cd60f$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $997a9c03857cd60f$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $997a9c03857cd60f$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $997a9c03857cd60f$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $997a9c03857cd60f$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $997a9c03857cd60f$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $997a9c03857cd60f$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $997a9c03857cd60f$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $997a9c03857cd60f$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $997a9c03857cd60f$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $997a9c03857cd60f$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $997a9c03857cd60f$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $997a9c03857cd60f$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$997a9c03857cd60f$var$internalPropsKey] = newProps;
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $997a9c03857cd60f$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $997a9c03857cd60f$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $997a9c03857cd60f$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $997a9c03857cd60f$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $997a9c03857cd60f$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $997a9c03857cd60f$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $997a9c03857cd60f$var$noop$1));
    else if (4 !== tag && (27 === tag && $997a9c03857cd60f$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($997a9c03857cd60f$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$997a9c03857cd60f$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $997a9c03857cd60f$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $997a9c03857cd60f$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($997a9c03857cd60f$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$997a9c03857cd60f$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $997a9c03857cd60f$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $997a9c03857cd60f$var$setInitialProperties(singleton, type, props);
        singleton[$997a9c03857cd60f$var$internalInstanceKey] = finishedWork;
        singleton[$997a9c03857cd60f$var$internalPropsKey] = props;
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $997a9c03857cd60f$var$offscreenSubtreeIsHidden = !1, $997a9c03857cd60f$var$offscreenSubtreeWasHidden = !1, $997a9c03857cd60f$var$needsFormReset = !1, $997a9c03857cd60f$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $997a9c03857cd60f$var$nextEffect = null;
function $997a9c03857cd60f$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $997a9c03857cd60f$var$eventsEnabled = $997a9c03857cd60f$var$_enabled;
    root = $997a9c03857cd60f$var$getActiveElementDeep(root);
    if ($997a9c03857cd60f$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $997a9c03857cd60f$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $997a9c03857cd60f$var$_enabled = !1;
    for($997a9c03857cd60f$var$nextEffect = firstChild; null !== $997a9c03857cd60f$var$nextEffect;)if (firstChild = $997a9c03857cd60f$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $997a9c03857cd60f$var$nextEffect = root;
    else for(; null !== $997a9c03857cd60f$var$nextEffect;){
        firstChild = $997a9c03857cd60f$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $997a9c03857cd60f$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $997a9c03857cd60f$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $997a9c03857cd60f$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $997a9c03857cd60f$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $997a9c03857cd60f$var$nextEffect = root;
            break;
        }
        $997a9c03857cd60f$var$nextEffect = firstChild.return;
    }
}
function $997a9c03857cd60f$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $997a9c03857cd60f$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $997a9c03857cd60f$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $997a9c03857cd60f$var$commitClassCallbacks(finishedWork);
            flags & 512 && $997a9c03857cd60f$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $997a9c03857cd60f$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $997a9c03857cd60f$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $997a9c03857cd60f$var$commitHostMount(finishedWork);
            flags & 512 && $997a9c03857cd60f$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $997a9c03857cd60f$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $997a9c03857cd60f$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $997a9c03857cd60f$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $997a9c03857cd60f$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $997a9c03857cd60f$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $997a9c03857cd60f$var$offscreenSubtreeWasHidden;
                prevProps = $997a9c03857cd60f$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $997a9c03857cd60f$var$offscreenSubtreeWasHidden;
                $997a9c03857cd60f$var$offscreenSubtreeIsHidden = flags;
                ($997a9c03857cd60f$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $997a9c03857cd60f$var$offscreenSubtreeIsHidden = prevProps;
                $997a9c03857cd60f$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $997a9c03857cd60f$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $997a9c03857cd60f$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $997a9c03857cd60f$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $997a9c03857cd60f$var$hostParent = null, $997a9c03857cd60f$var$hostParentIsContainer = !1;
function $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$997a9c03857cd60f$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $997a9c03857cd60f$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($997a9c03857cd60f$var$injectedHook && "function" === typeof $997a9c03857cd60f$var$injectedHook.onCommitFiberUnmount) try {
        $997a9c03857cd60f$var$injectedHook.onCommitFiberUnmount($997a9c03857cd60f$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden || $997a9c03857cd60f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden || $997a9c03857cd60f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $997a9c03857cd60f$var$hostParent, prevHostParentIsContainer = $997a9c03857cd60f$var$hostParentIsContainer;
            $997a9c03857cd60f$var$isSingletonScope(deletedFiber.type) && ($997a9c03857cd60f$var$hostParent = deletedFiber.stateNode, $997a9c03857cd60f$var$hostParentIsContainer = !1);
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $997a9c03857cd60f$var$releaseSingletonInstance(deletedFiber.stateNode);
            $997a9c03857cd60f$var$hostParent = prevHostParent;
            $997a9c03857cd60f$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden || $997a9c03857cd60f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $997a9c03857cd60f$var$hostParent;
            prevHostParentIsContainer = $997a9c03857cd60f$var$hostParentIsContainer;
            $997a9c03857cd60f$var$hostParent = null;
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $997a9c03857cd60f$var$hostParent = prevHostParent;
            $997a9c03857cd60f$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $997a9c03857cd60f$var$hostParent) {
                if ($997a9c03857cd60f$var$hostParentIsContainer) try {
                    (9 === $997a9c03857cd60f$var$hostParent.nodeType ? $997a9c03857cd60f$var$hostParent.body : "HTML" === $997a9c03857cd60f$var$hostParent.nodeName ? $997a9c03857cd60f$var$hostParent.ownerDocument.body : $997a9c03857cd60f$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $997a9c03857cd60f$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $997a9c03857cd60f$var$hostParent && ($997a9c03857cd60f$var$hostParentIsContainer ? (finishedRoot = $997a9c03857cd60f$var$hostParent, $997a9c03857cd60f$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $997a9c03857cd60f$var$retryIfBlockedOn(finishedRoot)) : $997a9c03857cd60f$var$clearHydrationBoundary($997a9c03857cd60f$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $997a9c03857cd60f$var$hostParent;
            prevHostParentIsContainer = $997a9c03857cd60f$var$hostParentIsContainer;
            $997a9c03857cd60f$var$hostParent = deletedFiber.stateNode.containerInfo;
            $997a9c03857cd60f$var$hostParentIsContainer = !0;
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $997a9c03857cd60f$var$hostParent = prevHostParent;
            $997a9c03857cd60f$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $997a9c03857cd60f$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden || $997a9c03857cd60f$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden || ($997a9c03857cd60f$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $997a9c03857cd60f$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden = (prevHostParent = $997a9c03857cd60f$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $997a9c03857cd60f$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $997a9c03857cd60f$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $997a9c03857cd60f$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $997a9c03857cd60f$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $997a9c03857cd60f$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $997a9c03857cd60f$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $997a9c03857cd60f$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $997a9c03857cd60f$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $997a9c03857cd60f$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $997a9c03857cd60f$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $997a9c03857cd60f$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($997a9c03857cd60f$var$isSingletonScope(parent.type)) {
                        $997a9c03857cd60f$var$hostParent = parent.stateNode;
                        $997a9c03857cd60f$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $997a9c03857cd60f$var$hostParent = parent.stateNode;
                    $997a9c03857cd60f$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $997a9c03857cd60f$var$hostParent = parent.stateNode.containerInfo;
                    $997a9c03857cd60f$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $997a9c03857cd60f$var$hostParent) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(160));
        $997a9c03857cd60f$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $997a9c03857cd60f$var$hostParent = null;
        $997a9c03857cd60f$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$997a9c03857cd60f$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $997a9c03857cd60f$var$currentHoistableRoot = null;
function $997a9c03857cd60f$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($997a9c03857cd60f$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $997a9c03857cd60f$var$commitHookEffectListMount(3, finishedWork), $997a9c03857cd60f$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($997a9c03857cd60f$var$offscreenSubtreeWasHidden || null === current || $997a9c03857cd60f$var$safelyDetachRef(current, current.return));
            flags & 64 && $997a9c03857cd60f$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $997a9c03857cd60f$var$currentHoistableRoot;
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($997a9c03857cd60f$var$offscreenSubtreeWasHidden || null === current || $997a9c03857cd60f$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$997a9c03857cd60f$var$internalHoistableMarker] || currentResource[$997a9c03857cd60f$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $997a9c03857cd60f$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$997a9c03857cd60f$var$internalInstanceKey] = finishedWork;
                                        $997a9c03857cd60f$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $997a9c03857cd60f$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $997a9c03857cd60f$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $997a9c03857cd60f$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $997a9c03857cd60f$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($997a9c03857cd60f$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$997a9c03857cd60f$var$internalInstanceKey] = finishedWork;
                                $997a9c03857cd60f$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $997a9c03857cd60f$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $997a9c03857cd60f$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $997a9c03857cd60f$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $997a9c03857cd60f$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $997a9c03857cd60f$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($997a9c03857cd60f$var$offscreenSubtreeWasHidden || null === current || $997a9c03857cd60f$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $997a9c03857cd60f$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($997a9c03857cd60f$var$offscreenSubtreeWasHidden || null === current || $997a9c03857cd60f$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $997a9c03857cd60f$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $997a9c03857cd60f$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($997a9c03857cd60f$var$needsFormReset = !0);
            break;
        case 6:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $997a9c03857cd60f$var$tagCaches = null;
            hoistableRoot = $997a9c03857cd60f$var$currentHoistableRoot;
            $997a9c03857cd60f$var$currentHoistableRoot = $997a9c03857cd60f$var$getHoistableRoot(root.containerInfo);
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$currentHoistableRoot = hoistableRoot;
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $997a9c03857cd60f$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $997a9c03857cd60f$var$needsFormReset && ($997a9c03857cd60f$var$needsFormReset = !1, $997a9c03857cd60f$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $997a9c03857cd60f$var$currentHoistableRoot;
            $997a9c03857cd60f$var$currentHoistableRoot = $997a9c03857cd60f$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            $997a9c03857cd60f$var$currentHoistableRoot = flags;
            break;
        case 12:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $997a9c03857cd60f$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($997a9c03857cd60f$var$globalMostRecentFallbackTime = $997a9c03857cd60f$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $997a9c03857cd60f$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $997a9c03857cd60f$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $997a9c03857cd60f$var$offscreenSubtreeWasHidden;
            $997a9c03857cd60f$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $997a9c03857cd60f$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $997a9c03857cd60f$var$offscreenSubtreeIsHidden || $997a9c03857cd60f$var$offscreenSubtreeWasHidden || $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $997a9c03857cd60f$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $997a9c03857cd60f$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $997a9c03857cd60f$var$hideOrUnhideDehydratedBoundary(instance, !0) : $997a9c03857cd60f$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $997a9c03857cd60f$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $997a9c03857cd60f$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $997a9c03857cd60f$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $997a9c03857cd60f$var$recursivelyTraverseMutationEffects(root, finishedWork), $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork);
    }
}
function $997a9c03857cd60f$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($997a9c03857cd60f$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $997a9c03857cd60f$var$getHostSibling(finishedWork);
                    $997a9c03857cd60f$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($997a9c03857cd60f$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $997a9c03857cd60f$var$getHostSibling(finishedWork);
                    $997a9c03857cd60f$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $997a9c03857cd60f$var$getHostSibling(finishedWork);
                    $997a9c03857cd60f$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $997a9c03857cd60f$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $997a9c03857cd60f$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $997a9c03857cd60f$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$997a9c03857cd60f$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $997a9c03857cd60f$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $997a9c03857cd60f$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $997a9c03857cd60f$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $997a9c03857cd60f$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $997a9c03857cd60f$var$safelyDetachRef(finishedWork, finishedWork.return);
                $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $997a9c03857cd60f$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $997a9c03857cd60f$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$997a9c03857cd60f$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $997a9c03857cd60f$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $997a9c03857cd60f$var$commitClassCallbacks(finishedWork);
                $997a9c03857cd60f$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $997a9c03857cd60f$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $997a9c03857cd60f$var$commitHostMount(finishedWork);
                $997a9c03857cd60f$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $997a9c03857cd60f$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $997a9c03857cd60f$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $997a9c03857cd60f$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $997a9c03857cd60f$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $997a9c03857cd60f$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $997a9c03857cd60f$var$releaseCache(previousCache));
}
function $997a9c03857cd60f$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $997a9c03857cd60f$var$releaseCache(current));
}
function $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$997a9c03857cd60f$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $997a9c03857cd60f$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $997a9c03857cd60f$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $997a9c03857cd60f$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $997a9c03857cd60f$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $997a9c03857cd60f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $997a9c03857cd60f$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $997a9c03857cd60f$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $997a9c03857cd60f$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $997a9c03857cd60f$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $997a9c03857cd60f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $997a9c03857cd60f$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $997a9c03857cd60f$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $997a9c03857cd60f$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $997a9c03857cd60f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $997a9c03857cd60f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $997a9c03857cd60f$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $997a9c03857cd60f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $997a9c03857cd60f$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $997a9c03857cd60f$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $997a9c03857cd60f$var$suspenseyCommitFlag = 8192;
function $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $997a9c03857cd60f$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$997a9c03857cd60f$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $997a9c03857cd60f$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $997a9c03857cd60f$var$suspenseyCommitFlag && null !== fiber.memoizedState && $997a9c03857cd60f$var$suspendResource(suspendedState, $997a9c03857cd60f$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $997a9c03857cd60f$var$currentHoistableRoot;
            $997a9c03857cd60f$var$currentHoistableRoot = $997a9c03857cd60f$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $997a9c03857cd60f$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $997a9c03857cd60f$var$suspenseyCommitFlag, $997a9c03857cd60f$var$suspenseyCommitFlag = 16777216, $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $997a9c03857cd60f$var$suspenseyCommitFlag = previousHoistableRoot) : $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $997a9c03857cd60f$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $997a9c03857cd60f$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $997a9c03857cd60f$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $997a9c03857cd60f$var$nextEffect = childToDelete;
            $997a9c03857cd60f$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $997a9c03857cd60f$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$997a9c03857cd60f$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $997a9c03857cd60f$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $997a9c03857cd60f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $997a9c03857cd60f$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $997a9c03857cd60f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $997a9c03857cd60f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $997a9c03857cd60f$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $997a9c03857cd60f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $997a9c03857cd60f$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $997a9c03857cd60f$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $997a9c03857cd60f$var$nextEffect = childToDelete;
            $997a9c03857cd60f$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $997a9c03857cd60f$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $997a9c03857cd60f$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $997a9c03857cd60f$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $997a9c03857cd60f$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $997a9c03857cd60f$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $997a9c03857cd60f$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $997a9c03857cd60f$var$nextEffect;){
        var fiber = $997a9c03857cd60f$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $997a9c03857cd60f$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $997a9c03857cd60f$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $997a9c03857cd60f$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $997a9c03857cd60f$var$nextEffect;){
            cache = $997a9c03857cd60f$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $997a9c03857cd60f$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $997a9c03857cd60f$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $997a9c03857cd60f$var$nextEffect = sibling;
                break a;
            }
            $997a9c03857cd60f$var$nextEffect = returnFiber;
        }
    }
}
var $997a9c03857cd60f$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $997a9c03857cd60f$var$readContext($997a9c03857cd60f$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $997a9c03857cd60f$var$readContext($997a9c03857cd60f$var$CacheContext).controller.signal;
    }
}, $997a9c03857cd60f$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $997a9c03857cd60f$var$executionContext = 0, $997a9c03857cd60f$var$workInProgressRoot = null, $997a9c03857cd60f$var$workInProgress = null, $997a9c03857cd60f$var$workInProgressRootRenderLanes = 0, $997a9c03857cd60f$var$workInProgressSuspendedReason = 0, $997a9c03857cd60f$var$workInProgressThrownValue = null, $997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings = !1, $997a9c03857cd60f$var$workInProgressRootIsPrerendering = !1, $997a9c03857cd60f$var$workInProgressRootDidAttachPingListener = !1, $997a9c03857cd60f$var$entangledRenderLanes = 0, $997a9c03857cd60f$var$workInProgressRootExitStatus = 0, $997a9c03857cd60f$var$workInProgressRootSkippedLanes = 0, $997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes = 0, $997a9c03857cd60f$var$workInProgressRootPingedLanes = 0, $997a9c03857cd60f$var$workInProgressDeferredLane = 0, $997a9c03857cd60f$var$workInProgressSuspendedRetryLanes = 0, $997a9c03857cd60f$var$workInProgressRootConcurrentErrors = null, $997a9c03857cd60f$var$workInProgressRootRecoverableErrors = null, $997a9c03857cd60f$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $997a9c03857cd60f$var$globalMostRecentFallbackTime = 0, $997a9c03857cd60f$var$globalMostRecentTransitionTime = 0, $997a9c03857cd60f$var$workInProgressRootRenderTargetTime = Infinity, $997a9c03857cd60f$var$workInProgressTransitions = null, $997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed = null, $997a9c03857cd60f$var$pendingEffectsStatus = 0, $997a9c03857cd60f$var$pendingEffectsRoot = null, $997a9c03857cd60f$var$pendingFinishedWork = null, $997a9c03857cd60f$var$pendingEffectsLanes = 0, $997a9c03857cd60f$var$pendingEffectsRemainingLanes = 0, $997a9c03857cd60f$var$pendingPassiveTransitions = null, $997a9c03857cd60f$var$pendingRecoverableErrors = null, $997a9c03857cd60f$var$nestedUpdateCount = 0, $997a9c03857cd60f$var$rootWithNestedUpdates = null;
function $997a9c03857cd60f$var$requestUpdateLane() {
    return 0 !== ($997a9c03857cd60f$var$executionContext & 2) && 0 !== $997a9c03857cd60f$var$workInProgressRootRenderLanes ? $997a9c03857cd60f$var$workInProgressRootRenderLanes & -$997a9c03857cd60f$var$workInProgressRootRenderLanes : null !== $997a9c03857cd60f$var$ReactSharedInternals.T ? $997a9c03857cd60f$var$requestTransitionLane() : $997a9c03857cd60f$var$resolveUpdatePriority();
}
function $997a9c03857cd60f$var$requestDeferredLane() {
    if (0 === $997a9c03857cd60f$var$workInProgressDeferredLane) {
        if (0 === ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 536870912) || $997a9c03857cd60f$var$isHydrating) {
            var lane = $997a9c03857cd60f$var$nextTransitionDeferredLane;
            $997a9c03857cd60f$var$nextTransitionDeferredLane <<= 1;
            0 === ($997a9c03857cd60f$var$nextTransitionDeferredLane & 3932160) && ($997a9c03857cd60f$var$nextTransitionDeferredLane = 262144);
            $997a9c03857cd60f$var$workInProgressDeferredLane = lane;
        } else $997a9c03857cd60f$var$workInProgressDeferredLane = 536870912;
    }
    lane = $997a9c03857cd60f$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $997a9c03857cd60f$var$workInProgressDeferredLane;
}
function $997a9c03857cd60f$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $997a9c03857cd60f$var$workInProgressRoot && (2 === $997a9c03857cd60f$var$workInProgressSuspendedReason || 9 === $997a9c03857cd60f$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $997a9c03857cd60f$var$prepareFreshStack(root, 0), $997a9c03857cd60f$var$markRootSuspended(root, $997a9c03857cd60f$var$workInProgressRootRenderLanes, $997a9c03857cd60f$var$workInProgressDeferredLane, !1);
    $997a9c03857cd60f$var$markRootUpdated$1(root, lane);
    if (0 === ($997a9c03857cd60f$var$executionContext & 2) || root !== $997a9c03857cd60f$var$workInProgressRoot) root === $997a9c03857cd60f$var$workInProgressRoot && (0 === ($997a9c03857cd60f$var$executionContext & 2) && ($997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $997a9c03857cd60f$var$workInProgressRootExitStatus && $997a9c03857cd60f$var$markRootSuspended(root, $997a9c03857cd60f$var$workInProgressRootRenderLanes, $997a9c03857cd60f$var$workInProgressDeferredLane, !1)), $997a9c03857cd60f$var$ensureRootIsScheduled(root);
}
function $997a9c03857cd60f$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($997a9c03857cd60f$var$executionContext & 6)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $997a9c03857cd60f$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $997a9c03857cd60f$var$renderRootConcurrent(root$jscomp$0, lanes) : $997a9c03857cd60f$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $997a9c03857cd60f$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $997a9c03857cd60f$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$997a9c03857cd60f$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $997a9c03857cd60f$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $997a9c03857cd60f$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($997a9c03857cd60f$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $997a9c03857cd60f$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($997a9c03857cd60f$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $997a9c03857cd60f$var$workInProgressRootRecoverableErrors;
                            $997a9c03857cd60f$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $997a9c03857cd60f$var$workInProgressRootRecoverableErrors ? $997a9c03857cd60f$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $997a9c03857cd60f$var$workInProgressRootRecoverableErrors.push.apply($997a9c03857cd60f$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $997a9c03857cd60f$var$prepareFreshStack(root$jscomp$0, 0);
                $997a9c03857cd60f$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($997a9c03857cd60f$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $997a9c03857cd60f$var$markRootSuspended(shouldTimeSlice, lanes, $997a9c03857cd60f$var$workInProgressDeferredLane, !$997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $997a9c03857cd60f$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($997a9c03857cd60f$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $997a9c03857cd60f$var$globalMostRecentFallbackTime + 300 - $997a9c03857cd60f$var$now(), 10 < exitStatus)) {
                    $997a9c03857cd60f$var$markRootSuspended(shouldTimeSlice, lanes, $997a9c03857cd60f$var$workInProgressDeferredLane, !$997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $997a9c03857cd60f$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $997a9c03857cd60f$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $997a9c03857cd60f$var$scheduleTimeout($997a9c03857cd60f$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $997a9c03857cd60f$var$workInProgressRootRecoverableErrors, $997a9c03857cd60f$var$workInProgressTransitions, $997a9c03857cd60f$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $997a9c03857cd60f$var$workInProgressDeferredLane, $997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes, $997a9c03857cd60f$var$workInProgressSuspendedRetryLanes, $997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $997a9c03857cd60f$var$commitRootWhenReady(shouldTimeSlice, forceSync, $997a9c03857cd60f$var$workInProgressRootRecoverableErrors, $997a9c03857cd60f$var$workInProgressTransitions, $997a9c03857cd60f$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $997a9c03857cd60f$var$workInProgressDeferredLane, $997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes, $997a9c03857cd60f$var$workInProgressSuspendedRetryLanes, $997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $997a9c03857cd60f$var$ensureRootIsScheduled(root$jscomp$0);
}
function $997a9c03857cd60f$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $997a9c03857cd60f$var$noop$1
        };
        $997a9c03857cd60f$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $997a9c03857cd60f$var$globalMostRecentFallbackTime - $997a9c03857cd60f$var$now() : (lanes & 4194048) === lanes ? $997a9c03857cd60f$var$globalMostRecentTransitionTime - $997a9c03857cd60f$var$now() : 0;
        timeoutOffset = $997a9c03857cd60f$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $997a9c03857cd60f$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($997a9c03857cd60f$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $997a9c03857cd60f$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $997a9c03857cd60f$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $997a9c03857cd60f$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$997a9c03857cd60f$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $997a9c03857cd60f$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$997a9c03857cd60f$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $997a9c03857cd60f$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $997a9c03857cd60f$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $997a9c03857cd60f$var$flushSyncWork$1() {
    return 0 === ($997a9c03857cd60f$var$executionContext & 6) ? ($997a9c03857cd60f$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $997a9c03857cd60f$var$resetWorkInProgressStack() {
    if (null !== $997a9c03857cd60f$var$workInProgress) {
        if (0 === $997a9c03857cd60f$var$workInProgressSuspendedReason) var interruptedWork = $997a9c03857cd60f$var$workInProgress.return;
        else interruptedWork = $997a9c03857cd60f$var$workInProgress, $997a9c03857cd60f$var$lastContextDependency = $997a9c03857cd60f$var$currentlyRenderingFiber$1 = null, $997a9c03857cd60f$var$resetHooksOnUnwind(interruptedWork), $997a9c03857cd60f$var$thenableState$1 = null, $997a9c03857cd60f$var$thenableIndexCounter$1 = 0, interruptedWork = $997a9c03857cd60f$var$workInProgress;
        for(; null !== interruptedWork;)$997a9c03857cd60f$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $997a9c03857cd60f$var$workInProgress = null;
    }
}
function $997a9c03857cd60f$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $997a9c03857cd60f$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $997a9c03857cd60f$var$pendingEffectsLanes = 0;
    $997a9c03857cd60f$var$resetWorkInProgressStack();
    $997a9c03857cd60f$var$workInProgressRoot = root;
    $997a9c03857cd60f$var$workInProgress = timeoutHandle = $997a9c03857cd60f$var$createWorkInProgress(root.current, null);
    $997a9c03857cd60f$var$workInProgressRootRenderLanes = lanes;
    $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
    $997a9c03857cd60f$var$workInProgressThrownValue = null;
    $997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $997a9c03857cd60f$var$workInProgressRootIsPrerendering = $997a9c03857cd60f$var$checkIfRootIsPrerendering(root, lanes);
    $997a9c03857cd60f$var$workInProgressRootDidAttachPingListener = !1;
    $997a9c03857cd60f$var$workInProgressSuspendedRetryLanes = $997a9c03857cd60f$var$workInProgressDeferredLane = $997a9c03857cd60f$var$workInProgressRootPingedLanes = $997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes = $997a9c03857cd60f$var$workInProgressRootSkippedLanes = $997a9c03857cd60f$var$workInProgressRootExitStatus = 0;
    $997a9c03857cd60f$var$workInProgressRootRecoverableErrors = $997a9c03857cd60f$var$workInProgressRootConcurrentErrors = null;
    $997a9c03857cd60f$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $997a9c03857cd60f$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $997a9c03857cd60f$var$entangledRenderLanes = lanes;
    $997a9c03857cd60f$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $997a9c03857cd60f$var$handleThrow(root, thrownValue) {
    $997a9c03857cd60f$var$currentlyRenderingFiber = null;
    $997a9c03857cd60f$var$ReactSharedInternals.H = $997a9c03857cd60f$var$ContextOnlyDispatcher;
    thrownValue === $997a9c03857cd60f$var$SuspenseException || thrownValue === $997a9c03857cd60f$var$SuspenseActionException ? (thrownValue = $997a9c03857cd60f$var$getSuspendedThenable(), $997a9c03857cd60f$var$workInProgressSuspendedReason = 3) : thrownValue === $997a9c03857cd60f$var$SuspenseyCommitException ? (thrownValue = $997a9c03857cd60f$var$getSuspendedThenable(), $997a9c03857cd60f$var$workInProgressSuspendedReason = 4) : $997a9c03857cd60f$var$workInProgressSuspendedReason = thrownValue === $997a9c03857cd60f$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $997a9c03857cd60f$var$workInProgressThrownValue = thrownValue;
    null === $997a9c03857cd60f$var$workInProgress && ($997a9c03857cd60f$var$workInProgressRootExitStatus = 1, $997a9c03857cd60f$var$logUncaughtError(root, $997a9c03857cd60f$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $997a9c03857cd60f$var$shouldRemainOnPreviousScreen() {
    var handler = $997a9c03857cd60f$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 4194048) === $997a9c03857cd60f$var$workInProgressRootRenderLanes ? null === $997a9c03857cd60f$var$shellBoundary ? !0 : !1 : ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 62914560) === $997a9c03857cd60f$var$workInProgressRootRenderLanes || 0 !== ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 536870912) ? handler === $997a9c03857cd60f$var$shellBoundary : !1;
}
function $997a9c03857cd60f$var$pushDispatcher() {
    var prevDispatcher = $997a9c03857cd60f$var$ReactSharedInternals.H;
    $997a9c03857cd60f$var$ReactSharedInternals.H = $997a9c03857cd60f$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $997a9c03857cd60f$var$ContextOnlyDispatcher : prevDispatcher;
}
function $997a9c03857cd60f$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $997a9c03857cd60f$var$ReactSharedInternals.A;
    $997a9c03857cd60f$var$ReactSharedInternals.A = $997a9c03857cd60f$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $997a9c03857cd60f$var$renderDidSuspendDelayIfPossible() {
    $997a9c03857cd60f$var$workInProgressRootExitStatus = 4;
    $997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings || ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 4194048) !== $997a9c03857cd60f$var$workInProgressRootRenderLanes && null !== $997a9c03857cd60f$var$suspenseHandlerStackCursor.current || ($997a9c03857cd60f$var$workInProgressRootIsPrerendering = !0);
    0 === ($997a9c03857cd60f$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($997a9c03857cd60f$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $997a9c03857cd60f$var$workInProgressRoot || $997a9c03857cd60f$var$markRootSuspended($997a9c03857cd60f$var$workInProgressRoot, $997a9c03857cd60f$var$workInProgressRootRenderLanes, $997a9c03857cd60f$var$workInProgressDeferredLane, !1);
}
function $997a9c03857cd60f$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $997a9c03857cd60f$var$executionContext;
    $997a9c03857cd60f$var$executionContext |= 2;
    var prevDispatcher = $997a9c03857cd60f$var$pushDispatcher(), prevAsyncDispatcher = $997a9c03857cd60f$var$pushAsyncDispatcher();
    if ($997a9c03857cd60f$var$workInProgressRoot !== root || $997a9c03857cd60f$var$workInProgressRootRenderLanes !== lanes) $997a9c03857cd60f$var$workInProgressTransitions = null, $997a9c03857cd60f$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $997a9c03857cd60f$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $997a9c03857cd60f$var$workInProgressSuspendedReason && null !== $997a9c03857cd60f$var$workInProgress) {
            var unitOfWork = $997a9c03857cd60f$var$workInProgress, thrownValue = $997a9c03857cd60f$var$workInProgressThrownValue;
            switch($997a9c03857cd60f$var$workInProgressSuspendedReason){
                case 8:
                    $997a9c03857cd60f$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $997a9c03857cd60f$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $997a9c03857cd60f$var$workInProgressSuspendedReason;
                    $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
                    $997a9c03857cd60f$var$workInProgressThrownValue = null;
                    $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $997a9c03857cd60f$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $997a9c03857cd60f$var$workInProgressSuspendedReason, $997a9c03857cd60f$var$workInProgressSuspendedReason = 0, $997a9c03857cd60f$var$workInProgressThrownValue = null, $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $997a9c03857cd60f$var$workLoopSync();
        exitStatus = $997a9c03857cd60f$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $997a9c03857cd60f$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $997a9c03857cd60f$var$lastContextDependency = $997a9c03857cd60f$var$currentlyRenderingFiber$1 = null;
    $997a9c03857cd60f$var$executionContext = prevExecutionContext;
    $997a9c03857cd60f$var$ReactSharedInternals.H = prevDispatcher;
    $997a9c03857cd60f$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $997a9c03857cd60f$var$workInProgress && ($997a9c03857cd60f$var$workInProgressRoot = null, $997a9c03857cd60f$var$workInProgressRootRenderLanes = 0, $997a9c03857cd60f$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $997a9c03857cd60f$var$workLoopSync() {
    for(; null !== $997a9c03857cd60f$var$workInProgress;)$997a9c03857cd60f$var$performUnitOfWork($997a9c03857cd60f$var$workInProgress);
}
function $997a9c03857cd60f$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $997a9c03857cd60f$var$executionContext;
    $997a9c03857cd60f$var$executionContext |= 2;
    var prevDispatcher = $997a9c03857cd60f$var$pushDispatcher(), prevAsyncDispatcher = $997a9c03857cd60f$var$pushAsyncDispatcher();
    $997a9c03857cd60f$var$workInProgressRoot !== root || $997a9c03857cd60f$var$workInProgressRootRenderLanes !== lanes ? ($997a9c03857cd60f$var$workInProgressTransitions = null, $997a9c03857cd60f$var$workInProgressRootRenderTargetTime = $997a9c03857cd60f$var$now() + 500, $997a9c03857cd60f$var$prepareFreshStack(root, lanes)) : $997a9c03857cd60f$var$workInProgressRootIsPrerendering = $997a9c03857cd60f$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $997a9c03857cd60f$var$workInProgressSuspendedReason && null !== $997a9c03857cd60f$var$workInProgress) {
            lanes = $997a9c03857cd60f$var$workInProgress;
            var thrownValue = $997a9c03857cd60f$var$workInProgressThrownValue;
            b: switch($997a9c03857cd60f$var$workInProgressSuspendedReason){
                case 1:
                    $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
                    $997a9c03857cd60f$var$workInProgressThrownValue = null;
                    $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($997a9c03857cd60f$var$isThenableResolved(thrownValue)) {
                        $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
                        $997a9c03857cd60f$var$workInProgressThrownValue = null;
                        $997a9c03857cd60f$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $997a9c03857cd60f$var$workInProgressSuspendedReason && 9 !== $997a9c03857cd60f$var$workInProgressSuspendedReason || $997a9c03857cd60f$var$workInProgressRoot !== root || ($997a9c03857cd60f$var$workInProgressSuspendedReason = 7);
                        $997a9c03857cd60f$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $997a9c03857cd60f$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $997a9c03857cd60f$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $997a9c03857cd60f$var$isThenableResolved(thrownValue) ? ($997a9c03857cd60f$var$workInProgressSuspendedReason = 0, $997a9c03857cd60f$var$workInProgressThrownValue = null, $997a9c03857cd60f$var$replaySuspendedUnitOfWork(lanes)) : ($997a9c03857cd60f$var$workInProgressSuspendedReason = 0, $997a9c03857cd60f$var$workInProgressThrownValue = null, $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($997a9c03857cd60f$var$workInProgress.tag){
                        case 26:
                            resource = $997a9c03857cd60f$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $997a9c03857cd60f$var$workInProgress;
                            if (resource ? $997a9c03857cd60f$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
                                $997a9c03857cd60f$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $997a9c03857cd60f$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($997a9c03857cd60f$var$workInProgress = returnFiber, $997a9c03857cd60f$var$completeUnitOfWork(returnFiber)) : $997a9c03857cd60f$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
                    $997a9c03857cd60f$var$workInProgressThrownValue = null;
                    $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $997a9c03857cd60f$var$workInProgressSuspendedReason = 0;
                    $997a9c03857cd60f$var$workInProgressThrownValue = null;
                    $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $997a9c03857cd60f$var$resetWorkInProgressStack();
                    $997a9c03857cd60f$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(462));
            }
        }
        $997a9c03857cd60f$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $997a9c03857cd60f$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $997a9c03857cd60f$var$lastContextDependency = $997a9c03857cd60f$var$currentlyRenderingFiber$1 = null;
    $997a9c03857cd60f$var$ReactSharedInternals.H = prevDispatcher;
    $997a9c03857cd60f$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $997a9c03857cd60f$var$executionContext = prevExecutionContext;
    if (null !== $997a9c03857cd60f$var$workInProgress) return 0;
    $997a9c03857cd60f$var$workInProgressRoot = null;
    $997a9c03857cd60f$var$workInProgressRootRenderLanes = 0;
    $997a9c03857cd60f$var$finishQueueingConcurrentUpdates();
    return $997a9c03857cd60f$var$workInProgressRootExitStatus;
}
function $997a9c03857cd60f$var$workLoopConcurrentByScheduler() {
    for(; null !== $997a9c03857cd60f$var$workInProgress && !$997a9c03857cd60f$var$shouldYield();)$997a9c03857cd60f$var$performUnitOfWork($997a9c03857cd60f$var$workInProgress);
}
function $997a9c03857cd60f$var$performUnitOfWork(unitOfWork) {
    var next = $997a9c03857cd60f$var$beginWork(unitOfWork.alternate, unitOfWork, $997a9c03857cd60f$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $997a9c03857cd60f$var$completeUnitOfWork(unitOfWork) : $997a9c03857cd60f$var$workInProgress = next;
}
function $997a9c03857cd60f$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $997a9c03857cd60f$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $997a9c03857cd60f$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $997a9c03857cd60f$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $997a9c03857cd60f$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $997a9c03857cd60f$var$resetHooksOnUnwind(next);
        default:
            $997a9c03857cd60f$var$unwindInterruptedWork(current, next), next = $997a9c03857cd60f$var$workInProgress = $997a9c03857cd60f$var$resetWorkInProgress(next, $997a9c03857cd60f$var$entangledRenderLanes), next = $997a9c03857cd60f$var$beginWork(current, next, $997a9c03857cd60f$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $997a9c03857cd60f$var$completeUnitOfWork(unitOfWork) : $997a9c03857cd60f$var$workInProgress = next;
}
function $997a9c03857cd60f$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $997a9c03857cd60f$var$lastContextDependency = $997a9c03857cd60f$var$currentlyRenderingFiber$1 = null;
    $997a9c03857cd60f$var$resetHooksOnUnwind(unitOfWork);
    $997a9c03857cd60f$var$thenableState$1 = null;
    $997a9c03857cd60f$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($997a9c03857cd60f$var$throwException(root, returnFiber, unitOfWork, thrownValue, $997a9c03857cd60f$var$workInProgressRootRenderLanes)) {
            $997a9c03857cd60f$var$workInProgressRootExitStatus = 1;
            $997a9c03857cd60f$var$logUncaughtError(root, $997a9c03857cd60f$var$createCapturedValueAtFiber(thrownValue, root.current));
            $997a9c03857cd60f$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $997a9c03857cd60f$var$workInProgress = returnFiber, error;
        $997a9c03857cd60f$var$workInProgressRootExitStatus = 1;
        $997a9c03857cd60f$var$logUncaughtError(root, $997a9c03857cd60f$var$createCapturedValueAtFiber(thrownValue, root.current));
        $997a9c03857cd60f$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($997a9c03857cd60f$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($997a9c03857cd60f$var$workInProgressRootIsPrerendering || 0 !== ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $997a9c03857cd60f$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $997a9c03857cd60f$var$unwindUnitOfWork(unitOfWork, root);
    } else $997a9c03857cd60f$var$completeUnitOfWork(unitOfWork);
}
function $997a9c03857cd60f$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $997a9c03857cd60f$var$unwindUnitOfWork(completedWork, $997a9c03857cd60f$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $997a9c03857cd60f$var$completeWork(completedWork.alternate, completedWork, $997a9c03857cd60f$var$entangledRenderLanes);
        if (null !== next) {
            $997a9c03857cd60f$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $997a9c03857cd60f$var$workInProgress = completedWork;
            return;
        }
        $997a9c03857cd60f$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $997a9c03857cd60f$var$workInProgressRootExitStatus && ($997a9c03857cd60f$var$workInProgressRootExitStatus = 5);
}
function $997a9c03857cd60f$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $997a9c03857cd60f$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $997a9c03857cd60f$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $997a9c03857cd60f$var$workInProgress = unitOfWork;
            return;
        }
        $997a9c03857cd60f$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $997a9c03857cd60f$var$workInProgressRootExitStatus = 6;
    $997a9c03857cd60f$var$workInProgress = null;
}
function $997a9c03857cd60f$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $997a9c03857cd60f$var$flushPendingEffects();
    while (0 !== $997a9c03857cd60f$var$pendingEffectsStatus);
    if (0 !== ($997a9c03857cd60f$var$executionContext & 6)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $997a9c03857cd60f$var$concurrentlyUpdatedLanes;
        $997a9c03857cd60f$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $997a9c03857cd60f$var$workInProgressRoot && ($997a9c03857cd60f$var$workInProgress = $997a9c03857cd60f$var$workInProgressRoot = null, $997a9c03857cd60f$var$workInProgressRootRenderLanes = 0);
        $997a9c03857cd60f$var$pendingFinishedWork = finishedWork;
        $997a9c03857cd60f$var$pendingEffectsRoot = root;
        $997a9c03857cd60f$var$pendingEffectsLanes = lanes;
        $997a9c03857cd60f$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $997a9c03857cd60f$var$pendingPassiveTransitions = transitions;
        $997a9c03857cd60f$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $997a9c03857cd60f$var$scheduleCallback$1($997a9c03857cd60f$var$NormalPriority$1, function() {
            $997a9c03857cd60f$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $997a9c03857cd60f$var$ReactSharedInternals.T;
            $997a9c03857cd60f$var$ReactSharedInternals.T = null;
            transitions = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
            $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $997a9c03857cd60f$var$executionContext;
            $997a9c03857cd60f$var$executionContext |= 4;
            try {
                $997a9c03857cd60f$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $997a9c03857cd60f$var$executionContext = spawnedLane, $997a9c03857cd60f$var$ReactDOMSharedInternals.p = transitions, $997a9c03857cd60f$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $997a9c03857cd60f$var$pendingEffectsStatus = 1;
        $997a9c03857cd60f$var$flushMutationEffects();
        $997a9c03857cd60f$var$flushLayoutEffects();
        $997a9c03857cd60f$var$flushSpawnedWork();
    }
}
function $997a9c03857cd60f$var$flushMutationEffects() {
    if (1 === $997a9c03857cd60f$var$pendingEffectsStatus) {
        $997a9c03857cd60f$var$pendingEffectsStatus = 0;
        var root = $997a9c03857cd60f$var$pendingEffectsRoot, finishedWork = $997a9c03857cd60f$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $997a9c03857cd60f$var$ReactSharedInternals.T;
            $997a9c03857cd60f$var$ReactSharedInternals.T = null;
            var previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
            $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $997a9c03857cd60f$var$executionContext;
            $997a9c03857cd60f$var$executionContext |= 4;
            try {
                $997a9c03857cd60f$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $997a9c03857cd60f$var$selectionInformation, curFocusedElem = $997a9c03857cd60f$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $997a9c03857cd60f$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $997a9c03857cd60f$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $997a9c03857cd60f$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $997a9c03857cd60f$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $997a9c03857cd60f$var$_enabled = !!$997a9c03857cd60f$var$eventsEnabled;
                $997a9c03857cd60f$var$selectionInformation = $997a9c03857cd60f$var$eventsEnabled = null;
            } finally{
                $997a9c03857cd60f$var$executionContext = prevExecutionContext, $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority, $997a9c03857cd60f$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $997a9c03857cd60f$var$pendingEffectsStatus = 2;
    }
}
function $997a9c03857cd60f$var$flushLayoutEffects() {
    if (2 === $997a9c03857cd60f$var$pendingEffectsStatus) {
        $997a9c03857cd60f$var$pendingEffectsStatus = 0;
        var root = $997a9c03857cd60f$var$pendingEffectsRoot, finishedWork = $997a9c03857cd60f$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $997a9c03857cd60f$var$ReactSharedInternals.T;
            $997a9c03857cd60f$var$ReactSharedInternals.T = null;
            var previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
            $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $997a9c03857cd60f$var$executionContext;
            $997a9c03857cd60f$var$executionContext |= 4;
            try {
                $997a9c03857cd60f$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $997a9c03857cd60f$var$executionContext = prevExecutionContext, $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority, $997a9c03857cd60f$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $997a9c03857cd60f$var$pendingEffectsStatus = 3;
    }
}
function $997a9c03857cd60f$var$flushSpawnedWork() {
    if (4 === $997a9c03857cd60f$var$pendingEffectsStatus || 3 === $997a9c03857cd60f$var$pendingEffectsStatus) {
        $997a9c03857cd60f$var$pendingEffectsStatus = 0;
        $997a9c03857cd60f$var$requestPaint();
        var root = $997a9c03857cd60f$var$pendingEffectsRoot, finishedWork = $997a9c03857cd60f$var$pendingFinishedWork, lanes = $997a9c03857cd60f$var$pendingEffectsLanes, recoverableErrors = $997a9c03857cd60f$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $997a9c03857cd60f$var$pendingEffectsStatus = 5 : ($997a9c03857cd60f$var$pendingEffectsStatus = 0, $997a9c03857cd60f$var$pendingFinishedWork = $997a9c03857cd60f$var$pendingEffectsRoot = null, $997a9c03857cd60f$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $997a9c03857cd60f$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($997a9c03857cd60f$var$injectedHook && "function" === typeof $997a9c03857cd60f$var$injectedHook.onCommitFiberRoot) try {
            $997a9c03857cd60f$var$injectedHook.onCommitFiberRoot($997a9c03857cd60f$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $997a9c03857cd60f$var$ReactSharedInternals.T;
            remainingLanes = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
            $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 2;
            $997a9c03857cd60f$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $997a9c03857cd60f$var$ReactSharedInternals.T = finishedWork, $997a9c03857cd60f$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($997a9c03857cd60f$var$pendingEffectsLanes & 3) && $997a9c03857cd60f$var$flushPendingEffects();
        $997a9c03857cd60f$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $997a9c03857cd60f$var$rootWithNestedUpdates ? $997a9c03857cd60f$var$nestedUpdateCount++ : ($997a9c03857cd60f$var$nestedUpdateCount = 0, $997a9c03857cd60f$var$rootWithNestedUpdates = root) : $997a9c03857cd60f$var$nestedUpdateCount = 0;
        $997a9c03857cd60f$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $997a9c03857cd60f$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $997a9c03857cd60f$var$releaseCache(remainingLanes)));
}
function $997a9c03857cd60f$var$flushPendingEffects() {
    $997a9c03857cd60f$var$flushMutationEffects();
    $997a9c03857cd60f$var$flushLayoutEffects();
    $997a9c03857cd60f$var$flushSpawnedWork();
    return $997a9c03857cd60f$var$flushPassiveEffects();
}
function $997a9c03857cd60f$var$flushPassiveEffects() {
    if (5 !== $997a9c03857cd60f$var$pendingEffectsStatus) return !1;
    var root = $997a9c03857cd60f$var$pendingEffectsRoot, remainingLanes = $997a9c03857cd60f$var$pendingEffectsRemainingLanes;
    $997a9c03857cd60f$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $997a9c03857cd60f$var$lanesToEventPriority($997a9c03857cd60f$var$pendingEffectsLanes), prevTransition = $997a9c03857cd60f$var$ReactSharedInternals.T, previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
    try {
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $997a9c03857cd60f$var$ReactSharedInternals.T = null;
        renderPriority = $997a9c03857cd60f$var$pendingPassiveTransitions;
        $997a9c03857cd60f$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $997a9c03857cd60f$var$pendingEffectsRoot, lanes = $997a9c03857cd60f$var$pendingEffectsLanes;
        $997a9c03857cd60f$var$pendingEffectsStatus = 0;
        $997a9c03857cd60f$var$pendingFinishedWork = $997a9c03857cd60f$var$pendingEffectsRoot = null;
        $997a9c03857cd60f$var$pendingEffectsLanes = 0;
        if (0 !== ($997a9c03857cd60f$var$executionContext & 6)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(331));
        var prevExecutionContext = $997a9c03857cd60f$var$executionContext;
        $997a9c03857cd60f$var$executionContext |= 4;
        $997a9c03857cd60f$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $997a9c03857cd60f$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $997a9c03857cd60f$var$executionContext = prevExecutionContext;
        $997a9c03857cd60f$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($997a9c03857cd60f$var$injectedHook && "function" === typeof $997a9c03857cd60f$var$injectedHook.onPostCommitFiberRoot) try {
            $997a9c03857cd60f$var$injectedHook.onPostCommitFiberRoot($997a9c03857cd60f$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority, $997a9c03857cd60f$var$ReactSharedInternals.T = prevTransition, $997a9c03857cd60f$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $997a9c03857cd60f$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $997a9c03857cd60f$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $997a9c03857cd60f$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $997a9c03857cd60f$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($997a9c03857cd60f$var$markRootUpdated$1(rootFiber, 2), $997a9c03857cd60f$var$ensureRootIsScheduled(rootFiber));
}
function $997a9c03857cd60f$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $997a9c03857cd60f$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $997a9c03857cd60f$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed || !$997a9c03857cd60f$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $997a9c03857cd60f$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $997a9c03857cd60f$var$createClassErrorUpdate(2);
                instance = $997a9c03857cd60f$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($997a9c03857cd60f$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $997a9c03857cd60f$var$markRootUpdated$1(instance, 2), $997a9c03857cd60f$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $997a9c03857cd60f$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $997a9c03857cd60f$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($997a9c03857cd60f$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $997a9c03857cd60f$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $997a9c03857cd60f$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $997a9c03857cd60f$var$workInProgressRoot === root && ($997a9c03857cd60f$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $997a9c03857cd60f$var$workInProgressRootExitStatus || 3 === $997a9c03857cd60f$var$workInProgressRootExitStatus && ($997a9c03857cd60f$var$workInProgressRootRenderLanes & 62914560) === $997a9c03857cd60f$var$workInProgressRootRenderLanes && 300 > $997a9c03857cd60f$var$now() - $997a9c03857cd60f$var$globalMostRecentFallbackTime ? 0 === ($997a9c03857cd60f$var$executionContext & 2) && $997a9c03857cd60f$var$prepareFreshStack(root, 0) : $997a9c03857cd60f$var$workInProgressRootPingedLanes |= pingedLanes, $997a9c03857cd60f$var$workInProgressSuspendedRetryLanes === $997a9c03857cd60f$var$workInProgressRootRenderLanes && ($997a9c03857cd60f$var$workInProgressSuspendedRetryLanes = 0));
    $997a9c03857cd60f$var$ensureRootIsScheduled(root);
}
function $997a9c03857cd60f$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $997a9c03857cd60f$var$claimNextRetryLane());
    boundaryFiber = $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($997a9c03857cd60f$var$markRootUpdated$1(boundaryFiber, retryLane), $997a9c03857cd60f$var$ensureRootIsScheduled(boundaryFiber));
}
function $997a9c03857cd60f$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $997a9c03857cd60f$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $997a9c03857cd60f$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $997a9c03857cd60f$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $997a9c03857cd60f$var$scheduleCallback$1(priorityLevel, callback) {
    return $997a9c03857cd60f$var$scheduleCallback$3(priorityLevel, callback);
}
var $997a9c03857cd60f$var$firstScheduledRoot = null, $997a9c03857cd60f$var$lastScheduledRoot = null, $997a9c03857cd60f$var$didScheduleMicrotask = !1, $997a9c03857cd60f$var$mightHavePendingSyncWork = !1, $997a9c03857cd60f$var$isFlushingWork = !1, $997a9c03857cd60f$var$currentEventTransitionLane = 0;
function $997a9c03857cd60f$var$ensureRootIsScheduled(root) {
    root !== $997a9c03857cd60f$var$lastScheduledRoot && null === root.next && (null === $997a9c03857cd60f$var$lastScheduledRoot ? $997a9c03857cd60f$var$firstScheduledRoot = $997a9c03857cd60f$var$lastScheduledRoot = root : $997a9c03857cd60f$var$lastScheduledRoot = $997a9c03857cd60f$var$lastScheduledRoot.next = root);
    $997a9c03857cd60f$var$mightHavePendingSyncWork = !0;
    $997a9c03857cd60f$var$didScheduleMicrotask || ($997a9c03857cd60f$var$didScheduleMicrotask = !0, $997a9c03857cd60f$var$scheduleImmediateRootScheduleTask());
}
function $997a9c03857cd60f$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$997a9c03857cd60f$var$isFlushingWork && $997a9c03857cd60f$var$mightHavePendingSyncWork) {
        $997a9c03857cd60f$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $997a9c03857cd60f$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $997a9c03857cd60f$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $997a9c03857cd60f$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $997a9c03857cd60f$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $997a9c03857cd60f$var$getNextLanes(root$170, root$170 === $997a9c03857cd60f$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $997a9c03857cd60f$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $997a9c03857cd60f$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $997a9c03857cd60f$var$isFlushingWork = !1;
    }
}
function $997a9c03857cd60f$var$processRootScheduleInImmediateTask() {
    $997a9c03857cd60f$var$processRootScheduleInMicrotask();
}
function $997a9c03857cd60f$var$processRootScheduleInMicrotask() {
    $997a9c03857cd60f$var$mightHavePendingSyncWork = $997a9c03857cd60f$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $997a9c03857cd60f$var$currentEventTransitionLane && $997a9c03857cd60f$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $997a9c03857cd60f$var$currentEventTransitionLane);
    for(var currentTime = $997a9c03857cd60f$var$now(), prev = null, root = $997a9c03857cd60f$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $997a9c03857cd60f$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $997a9c03857cd60f$var$firstScheduledRoot = next : prev.next = next, null === next && ($997a9c03857cd60f$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $997a9c03857cd60f$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $997a9c03857cd60f$var$pendingEffectsStatus && 5 !== $997a9c03857cd60f$var$pendingEffectsStatus || $997a9c03857cd60f$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $997a9c03857cd60f$var$currentEventTransitionLane && ($997a9c03857cd60f$var$currentEventTransitionLane = 0);
}
function $997a9c03857cd60f$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $997a9c03857cd60f$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $997a9c03857cd60f$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $997a9c03857cd60f$var$workInProgressRoot;
    suspendedLanes = $997a9c03857cd60f$var$workInProgressRootRenderLanes;
    suspendedLanes = $997a9c03857cd60f$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $997a9c03857cd60f$var$workInProgressSuspendedReason || 9 === $997a9c03857cd60f$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $997a9c03857cd60f$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $997a9c03857cd60f$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $997a9c03857cd60f$var$cancelCallback$1(pingedLanes);
        switch($997a9c03857cd60f$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $997a9c03857cd60f$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $997a9c03857cd60f$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $997a9c03857cd60f$var$IdlePriority;
                break;
            default:
                suspendedLanes = $997a9c03857cd60f$var$NormalPriority$1;
        }
        pingedLanes = $997a9c03857cd60f$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $997a9c03857cd60f$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $997a9c03857cd60f$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $997a9c03857cd60f$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $997a9c03857cd60f$var$pendingEffectsStatus && 5 !== $997a9c03857cd60f$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($997a9c03857cd60f$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $997a9c03857cd60f$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $997a9c03857cd60f$var$getNextLanes(root, root === $997a9c03857cd60f$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $997a9c03857cd60f$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $997a9c03857cd60f$var$scheduleTaskForRootDuringMicrotask(root, $997a9c03857cd60f$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $997a9c03857cd60f$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $997a9c03857cd60f$var$performSyncWorkOnRoot(root, lanes) {
    if ($997a9c03857cd60f$var$flushPendingEffects()) return null;
    $997a9c03857cd60f$var$performWorkOnRoot(root, lanes, !0);
}
function $997a9c03857cd60f$var$scheduleImmediateRootScheduleTask() {
    $997a9c03857cd60f$var$scheduleMicrotask(function() {
        0 !== ($997a9c03857cd60f$var$executionContext & 6) ? $997a9c03857cd60f$var$scheduleCallback$3($997a9c03857cd60f$var$ImmediatePriority, $997a9c03857cd60f$var$processRootScheduleInImmediateTask) : $997a9c03857cd60f$var$processRootScheduleInMicrotask();
    });
}
function $997a9c03857cd60f$var$requestTransitionLane() {
    if (0 === $997a9c03857cd60f$var$currentEventTransitionLane) {
        var actionScopeLane = $997a9c03857cd60f$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $997a9c03857cd60f$var$nextTransitionUpdateLane, $997a9c03857cd60f$var$nextTransitionUpdateLane <<= 1, 0 === ($997a9c03857cd60f$var$nextTransitionUpdateLane & 261888) && ($997a9c03857cd60f$var$nextTransitionUpdateLane = 256));
        $997a9c03857cd60f$var$currentEventTransitionLane = actionScopeLane;
    }
    return $997a9c03857cd60f$var$currentEventTransitionLane;
}
function $997a9c03857cd60f$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $997a9c03857cd60f$var$sanitizeURL("" + actionProp);
}
function $997a9c03857cd60f$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $997a9c03857cd60f$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $997a9c03857cd60f$var$coerceFormActionProp((nativeEventTarget[$997a9c03857cd60f$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$997a9c03857cd60f$var$internalPropsKey] || null) ? $997a9c03857cd60f$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $997a9c03857cd60f$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $997a9c03857cd60f$var$currentEventTransitionLane) {
                                var formData = submitter ? $997a9c03857cd60f$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $997a9c03857cd60f$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $997a9c03857cd60f$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $997a9c03857cd60f$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $997a9c03857cd60f$var$i$jscomp$inline_1577 = 0; $997a9c03857cd60f$var$i$jscomp$inline_1577 < $997a9c03857cd60f$var$simpleEventPluginEvents.length; $997a9c03857cd60f$var$i$jscomp$inline_1577++){
    var $997a9c03857cd60f$var$eventName$jscomp$inline_1578 = $997a9c03857cd60f$var$simpleEventPluginEvents[$997a9c03857cd60f$var$i$jscomp$inline_1577], $997a9c03857cd60f$var$domEventName$jscomp$inline_1579 = $997a9c03857cd60f$var$eventName$jscomp$inline_1578.toLowerCase(), $997a9c03857cd60f$var$capitalizedEvent$jscomp$inline_1580 = $997a9c03857cd60f$var$eventName$jscomp$inline_1578[0].toUpperCase() + $997a9c03857cd60f$var$eventName$jscomp$inline_1578.slice(1);
    $997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$domEventName$jscomp$inline_1579, "on" + $997a9c03857cd60f$var$capitalizedEvent$jscomp$inline_1580);
}
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$ANIMATION_END, "onAnimationEnd");
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$ANIMATION_ITERATION, "onAnimationIteration");
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$ANIMATION_START, "onAnimationStart");
$997a9c03857cd60f$var$registerSimpleEvent("dblclick", "onDoubleClick");
$997a9c03857cd60f$var$registerSimpleEvent("focusin", "onFocus");
$997a9c03857cd60f$var$registerSimpleEvent("focusout", "onBlur");
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$TRANSITION_RUN, "onTransitionRun");
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$TRANSITION_START, "onTransitionStart");
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$TRANSITION_CANCEL, "onTransitionCancel");
$997a9c03857cd60f$var$registerSimpleEvent($997a9c03857cd60f$var$TRANSITION_END, "onTransitionEnd");
$997a9c03857cd60f$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$997a9c03857cd60f$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$997a9c03857cd60f$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$997a9c03857cd60f$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$997a9c03857cd60f$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$997a9c03857cd60f$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$997a9c03857cd60f$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$997a9c03857cd60f$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$997a9c03857cd60f$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$997a9c03857cd60f$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $997a9c03857cd60f$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $997a9c03857cd60f$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($997a9c03857cd60f$var$mediaEventTypes));
function $997a9c03857cd60f$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $997a9c03857cd60f$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $997a9c03857cd60f$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $997a9c03857cd60f$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$997a9c03857cd60f$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$997a9c03857cd60f$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($997a9c03857cd60f$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $997a9c03857cd60f$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $997a9c03857cd60f$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $997a9c03857cd60f$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $997a9c03857cd60f$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$997a9c03857cd60f$var$listeningMarker]) {
        rootContainerElement[$997a9c03857cd60f$var$listeningMarker] = !0;
        $997a9c03857cd60f$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($997a9c03857cd60f$var$nonDelegatedEvents.has(domEventName) || $997a9c03857cd60f$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $997a9c03857cd60f$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$997a9c03857cd60f$var$listeningMarker] || (ownerDocument[$997a9c03857cd60f$var$listeningMarker] = !0, $997a9c03857cd60f$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $997a9c03857cd60f$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($997a9c03857cd60f$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $997a9c03857cd60f$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $997a9c03857cd60f$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $997a9c03857cd60f$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$997a9c03857cd60f$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $997a9c03857cd60f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $997a9c03857cd60f$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $997a9c03857cd60f$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $997a9c03857cd60f$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $997a9c03857cd60f$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $997a9c03857cd60f$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticTouchEvent;
                        break;
                    case $997a9c03857cd60f$var$ANIMATION_END:
                    case $997a9c03857cd60f$var$ANIMATION_ITERATION:
                    case $997a9c03857cd60f$var$ANIMATION_START:
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticAnimationEvent;
                        break;
                    case $997a9c03857cd60f$var$TRANSITION_END:
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $997a9c03857cd60f$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $997a9c03857cd60f$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($997a9c03857cd60f$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $997a9c03857cd60f$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($997a9c03857cd60f$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$997a9c03857cd60f$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $997a9c03857cd60f$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $997a9c03857cd60f$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $997a9c03857cd60f$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $997a9c03857cd60f$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $997a9c03857cd60f$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $997a9c03857cd60f$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $997a9c03857cd60f$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $997a9c03857cd60f$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $997a9c03857cd60f$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $997a9c03857cd60f$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $997a9c03857cd60f$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $997a9c03857cd60f$var$getTargetInstForChangeEvent;
                else if ($997a9c03857cd60f$var$isTextInputElement(reactName)) {
                    if ($997a9c03857cd60f$var$isInputEventSupported) getTargetInstFunc = $997a9c03857cd60f$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $997a9c03857cd60f$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $997a9c03857cd60f$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $997a9c03857cd60f$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $997a9c03857cd60f$var$getTargetInstForChangeEvent) : getTargetInstFunc = $997a9c03857cd60f$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $997a9c03857cd60f$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $997a9c03857cd60f$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $997a9c03857cd60f$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($997a9c03857cd60f$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $997a9c03857cd60f$var$activeElement = handleEventFunc, $997a9c03857cd60f$var$activeElementInst = targetInst, $997a9c03857cd60f$var$lastSelection = null;
                    break;
                case "focusout":
                    $997a9c03857cd60f$var$lastSelection = $997a9c03857cd60f$var$activeElementInst = $997a9c03857cd60f$var$activeElement = null;
                    break;
                case "mousedown":
                    $997a9c03857cd60f$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $997a9c03857cd60f$var$mouseDown = !1;
                    $997a9c03857cd60f$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($997a9c03857cd60f$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $997a9c03857cd60f$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($997a9c03857cd60f$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $997a9c03857cd60f$var$isComposing ? $997a9c03857cd60f$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($997a9c03857cd60f$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($997a9c03857cd60f$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $997a9c03857cd60f$var$isComposing && (fallbackData = $997a9c03857cd60f$var$getData()) : ($997a9c03857cd60f$var$root = nativeEventTarget, $997a9c03857cd60f$var$startText = "value" in $997a9c03857cd60f$var$root ? $997a9c03857cd60f$var$root.value : $997a9c03857cd60f$var$root.textContent, $997a9c03857cd60f$var$isComposing = !0)), handleEventFunc = $997a9c03857cd60f$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $997a9c03857cd60f$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $997a9c03857cd60f$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $997a9c03857cd60f$var$canUseTextInputEvent ? $997a9c03857cd60f$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $997a9c03857cd60f$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $997a9c03857cd60f$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $997a9c03857cd60f$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $997a9c03857cd60f$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $997a9c03857cd60f$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $997a9c03857cd60f$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $997a9c03857cd60f$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $997a9c03857cd60f$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($997a9c03857cd60f$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $997a9c03857cd60f$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($997a9c03857cd60f$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $997a9c03857cd60f$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $997a9c03857cd60f$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $997a9c03857cd60f$var$getListener(target, registrationName), null != stateNode && listeners.unshift($997a9c03857cd60f$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $997a9c03857cd60f$var$getListener(target, registrationName), null != stateNode && listeners.push($997a9c03857cd60f$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $997a9c03857cd60f$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $997a9c03857cd60f$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $997a9c03857cd60f$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($997a9c03857cd60f$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($997a9c03857cd60f$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $997a9c03857cd60f$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $997a9c03857cd60f$var$normalizeMarkupForTextOrAttribute(clientText);
    return $997a9c03857cd60f$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $997a9c03857cd60f$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $997a9c03857cd60f$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $997a9c03857cd60f$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $997a9c03857cd60f$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $997a9c03857cd60f$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $997a9c03857cd60f$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $997a9c03857cd60f$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $997a9c03857cd60f$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $997a9c03857cd60f$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $997a9c03857cd60f$var$setProp(domElement, tag, "name", props.name, props, null), $997a9c03857cd60f$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $997a9c03857cd60f$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $997a9c03857cd60f$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($997a9c03857cd60f$var$setProp(domElement, tag, "encType", props.encType, props, null), $997a9c03857cd60f$var$setProp(domElement, tag, "method", props.method, props, null), $997a9c03857cd60f$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $997a9c03857cd60f$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $997a9c03857cd60f$var$noop$1);
            break;
        case "onScroll":
            null != value && $997a9c03857cd60f$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $997a9c03857cd60f$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $997a9c03857cd60f$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("toggle", domElement);
            $997a9c03857cd60f$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $997a9c03857cd60f$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $997a9c03857cd60f$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $997a9c03857cd60f$var$aliases.get(key) || key, $997a9c03857cd60f$var$setValueForAttribute(domElement, key, value);
    }
}
function $997a9c03857cd60f$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $997a9c03857cd60f$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $997a9c03857cd60f$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $997a9c03857cd60f$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $997a9c03857cd60f$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $997a9c03857cd60f$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $997a9c03857cd60f$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$997a9c03857cd60f$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$997a9c03857cd60f$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $997a9c03857cd60f$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $997a9c03857cd60f$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("error", domElement);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($997a9c03857cd60f$var$formatProdErrorMessage(137, tag));
                    default:
                        $997a9c03857cd60f$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $997a9c03857cd60f$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $997a9c03857cd60f$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $997a9c03857cd60f$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $997a9c03857cd60f$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $997a9c03857cd60f$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $997a9c03857cd60f$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(91));
                    break;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $997a9c03857cd60f$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("toggle", domElement);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("cancel", domElement);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $997a9c03857cd60f$var$mediaEventTypes.length; hasSrc++)$997a9c03857cd60f$var$listenToNonDelegatedEvent($997a9c03857cd60f$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("error", domElement);
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $997a9c03857cd60f$var$listenToNonDelegatedEvent("error", domElement), $997a9c03857cd60f$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($997a9c03857cd60f$var$formatProdErrorMessage(137, tag));
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($997a9c03857cd60f$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $997a9c03857cd60f$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $997a9c03857cd60f$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $997a9c03857cd60f$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $997a9c03857cd60f$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $997a9c03857cd60f$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $997a9c03857cd60f$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $997a9c03857cd60f$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $997a9c03857cd60f$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $997a9c03857cd60f$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $997a9c03857cd60f$var$updateOptions(domElement, !!lastProps, tag, !0) : $997a9c03857cd60f$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $997a9c03857cd60f$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $997a9c03857cd60f$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $997a9c03857cd60f$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $997a9c03857cd60f$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($997a9c03857cd60f$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $997a9c03857cd60f$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $997a9c03857cd60f$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $997a9c03857cd60f$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $997a9c03857cd60f$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $997a9c03857cd60f$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $997a9c03857cd60f$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $997a9c03857cd60f$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $997a9c03857cd60f$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $997a9c03857cd60f$var$eventsEnabled = null, $997a9c03857cd60f$var$selectionInformation = null;
function $997a9c03857cd60f$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $997a9c03857cd60f$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $997a9c03857cd60f$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $997a9c03857cd60f$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $997a9c03857cd60f$var$currentPopstateTransitionEvent = null;
function $997a9c03857cd60f$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $997a9c03857cd60f$var$currentPopstateTransitionEvent) return !1;
        $997a9c03857cd60f$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $997a9c03857cd60f$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $997a9c03857cd60f$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $997a9c03857cd60f$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $997a9c03857cd60f$var$localPromise = "function" === typeof Promise ? Promise : void 0, $997a9c03857cd60f$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $997a9c03857cd60f$var$localPromise ? function(callback) {
    return $997a9c03857cd60f$var$localPromise.resolve(null).then(callback).catch($997a9c03857cd60f$var$handleErrorInNextTick);
} : $997a9c03857cd60f$var$scheduleTimeout;
function $997a9c03857cd60f$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $997a9c03857cd60f$var$isSingletonScope(type) {
    return "head" === type;
}
function $997a9c03857cd60f$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $997a9c03857cd60f$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $997a9c03857cd60f$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $997a9c03857cd60f$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$997a9c03857cd60f$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $997a9c03857cd60f$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $997a9c03857cd60f$var$retryIfBlockedOn(hydrationInstance);
}
function $997a9c03857cd60f$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $997a9c03857cd60f$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $997a9c03857cd60f$var$clearContainerSparingly(node);
                $997a9c03857cd60f$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $997a9c03857cd60f$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$997a9c03857cd60f$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $997a9c03857cd60f$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $997a9c03857cd60f$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $997a9c03857cd60f$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $997a9c03857cd60f$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $997a9c03857cd60f$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $997a9c03857cd60f$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $997a9c03857cd60f$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $997a9c03857cd60f$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $997a9c03857cd60f$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $997a9c03857cd60f$var$previousHydratableOnEnteringScopedSingleton = null;
function $997a9c03857cd60f$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $997a9c03857cd60f$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $997a9c03857cd60f$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $997a9c03857cd60f$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $997a9c03857cd60f$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(451));
    }
}
function $997a9c03857cd60f$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $997a9c03857cd60f$var$detachDeletedInstance(instance);
}
var $997a9c03857cd60f$var$preloadPropsMap = new Map(), $997a9c03857cd60f$var$preconnectsSet = new Set();
function $997a9c03857cd60f$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $997a9c03857cd60f$var$previousDispatcher = $997a9c03857cd60f$var$ReactDOMSharedInternals.d;
$997a9c03857cd60f$var$ReactDOMSharedInternals.d = {
    f: $997a9c03857cd60f$var$flushSyncWork,
    r: $997a9c03857cd60f$var$requestFormReset,
    D: $997a9c03857cd60f$var$prefetchDNS,
    C: $997a9c03857cd60f$var$preconnect,
    L: $997a9c03857cd60f$var$preload,
    m: $997a9c03857cd60f$var$preloadModule,
    X: $997a9c03857cd60f$var$preinitScript,
    S: $997a9c03857cd60f$var$preinitStyle,
    M: $997a9c03857cd60f$var$preinitModuleScript
};
function $997a9c03857cd60f$var$flushSyncWork() {
    var previousWasRendering = $997a9c03857cd60f$var$previousDispatcher.f(), wasRendering = $997a9c03857cd60f$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $997a9c03857cd60f$var$requestFormReset(form) {
    var formInst = $997a9c03857cd60f$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $997a9c03857cd60f$var$requestFormReset$1(formInst) : $997a9c03857cd60f$var$previousDispatcher.r(form);
}
var $997a9c03857cd60f$var$globalDocument = "undefined" === typeof document ? null : document;
function $997a9c03857cd60f$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $997a9c03857cd60f$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $997a9c03857cd60f$var$preconnectsSet.has(limitedEscapedHref) || ($997a9c03857cd60f$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $997a9c03857cd60f$var$setInitialProperties(href, "link", rel), $997a9c03857cd60f$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $997a9c03857cd60f$var$prefetchDNS(href) {
    $997a9c03857cd60f$var$previousDispatcher.D(href);
    $997a9c03857cd60f$var$preconnectAs("dns-prefetch", href, null);
}
function $997a9c03857cd60f$var$preconnect(href, crossOrigin) {
    $997a9c03857cd60f$var$previousDispatcher.C(href, crossOrigin);
    $997a9c03857cd60f$var$preconnectAs("preconnect", href, crossOrigin);
}
function $997a9c03857cd60f$var$preload(href, as, options) {
    $997a9c03857cd60f$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $997a9c03857cd60f$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $997a9c03857cd60f$var$getStyleKey(href);
                break;
            case "script":
                key = $997a9c03857cd60f$var$getScriptKey(href);
        }
        $997a9c03857cd60f$var$preloadPropsMap.has(key) || (href = $997a9c03857cd60f$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $997a9c03857cd60f$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($997a9c03857cd60f$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($997a9c03857cd60f$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $997a9c03857cd60f$var$setInitialProperties(as, "link", href), $997a9c03857cd60f$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $997a9c03857cd60f$var$preloadModule(href, options) {
    $997a9c03857cd60f$var$previousDispatcher.m(href, options);
    var ownerDocument = $997a9c03857cd60f$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $997a9c03857cd60f$var$getScriptKey(href);
        }
        if (!$997a9c03857cd60f$var$preloadPropsMap.has(key) && (href = $997a9c03857cd60f$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $997a9c03857cd60f$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($997a9c03857cd60f$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $997a9c03857cd60f$var$setInitialProperties(as, "link", href);
            $997a9c03857cd60f$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $997a9c03857cd60f$var$preinitStyle(href, precedence, options) {
    $997a9c03857cd60f$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $997a9c03857cd60f$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $997a9c03857cd60f$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $997a9c03857cd60f$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($997a9c03857cd60f$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $997a9c03857cd60f$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $997a9c03857cd60f$var$preloadPropsMap.get(key)) && $997a9c03857cd60f$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $997a9c03857cd60f$var$markNodeAsHoistable(link);
                $997a9c03857cd60f$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $997a9c03857cd60f$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $997a9c03857cd60f$var$preinitScript(src, options) {
    $997a9c03857cd60f$var$previousDispatcher.X(src, options);
    var ownerDocument = $997a9c03857cd60f$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $997a9c03857cd60f$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $997a9c03857cd60f$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($997a9c03857cd60f$var$getScriptSelectorFromKey(key)), resource || (src = $997a9c03857cd60f$var$assign({
            src: src,
            async: !0
        }, options), (options = $997a9c03857cd60f$var$preloadPropsMap.get(key)) && $997a9c03857cd60f$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $997a9c03857cd60f$var$markNodeAsHoistable(resource), $997a9c03857cd60f$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $997a9c03857cd60f$var$preinitModuleScript(src, options) {
    $997a9c03857cd60f$var$previousDispatcher.M(src, options);
    var ownerDocument = $997a9c03857cd60f$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $997a9c03857cd60f$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $997a9c03857cd60f$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($997a9c03857cd60f$var$getScriptSelectorFromKey(key)), resource || (src = $997a9c03857cd60f$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $997a9c03857cd60f$var$preloadPropsMap.get(key)) && $997a9c03857cd60f$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $997a9c03857cd60f$var$markNodeAsHoistable(resource), $997a9c03857cd60f$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $997a9c03857cd60f$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $997a9c03857cd60f$var$rootInstanceStackCursor.current) ? $997a9c03857cd60f$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $997a9c03857cd60f$var$getStyleKey(pendingProps.href), pendingProps = $997a9c03857cd60f$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $997a9c03857cd60f$var$getStyleKey(pendingProps.href);
                var styles$243 = $997a9c03857cd60f$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($997a9c03857cd60f$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $997a9c03857cd60f$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $997a9c03857cd60f$var$preloadPropsMap.set(type, pendingProps), styles$243 || $997a9c03857cd60f$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $997a9c03857cd60f$var$getScriptKey(pendingProps), pendingProps = $997a9c03857cd60f$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(444, type));
    }
}
function $997a9c03857cd60f$var$getStyleKey(href) {
    return 'href="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $997a9c03857cd60f$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $997a9c03857cd60f$var$stylesheetPropsFromRawProps(rawProps) {
    return $997a9c03857cd60f$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $997a9c03857cd60f$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $997a9c03857cd60f$var$setInitialProperties(key, "link", preloadProps), $997a9c03857cd60f$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $997a9c03857cd60f$var$getScriptKey(src) {
    return '[src="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $997a9c03857cd60f$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $997a9c03857cd60f$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $997a9c03857cd60f$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $997a9c03857cd60f$var$markNodeAsHoistable(instance), instance;
            var styleProps = $997a9c03857cd60f$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $997a9c03857cd60f$var$markNodeAsHoistable(instance);
            $997a9c03857cd60f$var$setInitialProperties(instance, "style", styleProps);
            $997a9c03857cd60f$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $997a9c03857cd60f$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($997a9c03857cd60f$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $997a9c03857cd60f$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $997a9c03857cd60f$var$stylesheetPropsFromRawProps(props);
            (styleProps = $997a9c03857cd60f$var$preloadPropsMap.get(styleProps)) && $997a9c03857cd60f$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $997a9c03857cd60f$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $997a9c03857cd60f$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $997a9c03857cd60f$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $997a9c03857cd60f$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($997a9c03857cd60f$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $997a9c03857cd60f$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $997a9c03857cd60f$var$preloadPropsMap.get(instance$249)) instance = $997a9c03857cd60f$var$assign({}, props), $997a9c03857cd60f$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $997a9c03857cd60f$var$markNodeAsHoistable(styleProps);
            $997a9c03857cd60f$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($997a9c03857cd60f$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $997a9c03857cd60f$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $997a9c03857cd60f$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $997a9c03857cd60f$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $997a9c03857cd60f$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $997a9c03857cd60f$var$tagCaches = null;
function $997a9c03857cd60f$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $997a9c03857cd60f$var$tagCaches) {
        var cache = new Map();
        var caches = $997a9c03857cd60f$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $997a9c03857cd60f$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$997a9c03857cd60f$var$internalHoistableMarker] || node[$997a9c03857cd60f$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $997a9c03857cd60f$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $997a9c03857cd60f$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $997a9c03857cd60f$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $997a9c03857cd60f$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $997a9c03857cd60f$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($997a9c03857cd60f$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $997a9c03857cd60f$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $997a9c03857cd60f$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $997a9c03857cd60f$var$stylesheetPropsFromRawProps(props);
            (key = $997a9c03857cd60f$var$preloadPropsMap.get(key)) && $997a9c03857cd60f$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $997a9c03857cd60f$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $997a9c03857cd60f$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $997a9c03857cd60f$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $997a9c03857cd60f$var$estimatedBytesWithinLimit = 0;
function $997a9c03857cd60f$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $997a9c03857cd60f$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $997a9c03857cd60f$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $997a9c03857cd60f$var$estimatedBytesWithinLimit && ($997a9c03857cd60f$var$estimatedBytesWithinLimit = 62500 * $997a9c03857cd60f$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $997a9c03857cd60f$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $997a9c03857cd60f$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $997a9c03857cd60f$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $997a9c03857cd60f$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $997a9c03857cd60f$var$precedencesByRoot = null;
function $997a9c03857cd60f$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $997a9c03857cd60f$var$precedencesByRoot = new Map(), resources.forEach($997a9c03857cd60f$var$insertStylesheetIntoRoot, state), $997a9c03857cd60f$var$precedencesByRoot = null, $997a9c03857cd60f$var$onUnsuspend.call(state));
}
function $997a9c03857cd60f$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $997a9c03857cd60f$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $997a9c03857cd60f$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $997a9c03857cd60f$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $997a9c03857cd60f$var$HostTransitionContext = {
    $$typeof: $997a9c03857cd60f$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $997a9c03857cd60f$var$sharedNotPendingObject,
    _currentValue2: $997a9c03857cd60f$var$sharedNotPendingObject,
    _threadCount: 0
};
function $997a9c03857cd60f$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $997a9c03857cd60f$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $997a9c03857cd60f$var$createLaneMap(0);
    this.hiddenUpdates = $997a9c03857cd60f$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $997a9c03857cd60f$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $997a9c03857cd60f$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $997a9c03857cd60f$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $997a9c03857cd60f$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $997a9c03857cd60f$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $997a9c03857cd60f$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $997a9c03857cd60f$var$emptyContextObject;
    parentComponent = $997a9c03857cd60f$var$emptyContextObject;
    return parentComponent;
}
function $997a9c03857cd60f$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $997a9c03857cd60f$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $997a9c03857cd60f$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $997a9c03857cd60f$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($997a9c03857cd60f$var$scheduleUpdateOnFiber(element, rootFiber, lane), $997a9c03857cd60f$var$entangleTransitions(element, rootFiber, lane));
}
function $997a9c03857cd60f$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $997a9c03857cd60f$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $997a9c03857cd60f$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $997a9c03857cd60f$var$markRetryLaneImpl(fiber, retryLane);
}
function $997a9c03857cd60f$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $997a9c03857cd60f$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $997a9c03857cd60f$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $997a9c03857cd60f$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $997a9c03857cd60f$var$requestUpdateLane();
        lane = $997a9c03857cd60f$var$getBumpedLaneForHydrationByLane(lane);
        var root = $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $997a9c03857cd60f$var$scheduleUpdateOnFiber(root, fiber, lane);
        $997a9c03857cd60f$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $997a9c03857cd60f$var$_enabled = !0;
function $997a9c03857cd60f$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $997a9c03857cd60f$var$ReactSharedInternals.T;
    $997a9c03857cd60f$var$ReactSharedInternals.T = null;
    var previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
    try {
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 2, $997a9c03857cd60f$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority, $997a9c03857cd60f$var$ReactSharedInternals.T = prevTransition;
    }
}
function $997a9c03857cd60f$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $997a9c03857cd60f$var$ReactSharedInternals.T;
    $997a9c03857cd60f$var$ReactSharedInternals.T = null;
    var previousPriority = $997a9c03857cd60f$var$ReactDOMSharedInternals.p;
    try {
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = 8, $997a9c03857cd60f$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $997a9c03857cd60f$var$ReactDOMSharedInternals.p = previousPriority, $997a9c03857cd60f$var$ReactSharedInternals.T = prevTransition;
    }
}
function $997a9c03857cd60f$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($997a9c03857cd60f$var$_enabled) {
        var blockedOn = $997a9c03857cd60f$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $997a9c03857cd60f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $997a9c03857cd60f$var$return_targetInst, targetContainer), $997a9c03857cd60f$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($997a9c03857cd60f$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($997a9c03857cd60f$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $997a9c03857cd60f$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $997a9c03857cd60f$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $997a9c03857cd60f$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $997a9c03857cd60f$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $997a9c03857cd60f$var$ensureRootIsScheduled(fiber);
                                0 === ($997a9c03857cd60f$var$executionContext & 6) && ($997a9c03857cd60f$var$workInProgressRootRenderTargetTime = $997a9c03857cd60f$var$now() + 500, $997a9c03857cd60f$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $997a9c03857cd60f$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $997a9c03857cd60f$var$scheduleUpdateOnFiber(root, fiber, 2), $997a9c03857cd60f$var$flushSyncWork$1(), $997a9c03857cd60f$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $997a9c03857cd60f$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $997a9c03857cd60f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $997a9c03857cd60f$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $997a9c03857cd60f$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $997a9c03857cd60f$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $997a9c03857cd60f$var$getEventTarget(nativeEvent);
    return $997a9c03857cd60f$var$findInstanceBlockingTarget(nativeEvent);
}
var $997a9c03857cd60f$var$return_targetInst = null;
function $997a9c03857cd60f$var$findInstanceBlockingTarget(targetNode) {
    $997a9c03857cd60f$var$return_targetInst = null;
    targetNode = $997a9c03857cd60f$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $997a9c03857cd60f$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $997a9c03857cd60f$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $997a9c03857cd60f$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $997a9c03857cd60f$var$return_targetInst = targetNode;
    return null;
}
function $997a9c03857cd60f$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($997a9c03857cd60f$var$getCurrentPriorityLevel()){
                case $997a9c03857cd60f$var$ImmediatePriority:
                    return 2;
                case $997a9c03857cd60f$var$UserBlockingPriority:
                    return 8;
                case $997a9c03857cd60f$var$NormalPriority$1:
                case $997a9c03857cd60f$var$LowPriority:
                    return 32;
                case $997a9c03857cd60f$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $997a9c03857cd60f$var$hasScheduledReplayAttempt = !1, $997a9c03857cd60f$var$queuedFocus = null, $997a9c03857cd60f$var$queuedDrag = null, $997a9c03857cd60f$var$queuedMouse = null, $997a9c03857cd60f$var$queuedPointers = new Map(), $997a9c03857cd60f$var$queuedPointerCaptures = new Map(), $997a9c03857cd60f$var$queuedExplicitHydrationTargets = [], $997a9c03857cd60f$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $997a9c03857cd60f$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $997a9c03857cd60f$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $997a9c03857cd60f$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $997a9c03857cd60f$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $997a9c03857cd60f$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $997a9c03857cd60f$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $997a9c03857cd60f$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $997a9c03857cd60f$var$getInstanceFromNode(blockedOn), null !== blockedOn && $997a9c03857cd60f$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $997a9c03857cd60f$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $997a9c03857cd60f$var$queuedFocus = $997a9c03857cd60f$var$accumulateOrCreateContinuousQueuedReplayableEvent($997a9c03857cd60f$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $997a9c03857cd60f$var$queuedDrag = $997a9c03857cd60f$var$accumulateOrCreateContinuousQueuedReplayableEvent($997a9c03857cd60f$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $997a9c03857cd60f$var$queuedMouse = $997a9c03857cd60f$var$accumulateOrCreateContinuousQueuedReplayableEvent($997a9c03857cd60f$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $997a9c03857cd60f$var$queuedPointers.set(pointerId, $997a9c03857cd60f$var$accumulateOrCreateContinuousQueuedReplayableEvent($997a9c03857cd60f$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $997a9c03857cd60f$var$queuedPointerCaptures.set(pointerId, $997a9c03857cd60f$var$accumulateOrCreateContinuousQueuedReplayableEvent($997a9c03857cd60f$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $997a9c03857cd60f$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $997a9c03857cd60f$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $997a9c03857cd60f$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $997a9c03857cd60f$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $997a9c03857cd60f$var$runWithPriority(queuedTarget.priority, function() {
                        $997a9c03857cd60f$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $997a9c03857cd60f$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $997a9c03857cd60f$var$runWithPriority(queuedTarget.priority, function() {
                        $997a9c03857cd60f$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $997a9c03857cd60f$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $997a9c03857cd60f$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $997a9c03857cd60f$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $997a9c03857cd60f$var$currentReplayingEvent = null;
        } else return targetContainers = $997a9c03857cd60f$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $997a9c03857cd60f$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $997a9c03857cd60f$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $997a9c03857cd60f$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $997a9c03857cd60f$var$replayUnblockedEvents() {
    $997a9c03857cd60f$var$hasScheduledReplayAttempt = !1;
    null !== $997a9c03857cd60f$var$queuedFocus && $997a9c03857cd60f$var$attemptReplayContinuousQueuedEvent($997a9c03857cd60f$var$queuedFocus) && ($997a9c03857cd60f$var$queuedFocus = null);
    null !== $997a9c03857cd60f$var$queuedDrag && $997a9c03857cd60f$var$attemptReplayContinuousQueuedEvent($997a9c03857cd60f$var$queuedDrag) && ($997a9c03857cd60f$var$queuedDrag = null);
    null !== $997a9c03857cd60f$var$queuedMouse && $997a9c03857cd60f$var$attemptReplayContinuousQueuedEvent($997a9c03857cd60f$var$queuedMouse) && ($997a9c03857cd60f$var$queuedMouse = null);
    $997a9c03857cd60f$var$queuedPointers.forEach($997a9c03857cd60f$var$attemptReplayContinuousQueuedEventInMap);
    $997a9c03857cd60f$var$queuedPointerCaptures.forEach($997a9c03857cd60f$var$attemptReplayContinuousQueuedEventInMap);
}
function $997a9c03857cd60f$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $997a9c03857cd60f$var$hasScheduledReplayAttempt || ($997a9c03857cd60f$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $997a9c03857cd60f$var$replayUnblockedEvents)));
}
var $997a9c03857cd60f$var$lastScheduledReplayQueue = null;
function $997a9c03857cd60f$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $997a9c03857cd60f$var$lastScheduledReplayQueue !== formReplayingQueue && ($997a9c03857cd60f$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $997a9c03857cd60f$var$lastScheduledReplayQueue === formReplayingQueue && ($997a9c03857cd60f$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $997a9c03857cd60f$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $997a9c03857cd60f$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $997a9c03857cd60f$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $997a9c03857cd60f$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $997a9c03857cd60f$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $997a9c03857cd60f$var$queuedFocus && $997a9c03857cd60f$var$scheduleCallbackIfUnblocked($997a9c03857cd60f$var$queuedFocus, unblocked);
    null !== $997a9c03857cd60f$var$queuedDrag && $997a9c03857cd60f$var$scheduleCallbackIfUnblocked($997a9c03857cd60f$var$queuedDrag, unblocked);
    null !== $997a9c03857cd60f$var$queuedMouse && $997a9c03857cd60f$var$scheduleCallbackIfUnblocked($997a9c03857cd60f$var$queuedMouse, unblocked);
    $997a9c03857cd60f$var$queuedPointers.forEach(unblock);
    $997a9c03857cd60f$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $997a9c03857cd60f$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $997a9c03857cd60f$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $997a9c03857cd60f$var$queuedExplicitHydrationTargets.length && (i = $997a9c03857cd60f$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$997a9c03857cd60f$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $997a9c03857cd60f$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$997a9c03857cd60f$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $997a9c03857cd60f$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$997a9c03857cd60f$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $997a9c03857cd60f$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $997a9c03857cd60f$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $997a9c03857cd60f$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $997a9c03857cd60f$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$997a9c03857cd60f$var$ReactDOMHydrationRoot.prototype.render = $997a9c03857cd60f$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(409));
    var current = root.current, lane = $997a9c03857cd60f$var$requestUpdateLane();
    $997a9c03857cd60f$var$updateContainerImpl(current, lane, children, root, null, null);
};
$997a9c03857cd60f$var$ReactDOMHydrationRoot.prototype.unmount = $997a9c03857cd60f$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $997a9c03857cd60f$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $997a9c03857cd60f$var$flushSyncWork$1();
        container[$997a9c03857cd60f$var$internalContainerInstanceKey] = null;
    }
};
function $997a9c03857cd60f$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$997a9c03857cd60f$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $997a9c03857cd60f$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $997a9c03857cd60f$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $997a9c03857cd60f$var$queuedExplicitHydrationTargets[i].priority; i++);
        $997a9c03857cd60f$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $997a9c03857cd60f$var$attemptExplicitHydrationTarget(target);
    }
};
var $997a9c03857cd60f$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $3xFFA.version;
if ("19.2.0" !== $997a9c03857cd60f$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(527, $997a9c03857cd60f$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$997a9c03857cd60f$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($997a9c03857cd60f$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $997a9c03857cd60f$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $997a9c03857cd60f$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $997a9c03857cd60f$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $997a9c03857cd60f$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $997a9c03857cd60f$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$997a9c03857cd60f$var$hook$jscomp$inline_2348.isDisabled && $997a9c03857cd60f$var$hook$jscomp$inline_2348.supportsFiber) try {
        $997a9c03857cd60f$var$rendererID = $997a9c03857cd60f$var$hook$jscomp$inline_2348.inject($997a9c03857cd60f$var$internals$jscomp$inline_2347), $997a9c03857cd60f$var$injectedHook = $997a9c03857cd60f$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$997a9c03857cd60f$export$882461b6382ed46c = function(container, options) {
    if (!$997a9c03857cd60f$var$isValidContainer(container)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $997a9c03857cd60f$var$defaultOnUncaughtError, onCaughtError = $997a9c03857cd60f$var$defaultOnCaughtError, onRecoverableError = $997a9c03857cd60f$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $997a9c03857cd60f$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $997a9c03857cd60f$var$defaultOnDefaultTransitionIndicator);
    container[$997a9c03857cd60f$var$internalContainerInstanceKey] = options.current;
    $997a9c03857cd60f$var$listenToAllSupportedEvents(container);
    return new $997a9c03857cd60f$var$ReactDOMRoot(options);
};
$997a9c03857cd60f$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$997a9c03857cd60f$var$isValidContainer(container)) throw Error($997a9c03857cd60f$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $997a9c03857cd60f$var$defaultOnUncaughtError, onCaughtError = $997a9c03857cd60f$var$defaultOnCaughtError, onRecoverableError = $997a9c03857cd60f$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $997a9c03857cd60f$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $997a9c03857cd60f$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $997a9c03857cd60f$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $997a9c03857cd60f$var$requestUpdateLane();
    isStrictMode = $997a9c03857cd60f$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $997a9c03857cd60f$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $997a9c03857cd60f$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $997a9c03857cd60f$var$markRootUpdated$1(initialChildren, options);
    $997a9c03857cd60f$var$ensureRootIsScheduled(initialChildren);
    container[$997a9c03857cd60f$var$internalContainerInstanceKey] = initialChildren.current;
    $997a9c03857cd60f$var$listenToAllSupportedEvents(container);
    return new $997a9c03857cd60f$var$ReactDOMHydrationRoot(initialChildren);
};
$997a9c03857cd60f$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("3xFFA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7AdSc"));

});

parcelRegister("J181o", function(module, exports) {
'use strict';
function $087514281afc55da$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($087514281afc55da$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$087514281afc55da$var$checkDCE();

module.exports = (parcelRequire("7sEfW"));

});
parcelRegister("7sEfW", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $56ea5fef7dd9e228$export$69ce8ef3fe5cead0, (v) => $56ea5fef7dd9e228$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $56ea5fef7dd9e228$export$d39a5bbd09211389, (v) => $56ea5fef7dd9e228$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $56ea5fef7dd9e228$export$cd75ccfd720a3cd4, (v) => $56ea5fef7dd9e228$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $56ea5fef7dd9e228$export$a0816fa17a9e79be, (v) => $56ea5fef7dd9e228$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $56ea5fef7dd9e228$export$7292efcadded39f3, (v) => $56ea5fef7dd9e228$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $56ea5fef7dd9e228$export$da407abadb9b8f86, (v) => $56ea5fef7dd9e228$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $56ea5fef7dd9e228$export$314cfea32580671c, (v) => $56ea5fef7dd9e228$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $56ea5fef7dd9e228$export$513ccb98c53b8039, (v) => $56ea5fef7dd9e228$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $56ea5fef7dd9e228$export$dbca993bc2d264a, (v) => $56ea5fef7dd9e228$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $56ea5fef7dd9e228$export$4797a8006f0655d0, (v) => $56ea5fef7dd9e228$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $56ea5fef7dd9e228$export$c78a37762a8d58e1, (v) => $56ea5fef7dd9e228$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $56ea5fef7dd9e228$export$606f11b2eb45ecc6, (v) => $56ea5fef7dd9e228$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $56ea5fef7dd9e228$export$f7e8a0bf92324b1e, (v) => $56ea5fef7dd9e228$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $56ea5fef7dd9e228$export$83d89fbfd8236492, (v) => $56ea5fef7dd9e228$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56ea5fef7dd9e228$export$69ce8ef3fe5cead0;
var $56ea5fef7dd9e228$export$d39a5bbd09211389;
var $56ea5fef7dd9e228$export$cd75ccfd720a3cd4;
var $56ea5fef7dd9e228$export$a0816fa17a9e79be;
var $56ea5fef7dd9e228$export$7292efcadded39f3;
var $56ea5fef7dd9e228$export$da407abadb9b8f86;
var $56ea5fef7dd9e228$export$314cfea32580671c;
var $56ea5fef7dd9e228$export$513ccb98c53b8039;
var $56ea5fef7dd9e228$export$dbca993bc2d264a;
var $56ea5fef7dd9e228$export$4797a8006f0655d0;
var $56ea5fef7dd9e228$export$c78a37762a8d58e1;
var $56ea5fef7dd9e228$export$606f11b2eb45ecc6;
var $56ea5fef7dd9e228$export$f7e8a0bf92324b1e;
var $56ea5fef7dd9e228$export$83d89fbfd8236492;
"use strict";

var $3xFFA = parcelRequire("3xFFA");
function $56ea5fef7dd9e228$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $56ea5fef7dd9e228$var$noop() {}
var $56ea5fef7dd9e228$var$Internals = {
    d: {
        f: $56ea5fef7dd9e228$var$noop,
        r: function() {
            throw Error($56ea5fef7dd9e228$var$formatProdErrorMessage(522));
        },
        D: $56ea5fef7dd9e228$var$noop,
        C: $56ea5fef7dd9e228$var$noop,
        L: $56ea5fef7dd9e228$var$noop,
        m: $56ea5fef7dd9e228$var$noop,
        X: $56ea5fef7dd9e228$var$noop,
        S: $56ea5fef7dd9e228$var$noop,
        M: $56ea5fef7dd9e228$var$noop
    },
    p: 0,
    findDOMNode: null
}, $56ea5fef7dd9e228$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $56ea5fef7dd9e228$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $56ea5fef7dd9e228$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $56ea5fef7dd9e228$var$ReactSharedInternals = $3xFFA.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $56ea5fef7dd9e228$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$56ea5fef7dd9e228$export$69ce8ef3fe5cead0 = $56ea5fef7dd9e228$var$Internals;
$56ea5fef7dd9e228$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($56ea5fef7dd9e228$var$formatProdErrorMessage(299));
    return $56ea5fef7dd9e228$var$createPortal$1(children, container, null, key);
};
$56ea5fef7dd9e228$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $56ea5fef7dd9e228$var$ReactSharedInternals.T, previousUpdatePriority = $56ea5fef7dd9e228$var$Internals.p;
    try {
        if ($56ea5fef7dd9e228$var$ReactSharedInternals.T = null, $56ea5fef7dd9e228$var$Internals.p = 2, fn) return fn();
    } finally{
        $56ea5fef7dd9e228$var$ReactSharedInternals.T = previousTransition, $56ea5fef7dd9e228$var$Internals.p = previousUpdatePriority, $56ea5fef7dd9e228$var$Internals.d.f();
    }
};
$56ea5fef7dd9e228$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $56ea5fef7dd9e228$var$Internals.d.C(href, options));
};
$56ea5fef7dd9e228$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $56ea5fef7dd9e228$var$Internals.d.D(href);
};
$56ea5fef7dd9e228$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $56ea5fef7dd9e228$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $56ea5fef7dd9e228$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $56ea5fef7dd9e228$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$56ea5fef7dd9e228$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $56ea5fef7dd9e228$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $56ea5fef7dd9e228$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $56ea5fef7dd9e228$var$Internals.d.M(href);
    }
};
$56ea5fef7dd9e228$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $56ea5fef7dd9e228$var$getCrossOriginStringAs(as, options.crossOrigin);
        $56ea5fef7dd9e228$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$56ea5fef7dd9e228$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $56ea5fef7dd9e228$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $56ea5fef7dd9e228$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $56ea5fef7dd9e228$var$Internals.d.m(href);
    }
};
$56ea5fef7dd9e228$export$4797a8006f0655d0 = function(form) {
    $56ea5fef7dd9e228$var$Internals.d.r(form);
};
$56ea5fef7dd9e228$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$56ea5fef7dd9e228$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $56ea5fef7dd9e228$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$56ea5fef7dd9e228$export$f7e8a0bf92324b1e = function() {
    return $56ea5fef7dd9e228$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$56ea5fef7dd9e228$export$83d89fbfd8236492 = "19.2.0";

});



var $cd63cdc3214c7dc5$exports = {};
'use strict';

$cd63cdc3214c7dc5$exports = (parcelRequire("jtku2"));



var $3xFFA = parcelRequire("3xFFA");
var $887e572a59b27363$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $887e572a59b27363$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $887e572a59b27363$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $887e572a59b27363$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$887e572a59b27363$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($887e572a59b27363$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $887e572a59b27363$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $be3710ecc2092733$export$71ad59f2e432cfe8 = "-ms-";
var $be3710ecc2092733$export$2c0f367103c8d01c = "-moz-";
var $be3710ecc2092733$export$39dfd62a25e0fe93 = "-webkit-";
var $be3710ecc2092733$export$a29989082612d0d9 = "comm";
var $be3710ecc2092733$export$aa3a2e812ca8570d = "rule";
var $be3710ecc2092733$export$527d108ccf083c2b = "decl";
var $be3710ecc2092733$export$d3d35020fa5b54f0 = "@page";
var $be3710ecc2092733$export$500415a86c544f73 = "@media";
var $be3710ecc2092733$export$a763edbf796b780a = "@import";
var $be3710ecc2092733$export$2790aeb8b4e5c826 = "@charset";
var $be3710ecc2092733$export$1cc683e23b84b133 = "@viewport";
var $be3710ecc2092733$export$9447a5efea57e862 = "@supports";
var $be3710ecc2092733$export$ef011b4e114b1fba = "@document";
var $be3710ecc2092733$export$6aad947bda0f3f46 = "@namespace";
var $be3710ecc2092733$export$b44a8529a35fcb60 = "@keyframes";
var $be3710ecc2092733$export$2c16de31893252e6 = "@font-face";
var $be3710ecc2092733$export$3d846dd52e150c6f = "@counter-style";
var $be3710ecc2092733$export$22314bfbb57653fe = "@font-feature-values";
var $be3710ecc2092733$export$d773506282b3cfe6 = "@layer";
var $be3710ecc2092733$export$2335f513bbd82c6d = Math.abs;
var $be3710ecc2092733$export$6788812c4e6611e6 = String.fromCharCode;
var $be3710ecc2092733$export$e6e34fd1f2686227 = Object.assign;
function $be3710ecc2092733$export$d6af199866bfb566(e, r) {
    return $be3710ecc2092733$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 0)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 1)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 2)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 3) : 0;
}
function $be3710ecc2092733$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $be3710ecc2092733$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $be3710ecc2092733$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $be3710ecc2092733$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $be3710ecc2092733$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $be3710ecc2092733$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $be3710ecc2092733$export$36776f635604f274(e) {
    return e.length;
}
function $be3710ecc2092733$export$f9084667e487ed46(e) {
    return e.length;
}
function $be3710ecc2092733$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $be3710ecc2092733$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $be3710ecc2092733$export$53f1d5ea8de3d7c = 1;
var $be3710ecc2092733$export$4e0c71f277ca26b3 = 1;
var $be3710ecc2092733$export$f24224f1c91d8156 = 0;
var $be3710ecc2092733$export$5880b8b5730aff45 = 0;
var $be3710ecc2092733$export$c0306caf338ac095 = 0;
var $be3710ecc2092733$export$30a86d91af8ff6e6 = "";
function $be3710ecc2092733$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $be3710ecc2092733$export$53f1d5ea8de3d7c,
        column: $be3710ecc2092733$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $be3710ecc2092733$export$784d13d8ee351f07(e, r) {
    return $be3710ecc2092733$export$e6e34fd1f2686227($be3710ecc2092733$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $be3710ecc2092733$export$eba6f6f03b0a92e7() {
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$232faf9add678146() {
    $be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$5880b8b5730aff45 > 0 ? $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, --$be3710ecc2092733$export$5880b8b5730aff45) : 0;
    if ($be3710ecc2092733$export$4e0c71f277ca26b3--, $be3710ecc2092733$export$c0306caf338ac095 === 10) $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$53f1d5ea8de3d7c--;
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$48cfd1e771a65c4f() {
    $be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$5880b8b5730aff45 < $be3710ecc2092733$export$f24224f1c91d8156 ? $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, $be3710ecc2092733$export$5880b8b5730aff45++) : 0;
    if ($be3710ecc2092733$export$4e0c71f277ca26b3++, $be3710ecc2092733$export$c0306caf338ac095 === 10) $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$53f1d5ea8de3d7c++;
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$4d3fb11e950abb9e() {
    return $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, $be3710ecc2092733$export$5880b8b5730aff45);
}
function $be3710ecc2092733$export$e88cb2efb12ae807() {
    return $be3710ecc2092733$export$5880b8b5730aff45;
}
function $be3710ecc2092733$export$58adb3bec8346d0f(e, r) {
    return $be3710ecc2092733$export$2f35ab04d2335697($be3710ecc2092733$export$30a86d91af8ff6e6, e, r);
}
function $be3710ecc2092733$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $be3710ecc2092733$export$2de70f21292aac9e(e) {
    return $be3710ecc2092733$export$53f1d5ea8de3d7c = $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$f24224f1c91d8156 = $be3710ecc2092733$export$36776f635604f274($be3710ecc2092733$export$30a86d91af8ff6e6 = e), $be3710ecc2092733$export$5880b8b5730aff45 = 0, [];
}
function $be3710ecc2092733$export$45918ac1574455b1(e) {
    return $be3710ecc2092733$export$30a86d91af8ff6e6 = "", e;
}
function $be3710ecc2092733$export$410ac95b9ec204b8(e) {
    return $be3710ecc2092733$export$87c2784dc9fc4ab($be3710ecc2092733$export$58adb3bec8346d0f($be3710ecc2092733$export$5880b8b5730aff45 - 1, $be3710ecc2092733$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $be3710ecc2092733$export$660b2ee2d4fb4eff(e) {
    return $be3710ecc2092733$export$45918ac1574455b1($be3710ecc2092733$export$5f8c09e3ae6f64e1($be3710ecc2092733$export$2de70f21292aac9e(e)));
}
function $be3710ecc2092733$export$7af1228ff777d175(e) {
    while($be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$4d3fb11e950abb9e())if ($be3710ecc2092733$export$c0306caf338ac095 < 33) $be3710ecc2092733$export$48cfd1e771a65c4f();
    else break;
    return $be3710ecc2092733$export$9e1725a4cfeada27(e) > 2 || $be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $be3710ecc2092733$export$5f8c09e3ae6f64e1(e) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())switch($be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$c0306caf338ac095)){
        case 0:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$c2ab62c7bf24634($be3710ecc2092733$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$410ac95b9ec204b8($be3710ecc2092733$export$c0306caf338ac095), e);
            break;
        default:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$6788812c4e6611e6($be3710ecc2092733$export$c0306caf338ac095), e);
    }
    return e;
}
function $be3710ecc2092733$export$955ba06d119e085e(e, r) {
    while(--r && $be3710ecc2092733$export$48cfd1e771a65c4f())if ($be3710ecc2092733$export$c0306caf338ac095 < 48 || $be3710ecc2092733$export$c0306caf338ac095 > 102 || $be3710ecc2092733$export$c0306caf338ac095 > 57 && $be3710ecc2092733$export$c0306caf338ac095 < 65 || $be3710ecc2092733$export$c0306caf338ac095 > 70 && $be3710ecc2092733$export$c0306caf338ac095 < 97) break;
    return $be3710ecc2092733$export$58adb3bec8346d0f(e, $be3710ecc2092733$export$e88cb2efb12ae807() + (r < 6 && $be3710ecc2092733$export$4d3fb11e950abb9e() == 32 && $be3710ecc2092733$export$48cfd1e771a65c4f() == 32));
}
function $be3710ecc2092733$export$c889f2fcc19dbf12(e) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())switch($be3710ecc2092733$export$c0306caf338ac095){
        case e:
            return $be3710ecc2092733$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $be3710ecc2092733$export$c889f2fcc19dbf12($be3710ecc2092733$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $be3710ecc2092733$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $be3710ecc2092733$export$48cfd1e771a65c4f();
            break;
    }
    return $be3710ecc2092733$export$5880b8b5730aff45;
}
function $be3710ecc2092733$export$4254d4e2b3745c4c(e, r) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())if (e + $be3710ecc2092733$export$c0306caf338ac095 === 57) break;
    else if (e + $be3710ecc2092733$export$c0306caf338ac095 === 84 && $be3710ecc2092733$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $be3710ecc2092733$export$58adb3bec8346d0f(r, $be3710ecc2092733$export$5880b8b5730aff45 - 1) + "*" + $be3710ecc2092733$export$6788812c4e6611e6(e === 47 ? e : $be3710ecc2092733$export$48cfd1e771a65c4f());
}
function $be3710ecc2092733$export$c2ab62c7bf24634(e) {
    while(!$be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$4d3fb11e950abb9e()))$be3710ecc2092733$export$48cfd1e771a65c4f();
    return $be3710ecc2092733$export$58adb3bec8346d0f(e, $be3710ecc2092733$export$5880b8b5730aff45);
}
function $be3710ecc2092733$export$ef7acd7185315e22(e) {
    return $be3710ecc2092733$export$45918ac1574455b1($be3710ecc2092733$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $be3710ecc2092733$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $be3710ecc2092733$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $be3710ecc2092733$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $be3710ecc2092733$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($be3710ecc2092733$export$f8e21b1e77979a08(j += $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $be3710ecc2092733$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $be3710ecc2092733$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $be3710ecc2092733$export$955ba06d119e085e($be3710ecc2092733$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($be3710ecc2092733$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$4a34f930e789283c($be3710ecc2092733$export$4254d4e2b3745c4c($be3710ecc2092733$export$48cfd1e771a65c4f(), $be3710ecc2092733$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $be3710ecc2092733$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $be3710ecc2092733$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $be3710ecc2092733$export$36776f635604f274(j) - l) $be3710ecc2092733$export$10d8903dec122b9d(p > 32 ? $be3710ecc2092733$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $be3710ecc2092733$export$f8483753829ec8f3($be3710ecc2092733$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $be3710ecc2092733$export$10d8903dec122b9d(y = $be3710ecc2092733$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $be3710ecc2092733$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $be3710ecc2092733$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $be3710ecc2092733$export$98e6a39c04603d36(e, y, y, n && $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $be3710ecc2092733$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $be3710ecc2092733$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $be3710ecc2092733$export$232faf9add678146() == 125) continue;
            }
            switch(j += $be3710ecc2092733$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($be3710ecc2092733$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($be3710ecc2092733$export$4d3fb11e950abb9e() === 45) j += $be3710ecc2092733$export$410ac95b9ec204b8($be3710ecc2092733$export$48cfd1e771a65c4f());
                    v = $be3710ecc2092733$export$4d3fb11e950abb9e(), o = l = $be3710ecc2092733$export$36776f635604f274(g = j += $be3710ecc2092733$export$c2ab62c7bf24634($be3710ecc2092733$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $be3710ecc2092733$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $be3710ecc2092733$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $be3710ecc2092733$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $be3710ecc2092733$export$2f35ab04d2335697(e, v + 1, v = $be3710ecc2092733$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $be3710ecc2092733$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $be3710ecc2092733$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, s === 0 ? $be3710ecc2092733$export$aa3a2e812ca8570d : i, f, o, l);
}
function $be3710ecc2092733$export$4a34f930e789283c(e, r, a) {
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, $be3710ecc2092733$export$a29989082612d0d9, $be3710ecc2092733$export$6788812c4e6611e6($be3710ecc2092733$export$eba6f6f03b0a92e7()), $be3710ecc2092733$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $be3710ecc2092733$export$f8483753829ec8f3(e, r, a, n) {
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, $be3710ecc2092733$export$527d108ccf083c2b, $be3710ecc2092733$export$2f35ab04d2335697(e, 0, n), $be3710ecc2092733$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $be3710ecc2092733$export$82e9f45cca5ba907(n, c, s) {
    switch($be3710ecc2092733$export$d6af199866bfb566(n, c)){
        case 5103:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $be3710ecc2092733$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$2c0f367103c8d01c + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($be3710ecc2092733$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-$1$2" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-item-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$be3710ecc2092733$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-row-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-line-pack" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-grow", "") + $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-pack:$3" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $be3710ecc2092733$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$be3710ecc2092733$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-column-align" + $be3710ecc2092733$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $be3710ecc2092733$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$be3710ecc2092733$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$be3710ecc2092733$export$f8e21b1e77979a08(s, "span") ? $be3710ecc2092733$export$4659b591c19bdf3d(s, /\d+/) : +$be3710ecc2092733$export$4659b591c19bdf3d(s, /\d+/) - +$be3710ecc2092733$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $be3710ecc2092733$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($be3710ecc2092733$export$36776f635604f274(n) - 1 - c > 6) switch($be3710ecc2092733$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($be3710ecc2092733$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $be3710ecc2092733$export$2c0f367103c8d01c + ($be3710ecc2092733$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$be3710ecc2092733$export$f8e21b1e77979a08(n, "stretch") ? $be3710ecc2092733$export$82e9f45cca5ba907($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $be3710ecc2092733$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $be3710ecc2092733$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($be3710ecc2092733$export$a9db5e087081082d(n, c + 6) === 121) return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, ":", ":" + $be3710ecc2092733$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($be3710ecc2092733$export$a9db5e087081082d(n, $be3710ecc2092733$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + ($be3710ecc2092733$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, ":", ":" + $be3710ecc2092733$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $be3710ecc2092733$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $be3710ecc2092733$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $be3710ecc2092733$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $be3710ecc2092733$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $be3710ecc2092733$export$a763edbf796b780a:
        case $be3710ecc2092733$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $be3710ecc2092733$export$a29989082612d0d9:
            return "";
        case $be3710ecc2092733$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $be3710ecc2092733$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $be3710ecc2092733$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $be3710ecc2092733$export$36776f635604f274(a = $be3710ecc2092733$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $be3710ecc2092733$export$5a7767152ae0305f(e) {
    var r = $be3710ecc2092733$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $be3710ecc2092733$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $be3710ecc2092733$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $be3710ecc2092733$export$527d108ccf083c2b:
                n.return = $be3710ecc2092733$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $be3710ecc2092733$export$b44a8529a35fcb60:
                return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                    $be3710ecc2092733$export$784d13d8ee351f07(n, {
                        value: $be3710ecc2092733$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $be3710ecc2092733$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $be3710ecc2092733$export$aa3a2e812ca8570d:
                if (n.length) return $be3710ecc2092733$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($be3710ecc2092733$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $be3710ecc2092733$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $be3710ecc2092733$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $be3710ecc2092733$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $be3710ecc2092733$export$76a88f7de6507443(e) {
    switch(e.type){
        case $be3710ecc2092733$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $be3710ecc2092733$export$1be1fc439b849fdf($be3710ecc2092733$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($be3710ecc2092733$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $be3710ecc2092733$export$2f35ab04d2335697(r, 1, $be3710ecc2092733$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $be3710ecc2092733$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $be3710ecc2092733$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $be3710ecc2092733$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $5dceb7a01231679c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $e015ec02b8c36601$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $e8de59cef78c71aa$var$isBrowser = typeof document !== 'undefined';
var $e8de59cef78c71aa$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $be3710ecc2092733$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $be3710ecc2092733$export$9e1725a4cfeada27)(character)) break;
        (0, $be3710ecc2092733$export$48cfd1e771a65c4f)();
    }
    return (0, $be3710ecc2092733$export$58adb3bec8346d0f)(begin, (0, $be3710ecc2092733$export$5880b8b5730aff45));
};
var $e8de59cef78c71aa$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $be3710ecc2092733$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $be3710ecc2092733$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $e8de59cef78c71aa$var$identifierWithPointTracking((0, $be3710ecc2092733$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $be3710ecc2092733$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $be3710ecc2092733$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $be3710ecc2092733$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $be3710ecc2092733$export$48cfd1e771a65c4f)());
    return parsed;
};
var $e8de59cef78c71aa$var$getRules = function getRules(value, points) {
    return (0, $be3710ecc2092733$export$45918ac1574455b1)($e8de59cef78c71aa$var$toRules((0, $be3710ecc2092733$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $e8de59cef78c71aa$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $e8de59cef78c71aa$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$e8de59cef78c71aa$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $e8de59cef78c71aa$var$fixedElements.set(element, true);
    var points = [];
    var rules = $e8de59cef78c71aa$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $e8de59cef78c71aa$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $e8de59cef78c71aa$var$prefix(value, length) {
    switch((0, $be3710ecc2092733$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$2c0f367103c8d01c) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + 'box-' + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)((0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)((0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)((0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $be3710ecc2092733$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $be3710ecc2092733$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $be3710ecc2092733$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $be3710ecc2092733$export$2c0f367103c8d01c) + ((0, $be3710ecc2092733$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $be3710ecc2092733$export$f8e21b1e77979a08)(value, 'stretch') ? $e8de59cef78c71aa$var$prefix((0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $be3710ecc2092733$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $be3710ecc2092733$export$a9db5e087081082d)(value, (0, $be3710ecc2092733$export$36776f635604f274)(value) - 3 - (~(0, $be3710ecc2092733$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + ((0, $be3710ecc2092733$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $be3710ecc2092733$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + value + (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $e8de59cef78c71aa$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $be3710ecc2092733$export$527d108ccf083c2b:
                element["return"] = $e8de59cef78c71aa$var$prefix(element.value, element.length);
                break;
            case 0, $be3710ecc2092733$export$b44a8529a35fcb60:
                return (0, $be3710ecc2092733$export$dfdc1655ccc5b9cb)([
                    (0, $be3710ecc2092733$export$784d13d8ee351f07)(element, {
                        value: (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $be3710ecc2092733$export$aa3a2e812ca8570d:
                if (element.length) return (0, $be3710ecc2092733$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $be3710ecc2092733$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $be3710ecc2092733$export$dfdc1655ccc5b9cb)([
                                (0, $be3710ecc2092733$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $be3710ecc2092733$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $be3710ecc2092733$export$dfdc1655ccc5b9cb)([
                                (0, $be3710ecc2092733$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $be3710ecc2092733$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $be3710ecc2092733$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $be3710ecc2092733$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $be3710ecc2092733$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $be3710ecc2092733$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $be3710ecc2092733$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $e8de59cef78c71aa$var$getServerStylisCache = $e8de59cef78c71aa$var$isBrowser ? undefined : (0, $5dceb7a01231679c$export$2e2bcd8739ae039)(function() {
    return (0, $e015ec02b8c36601$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $e8de59cef78c71aa$var$defaultStylisPlugins = [
    $e8de59cef78c71aa$var$prefixer
];
var $e8de59cef78c71aa$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($e8de59cef78c71aa$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $e8de59cef78c71aa$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($e8de59cef78c71aa$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $e8de59cef78c71aa$var$compat,
        $e8de59cef78c71aa$var$removeLabel
    ];
    if (!$e8de59cef78c71aa$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $be3710ecc2092733$export$fac44ee5b035f737),
            (0, $be3710ecc2092733$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $be3710ecc2092733$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $be3710ecc2092733$export$dfdc1655ccc5b9cb)((0, $be3710ecc2092733$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $be3710ecc2092733$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $be3710ecc2092733$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $be3710ecc2092733$export$dfdc1655ccc5b9cb)((0, $be3710ecc2092733$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $e8de59cef78c71aa$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $887e572a59b27363$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039() {
    return $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039.apply(null, arguments);
}



var $35f9bc7c0d546ba3$exports = {};
'use strict';
var $6df612c424d59fc3$exports = {};
'use strict';

$6df612c424d59fc3$exports = (parcelRequire("dhnve"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $35f9bc7c0d546ba3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $35f9bc7c0d546ba3$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$TYPE_STATICS = {};
$35f9bc7c0d546ba3$var$TYPE_STATICS[$6df612c424d59fc3$exports.ForwardRef] = $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS;
$35f9bc7c0d546ba3$var$TYPE_STATICS[$6df612c424d59fc3$exports.Memo] = $35f9bc7c0d546ba3$var$MEMO_STATICS;
function $35f9bc7c0d546ba3$var$getStatics(component) {
    // React v16.11 and below
    if ($6df612c424d59fc3$exports.isMemo(component)) return $35f9bc7c0d546ba3$var$MEMO_STATICS;
     // React v16.12 and above
    return $35f9bc7c0d546ba3$var$TYPE_STATICS[component['$$typeof']] || $35f9bc7c0d546ba3$var$REACT_STATICS;
}
var $35f9bc7c0d546ba3$var$defineProperty = Object.defineProperty;
var $35f9bc7c0d546ba3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $35f9bc7c0d546ba3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $35f9bc7c0d546ba3$var$getPrototypeOf = Object.getPrototypeOf;
var $35f9bc7c0d546ba3$var$objectPrototype = Object.prototype;
function $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($35f9bc7c0d546ba3$var$objectPrototype) {
            var inheritedComponent = $35f9bc7c0d546ba3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $35f9bc7c0d546ba3$var$objectPrototype) $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $35f9bc7c0d546ba3$var$getOwnPropertyNames(sourceComponent);
        if ($35f9bc7c0d546ba3$var$getOwnPropertySymbols) keys = keys.concat($35f9bc7c0d546ba3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $35f9bc7c0d546ba3$var$getStatics(targetComponent);
        var sourceStatics = $35f9bc7c0d546ba3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$35f9bc7c0d546ba3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $35f9bc7c0d546ba3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$35f9bc7c0d546ba3$exports = $35f9bc7c0d546ba3$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $a74f3072064f1ed3$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($35f9bc7c0d546ba3$exports)))(targetComponent, sourceComponent);
};


var $27911428553baf2d$var$isBrowser = typeof document !== 'undefined';
function $27911428553baf2d$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $27911428553baf2d$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $27911428553baf2d$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $27911428553baf2d$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $27911428553baf2d$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$27911428553baf2d$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$27911428553baf2d$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7afb77f31dbef2ab$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $21cb5de91d0b0040$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $aa3b5868d1a715ff$var$isDevelopment = false;
var $aa3b5868d1a715ff$var$hyphenateRegex = /[A-Z]|^ms/g;
var $aa3b5868d1a715ff$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $aa3b5868d1a715ff$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $aa3b5868d1a715ff$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $aa3b5868d1a715ff$var$processStyleName = /* #__PURE__ */ (0, $e015ec02b8c36601$export$2e2bcd8739ae039)(function(styleName) {
    return $aa3b5868d1a715ff$var$isCustomProperty(styleName) ? styleName : styleName.replace($aa3b5868d1a715ff$var$hyphenateRegex, '-$&').toLowerCase();
});
var $aa3b5868d1a715ff$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($aa3b5868d1a715ff$var$animationRegex, function(match, p1, p2) {
                $aa3b5868d1a715ff$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $aa3b5868d1a715ff$var$cursor
                };
                return p1;
            });
    }
    if ((0, $21cb5de91d0b0040$export$2e2bcd8739ae039)[key] !== 1 && !$aa3b5868d1a715ff$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $aa3b5868d1a715ff$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $aa3b5868d1a715ff$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $aa3b5868d1a715ff$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $aa3b5868d1a715ff$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $aa3b5868d1a715ff$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $aa3b5868d1a715ff$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $aa3b5868d1a715ff$var$cursor;
                var result = interpolation(mergedProps);
                $aa3b5868d1a715ff$var$cursor = previousCursor;
                return $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $aa3b5868d1a715ff$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($aa3b5868d1a715ff$var$isProcessableValue(asString)) string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + $aa3b5868d1a715ff$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $aa3b5868d1a715ff$var$isDevelopment) throw new Error($aa3b5868d1a715ff$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($aa3b5868d1a715ff$var$isProcessableValue(value[_i])) string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + $aa3b5868d1a715ff$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $aa3b5868d1a715ff$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $aa3b5868d1a715ff$var$cursor;
function $aa3b5868d1a715ff$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $aa3b5868d1a715ff$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $aa3b5868d1a715ff$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $aa3b5868d1a715ff$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $7afb77f31dbef2ab$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $aa3b5868d1a715ff$var$cursor
    };
}



var $3xFFA = parcelRequire("3xFFA");
var $73baf61291a3f799$var$isBrowser = typeof document !== 'undefined';
var $73baf61291a3f799$var$syncFallback = function syncFallback(create) {
    return create();
};
var $73baf61291a3f799$var$useInsertionEffect = $3xFFA.useInsertionEffect ? $3xFFA.useInsertionEffect : false;
var $73baf61291a3f799$export$db21c7ffa21794e7 = !$73baf61291a3f799$var$isBrowser ? $73baf61291a3f799$var$syncFallback : $73baf61291a3f799$var$useInsertionEffect || $73baf61291a3f799$var$syncFallback;
var $73baf61291a3f799$export$811a713a7276cb9d = $73baf61291a3f799$var$useInsertionEffect || $3xFFA.useLayoutEffect;


var $a0dad71f2f8a4418$export$407448d2b89b1813 = false;
var $a0dad71f2f8a4418$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $a0dad71f2f8a4418$var$EmotionCacheContext = /* #__PURE__ */ $3xFFA.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $e8de59cef78c71aa$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $a0dad71f2f8a4418$export$e7094788287c5e9b = $a0dad71f2f8a4418$var$EmotionCacheContext.Provider;
var $a0dad71f2f8a4418$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3xFFA.useContext)($a0dad71f2f8a4418$var$EmotionCacheContext);
};
var $a0dad71f2f8a4418$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $3xFFA.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3xFFA.useContext)($a0dad71f2f8a4418$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$a0dad71f2f8a4418$export$23f2a1d2818174ef) $a0dad71f2f8a4418$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $3xFFA.useContext)($a0dad71f2f8a4418$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $e8de59cef78c71aa$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $3xFFA.createElement($a0dad71f2f8a4418$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $a0dad71f2f8a4418$export$971d5caa766a69d7 = /* #__PURE__ */ $3xFFA.createContext({});
var $a0dad71f2f8a4418$export$3b14a55fb2447963 = function useTheme() {
    return $3xFFA.useContext($a0dad71f2f8a4418$export$971d5caa766a69d7);
};
var $a0dad71f2f8a4418$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $a0dad71f2f8a4418$var$createCacheWithTheme = /* #__PURE__ */ (0, $5dceb7a01231679c$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $5dceb7a01231679c$export$2e2bcd8739ae039)(function(theme) {
        return $a0dad71f2f8a4418$var$getTheme(outerTheme, theme);
    });
});
var $a0dad71f2f8a4418$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $3xFFA.useContext($a0dad71f2f8a4418$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $a0dad71f2f8a4418$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $3xFFA.createElement($a0dad71f2f8a4418$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $a0dad71f2f8a4418$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $3xFFA.forwardRef(function render(props, ref) {
        var theme = $3xFFA.useContext($a0dad71f2f8a4418$export$971d5caa766a69d7);
        return /*#__PURE__*/ $3xFFA.createElement(Component, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $a74f3072064f1ed3$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $a0dad71f2f8a4418$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $a0dad71f2f8a4418$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $a0dad71f2f8a4418$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($a0dad71f2f8a4418$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$a0dad71f2f8a4418$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $a0dad71f2f8a4418$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $27911428553baf2d$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $73baf61291a3f799$export$db21c7ffa21794e7)(function() {
        return (0, $27911428553baf2d$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$a0dad71f2f8a4418$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $3xFFA.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $a0dad71f2f8a4418$var$Emotion = /* #__PURE__ */ $a0dad71f2f8a4418$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$a0dad71f2f8a4418$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $27911428553baf2d$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $aa3b5868d1a715ff$export$6321afa313b251b5)(registeredStyles, undefined, $3xFFA.useContext($a0dad71f2f8a4418$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($a0dad71f2f8a4418$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $a0dad71f2f8a4418$var$typePropName && !$a0dad71f2f8a4418$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $3xFFA.createElement($3xFFA.Fragment, null, /*#__PURE__*/ $3xFFA.createElement($a0dad71f2f8a4418$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $3xFFA.createElement(WrappedComponent, newProps));
});
var $a0dad71f2f8a4418$export$a9c23c6ac3fc3eca = $a0dad71f2f8a4418$var$Emotion;


parcelRequire("3xFFA");

var $ea91494f21666f34$exports = {};
function $ea91494f21666f34$var$_extends() {
    return $ea91494f21666f34$exports = $ea91494f21666f34$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea91494f21666f34$exports.__esModule = true, $ea91494f21666f34$exports["default"] = $ea91494f21666f34$exports, $ea91494f21666f34$var$_extends.apply(null, arguments);
}
$ea91494f21666f34$exports = $ea91494f21666f34$var$_extends, $ea91494f21666f34$exports.__esModule = true, $ea91494f21666f34$exports["default"] = $ea91494f21666f34$exports;








var $0743a88a30c3c026$export$ffb0004e005737fa = $cd63cdc3214c7dc5$exports.Fragment;
var $0743a88a30c3c026$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $a0dad71f2f8a4418$export$dda1d9f60106f0e9).call(props, 'css')) return $cd63cdc3214c7dc5$exports.jsx(type, props, key);
    return $cd63cdc3214c7dc5$exports.jsx((0, $a0dad71f2f8a4418$export$a9c23c6ac3fc3eca), (0, $a0dad71f2f8a4418$export$db3b6bfb95261072)(type, props), key);
};
var $0743a88a30c3c026$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $a0dad71f2f8a4418$export$dda1d9f60106f0e9).call(props, 'css')) return $cd63cdc3214c7dc5$exports.jsxs(type, props, key);
    return $cd63cdc3214c7dc5$exports.jsxs((0, $a0dad71f2f8a4418$export$a9c23c6ac3fc3eca), (0, $a0dad71f2f8a4418$export$db3b6bfb95261072)(type, props), key);
};


var $0f51dce6f3d66152$exports = {};
'use strict';
function $0f51dce6f3d66152$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0f51dce6f3d66152$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0f51dce6f3d66152$var$checkDCE();

$0f51dce6f3d66152$exports = (parcelRequire("daXOJ"));



var $3xFFA = parcelRequire("3xFFA");


var $3xFFA = parcelRequire("3xFFA");
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $3xFFA = parcelRequire("3xFFA");
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $0ba4d9d227a388be$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $0ba4d9d227a388be$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $0ba4d9d227a388be$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $0ba4d9d227a388be$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $0ba4d9d227a388be$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $0ba4d9d227a388be$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $3xFFA = parcelRequire("3xFFA");
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $965e4076cca86926$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $dfbd48558cb94d72$export$2e2bcd8739ae039 = (0, $3xFFA.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $3xFFA.createElement)("svg", {
        ref: ref,
        ...(0, $965e4076cca86926$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $0ba4d9d227a388be$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $0ba4d9d227a388be$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $3xFFA.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $38801fe8a7e31244$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $3xFFA.forwardRef)(({ className: className, ...props }, ref)=>(0, $3xFFA.createElement)((0, $dfbd48558cb94d72$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $0ba4d9d227a388be$export$3d46f4579dba46e5)(`lucide-${(0, $0ba4d9d227a388be$export$73bda83cddbc7187)((0, $0ba4d9d227a388be$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $0ba4d9d227a388be$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $490842de9f509506$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $490842de9f509506$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("arrow-right", $490842de9f509506$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $52eca6c4d4790f60$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $52eca6c4d4790f60$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("check", $52eca6c4d4790f60$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1b4777838600eaef$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $1b4777838600eaef$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("chevron-right", $1b4777838600eaef$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9226682eb372e291$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.54 15H17a2 2 0 0 0-2 2v4.54",
            key: "1djwo0"
        }
    ],
    [
        "path",
        {
            d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
            key: "1tzkfa"
        }
    ],
    [
        "path",
        {
            d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05",
            key: "14pb5j"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $9226682eb372e291$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("earth", $9226682eb372e291$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fe0914acc94938d7$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
];
const $fe0914acc94938d7$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("globe", $fe0914acc94938d7$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $784b3f579e3d10b5$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $784b3f579e3d10b5$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("lock", $784b3f579e3d10b5$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $62f4f3057600d676$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
            key: "m3kijz"
        }
    ],
    [
        "path",
        {
            d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
            key: "1fmvmk"
        }
    ],
    [
        "path",
        {
            d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0",
            key: "1f8sc4"
        }
    ],
    [
        "path",
        {
            d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
            key: "qeys4"
        }
    ]
];
const $62f4f3057600d676$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("rocket", $62f4f3057600d676$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ec84d8b1fa554c8d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
];
const $ec84d8b1fa554c8d$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("shield", $ec84d8b1fa554c8d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9e9a56228bcf9155$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
            key: "1s2grr"
        }
    ],
    [
        "path",
        {
            d: "M20 2v4",
            key: "1rf3ol"
        }
    ],
    [
        "path",
        {
            d: "M22 4h-4",
            key: "gwowj6"
        }
    ],
    [
        "circle",
        {
            cx: "4",
            cy: "20",
            r: "2",
            key: "6kqj1y"
        }
    ]
];
const $9e9a56228bcf9155$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("sparkles", $9e9a56228bcf9155$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $99823a0e7d4bef74$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $99823a0e7d4bef74$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("star", $99823a0e7d4bef74$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1258fca0762ab423$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const $1258fca0762ab423$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("trending-up", $1258fca0762ab423$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $daf06ec5650a1b91$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
];
const $daf06ec5650a1b91$export$2e2bcd8739ae039 = (0, $38801fe8a7e31244$export$2e2bcd8739ae039)("zap", $daf06ec5650a1b91$export$3efd853dbb351e94);




var $3xFFA = parcelRequire("3xFFA");
const $ea5b9f98408c9856$var$Particles = ({ className: className, quantity: quantity = 100, staticity: staticity = 50, ease: ease = 50, size: size = 0.4, color: color = "#ffffff" })=>{
    const canvasRef = (0, $3xFFA.useRef)(null);
    const canvasContainerRef = (0, $3xFFA.useRef)(null);
    const context = (0, $3xFFA.useRef)(null);
    const circles = (0, $3xFFA.useRef)([]);
    const mousePosition = (0, $3xFFA.useRef)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, $3xFFA.useRef)(false);
    const canvasSize = (0, $3xFFA.useRef)({
        w: 0,
        h: 0
    });
    const dpr = typeof window !== "undefined" ? window.devicePixelRatio : 1;
    (0, $3xFFA.useEffect)(()=>{
        if (canvasRef.current) context.current = canvasRef.current.getContext("2d");
        initCanvas();
        animate();
        window.addEventListener("resize", initCanvas);
        return ()=>window.removeEventListener("resize", initCanvas);
    }, [
        color
    ]);
    (0, $3xFFA.useEffect)(()=>{
        onMouseMove();
    }, [
        staticity,
        ease
    ]);
    const initCanvas = ()=>{
        resizeCanvas();
        drawParticles();
    };
    const onMouseMove = ()=>{
        if (canvasRef.current) {
            const rect = canvasRef.current.getBoundingClientRect();
            const handleMouseMove = (e)=>{
                mousePosition.current = {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                };
                mouseMoveRef.current = true;
            };
            const handleMouseLeave = ()=>{
                mouseMoveRef.current = false;
            };
            canvasRef.current.addEventListener("mousemove", handleMouseMove);
            canvasRef.current.addEventListener("mouseleave", handleMouseLeave);
            return ()=>{
                if (canvasRef.current) {
                    canvasRef.current.removeEventListener("mousemove", handleMouseMove);
                    canvasRef.current.removeEventListener("mouseleave", handleMouseLeave);
                }
            };
        }
    };
    const resizeCanvas = ()=>{
        if (canvasContainerRef.current && canvasRef.current && context.current) {
            circles.current.length = 0;
            canvasSize.current.w = canvasContainerRef.current.offsetWidth;
            canvasSize.current.h = canvasContainerRef.current.offsetHeight;
            canvasRef.current.width = canvasSize.current.w * dpr;
            canvasRef.current.height = canvasSize.current.h * dpr;
            canvasRef.current.style.width = `${canvasSize.current.w}px`;
            canvasRef.current.style.height = `${canvasSize.current.h}px`;
            context.current.scale(dpr, dpr);
        }
    };
    const circleParams = ()=>{
        const x = Math.floor(Math.random() * canvasSize.current.w);
        const y = Math.floor(Math.random() * canvasSize.current.h);
        const translateX = 0;
        const translateY = 0;
        const pSize = Math.floor(Math.random() * 2) + size;
        const alpha = 0;
        const targetAlpha = parseFloat((Math.random() * 0.6 + 0.1).toFixed(1));
        const dx = (Math.random() - 0.5) * 0.1;
        const dy = (Math.random() - 0.5) * 0.1;
        const magnetism = 0.1 + Math.random() * 4;
        return {
            x: x,
            y: y,
            translateX: translateX,
            translateY: translateY,
            size: pSize,
            alpha: alpha,
            targetAlpha: targetAlpha,
            dx: dx,
            dy: dy,
            magnetism: magnetism
        };
    };
    const drawCircle = (circle, update = false)=>{
        if (context.current) {
            const { x: x, y: y, translateX: translateX, translateY: translateY, size: size, alpha: alpha } = circle;
            context.current.translate(translateX, translateY);
            context.current.beginPath();
            context.current.arc(x, y, size, 0, 2 * Math.PI);
            context.current.fillStyle = `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, ${alpha})`;
            context.current.fill();
            context.current.setTransform(dpr, 0, 0, dpr, 0, 0);
            if (!update) circles.current.push(circle);
        }
    };
    const clearContext = ()=>{
        if (context.current) context.current.clearRect(0, 0, canvasSize.current.w, canvasSize.current.h);
    };
    const drawParticles = ()=>{
        clearContext();
        for(let i = 0; i < quantity; i++){
            const circle = circleParams();
            drawCircle(circle);
        }
    };
    const remapValue = (value, start1, end1, start2, end2)=>{
        const remapped = (value - start1) * (end2 - start2) / (end1 - start1) + start2;
        return remapped > 0 ? remapped : 0;
    };
    const animate = ()=>{
        clearContext();
        circles.current.forEach((circle, i)=>{
            const edge = [
                circle.x + circle.translateX - circle.size,
                canvasSize.current.w - circle.x - circle.translateX - circle.size,
                circle.y + circle.translateY - circle.size,
                canvasSize.current.h - circle.y - circle.translateY - circle.size
            ];
            const closestEdge = edge.reduce((a, b)=>Math.min(a, b));
            const remapClosestEdge = parseFloat(remapValue(closestEdge, 0, 20, 0, 1).toFixed(2));
            if (remapClosestEdge > 1) {
                circle.alpha += 0.02;
                if (circle.alpha > circle.targetAlpha) circle.alpha = circle.targetAlpha;
            } else circle.alpha = circle.targetAlpha * remapClosestEdge;
            circle.x += circle.dx;
            circle.y += circle.dy;
            circle.translateX += (mousePosition.current.x / (staticity / circle.magnetism) - circle.translateX) / ease;
            circle.translateY += (mousePosition.current.y / (staticity / circle.magnetism) - circle.translateY) / ease;
            if (circle.x < -circle.size || circle.x > canvasSize.current.w + circle.size || circle.y < -circle.size || circle.y > canvasSize.current.h + circle.size) {
                circles.current.splice(i, 1);
                const newCircle = circleParams();
                drawCircle(newCircle);
            } else drawCircle({
                ...circle,
                x: circle.x,
                y: circle.y,
                translateX: circle.translateX,
                translateY: circle.translateY,
                alpha: circle.alpha
            }, true);
        });
        window.requestAnimationFrame(animate);
    };
    return /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
        className: className,
        ref: canvasContainerRef,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("canvas", {
            ref: canvasRef
        })
    });
};
var $ea5b9f98408c9856$export$2e2bcd8739ae039 = $ea5b9f98408c9856$var$Particles;




var $3xFFA = parcelRequire("3xFFA");
const $bd34df4266009e3c$var$ActivityFeed = ({ activities: activities, currentActivity: currentActivity, setCurrentActivity: setCurrentActivity })=>{
    const [activityMinimized, setActivityMinimized] = (0, $3xFFA.useState)(true);
    return /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
        className: "fixed bottom-6 right-6 z-50 select-none",
        children: activityMinimized ? // Minimized Pill Mode
        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("button", {
            onClick: ()=>setActivityMinimized(false),
            className: "group flex cursor-pointer items-center gap-3 px-5 py-2 bg-gradient-to-r from-indigo-600/90 to-purple-600/90 backdrop-blur-xl border border-indigo-400/30 rounded-full shadow-md shadow-black/40 hover:shadow-black/60 hover:shadow-2xl transition-all duration-300 hover:scale-105",
            children: [
                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                            className: "w-2 h-2 bg-green-400 rounded-full animate-pulse"
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("span", {
                            className: "text-xs font-semibold text-white",
                            children: [
                                " ",
                                activities[currentActivity].name,
                                " \u2022 ",
                                activities[currentActivity].action
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("svg", {
                    className: "w-4 h-4 text-white/70 group-hover:text-white transition-colors",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M5 15l7-7 7 7"
                    })
                })
            ]
        }) : // Expanded Panel Mode
        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
            className: "w-80 animate-fade-in",
            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                className: "bg-slate-900/95 backdrop-blur-xl border border-black/50 hover:border-slate-800/50 rounded-2xl shadow-2xl shadow-[rgba(0,0,0,0.65)] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                        className: "px-4 py-3 border-b border-slate-700/50 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                        className: "w-2 h-2 bg-green-400 rounded-full animate-pulse"
                                    }),
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                        className: "text-sm font-semibold text-slate-200",
                                        children: "Recent Activity"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("button", {
                                onClick: ()=>setActivityMinimized(true),
                                className: "cursor-pointer text-slate-400 hover:text-slate-200 transition-colors p-1 hover:bg-slate-800/50 rounded-full",
                                title: "Minimize",
                                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("svg", {
                                    className: "w-4 h-4",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M19 9l-7 7-7-7"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                        className: "p-4 space-y-3 max-h-64 overflow-y-auto",
                        children: activities.slice(currentActivity, currentActivity + 3).map((activity, idx)=>/*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                className: "flex items-start gap-3 p-3 bg-slate-800/50 rounded-xl hover:bg-slate-800/70 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                        className: "text-2xl",
                                        children: activity.icon
                                    }),
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                        className: "flex-1 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                className: "flex items-center gap-2 mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                        className: "text-sm font-semibold text-white truncate",
                                                        children: activity.name
                                                    }),
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                        className: "text-xs text-slate-500",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                        className: "text-xs text-slate-400 truncate",
                                                        children: activity.location
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("p", {
                                                className: "text-xs text-slate-400 mb-1",
                                                children: activity.action
                                            }),
                                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                className: "text-xs text-slate-500",
                                                children: activity.time
                                            })
                                        ]
                                    })
                                ]
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                        className: "px-4 py-3 bg-slate-800/30 border-t border-slate-700/50",
                        children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "flex items-center justify-between text-xs",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                    className: "text-slate-400",
                                    children: "47 views this week"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                    className: "text-indigo-400 font-semibold",
                                    children: "\uD83D\uDD25 High demand"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $bd34df4266009e3c$export$2e2bcd8739ae039 = $bd34df4266009e3c$var$ActivityFeed;





var $d07544476170b68d$exports = {};
$d07544476170b68d$exports = import.meta.resolve("bSQcn");


const $cd93687958c8007e$var$LogoImageUrl = new URL($d07544476170b68d$exports);
var $fbb1fbbd634bc4ba$exports = {};
$fbb1fbbd634bc4ba$exports = import.meta.resolve("c0Lye");


const $cd93687958c8007e$var$JLogoImageUrl = new URL($fbb1fbbd634bc4ba$exports);
function $cd93687958c8007e$export$86fbec116b87613f() {
    // const [activityMinimized, setActivityMinimized] = useState(true);
    const [currentActivity, setCurrentActivity] = (0, $3xFFA.useState)(0);
    const [openFaq, setOpenFaq] = (0, $3xFFA.useState)(null);
    const [scrollProgress, setScrollProgress] = (0, $3xFFA.useState)(0);
    const [calcValues, setCalcValues] = (0, $3xFFA.useState)({
        traffic: 5000,
        leadValue: 500,
        conversionRate: 2.5
    });
    // Calculator logic
    const trafficMultiplier = 25; // realtor.io gives 25x traffic boost
    const projectedTraffic = calcValues.traffic * trafficMultiplier;
    const monthlyLeads = projectedTraffic * (calcValues.conversionRate / 100);
    const monthlyRevenue = monthlyLeads * calcValues.leadValue;
    const annualRevenue = monthlyRevenue * 12;
    const domainCost = 5000000;
    const roiMonths = domainCost / monthlyRevenue;
    (0, $3xFFA.useEffect)(()=>{
        const interval = setInterval(()=>{
            setCurrentActivity((prev)=>(prev + 1) % activities.length);
        }, 5000);
        return ()=>clearInterval(interval);
    }, []);
    (0, $3xFFA.useEffect)(()=>{
        const handleScroll = ()=>{
            const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const progress = window.scrollY / totalHeight * 100;
            setScrollProgress(progress);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    // const handleBuyNow = async () => {
    //   const stripe = await window.Stripe('pk_test_YOUR_PUBLISHABLE_KEY');
    //   const response = await fetch('YOUR_BACKEND_URL/create-checkout-session', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ domain: 'realtor.io', price: 5000000 }),
    //   });
    //   const session = await response.json();
    //   const result = await stripe.redirectToCheckout({ sessionId: session.id });
    //   if (result.error) alert(result.error.message);
    // };
    const features = [
        {
            icon: (0, $fe0914acc94938d7$export$2e2bcd8739ae039),
            title: 'Global Recognition',
            desc: 'Instantly recognized by millions worldwide'
        },
        {
            icon: (0, $1258fca0762ab423$export$2e2bcd8739ae039),
            title: '100K+ Monthly Searches',
            desc: 'Massive organic traffic potential'
        },
        {
            icon: (0, $ec84d8b1fa554c8d$export$2e2bcd8739ae039),
            title: 'Ultimate Authority',
            desc: 'Industry-leading credibility built-in'
        },
        {
            icon: (0, $daf06ec5650a1b91$export$2e2bcd8739ae039),
            title: 'SEO Powerhouse',
            desc: 'Exact match domain advantage'
        }
    ];
    const stats = [
        {
            value: '100K+',
            label: 'Monthly Searches'
        },
        {
            value: '15+',
            label: 'Years Established'
        },
        {
            value: '$1B+',
            label: 'Industry Value'
        }
    ];
    const activities = [
        {
            name: 'Sarah M.',
            location: 'New York, NY',
            action: 'Requested information',
            time: '12 minutes ago',
            icon: "\uD83D\uDC64"
        },
        {
            name: 'Michael T.',
            location: 'Los Angeles, CA',
            action: 'Viewed domain details',
            time: '1 hour ago',
            icon: "\uD83D\uDC41\uFE0F"
        },
        {
            name: 'Investment Group',
            location: 'Miami, FL',
            action: 'Made serious inquiry',
            time: '3 hours ago',
            icon: "\uD83D\uDCBC"
        },
        {
            name: 'Jennifer K.',
            location: 'Austin, TX',
            action: 'Added to watchlist',
            time: '5 hours ago',
            icon: "\u2B50"
        },
        {
            name: 'Tech Ventures LLC',
            location: 'San Francisco, CA',
            action: 'Contacted specialist',
            time: '8 hours ago',
            icon: "\uD83C\uDFE2"
        }
    ];
    const faqs = [
        {
            question: "How does the purchase process work?",
            answer: "Once you complete payment through our secure Stripe checkout, we initiate the domain transfer immediately. You'll receive transfer authorization codes and step-by-step instructions via email. Our domain specialists are available 24/7 to guide you through the entire process, which typically takes 5-7 business days to complete."
        },
        {
            question: "Is the $627,000 USD price negotiable?",
            answer: "The price reflects the domain's exceptional value, market position, and revenue potential. realtor.io is a category-defining asset with 100K+ monthly searches and 15+ years of established brand recognition. While we occasionally consider serious offers from qualified buyers, the listed price represents fair market value for this premium digital asset."
        },
        {
            question: "What payment methods do you accept?",
            answer: "We accept all major payment methods through Stripe, including credit cards, bank transfers (ACH/wire), and cryptocurrency. All transactions are processed securely with enterprise-grade encryption. For purchases over $1M, we can arrange custom payment plans or escrow services through Dan.com or Escrow.com."
        },
        {
            question: "Do you offer financing options?",
            answer: "Yes! We understand that premium domain acquisitions represent significant investments. We can arrange flexible financing terms for qualified buyers, including installment plans, lease-to-own agreements, and deferred payment structures. Contact our specialists to discuss custom financing options tailored to your needs."
        },
        {
            question: "What happens after I purchase the domain?",
            answer: "Upon payment confirmation, you'll receive: (1) Transfer authorization codes within 24 - 48 hours, (2) Complete DNS management access, (3) Dedicated support during the transition period. We ensure a seamless handoff with zero downtime."
        },
        {
            question: "Is this a secure transaction?",
            answer: "Absolutely. All transactions are protected by Stripe's industry-leading security, bank-level encryption, and escrow services. We're a verified domain marketplace with thousands of successful transfers. Your payment is held in escrow until the domain transfer is confirmed complete. We also offer buyer protection guarantees and full refund policies if transfer issues arise."
        }
    ];
    return /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
        className: "min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white overflow-hidden relative",
        style: {
            fontFamily: "'Space Grotesk', sans-serif"
        },
        children: [
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $ea5b9f98408c9856$export$2e2bcd8739ae039), {
                className: "absolute inset-0 pointer-events-none",
                quantity: 150,
                ease: 80,
                staticity: 50,
                color: "#6366f1",
                size: 0.5
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                className: "fixed top-0 left-0 right-0 z-50 h-1 bg-slate-900/50",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                    className: "h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all duration-200 ease-out shadow-lg shadow-indigo-500/50",
                    style: {
                        width: `${scrollProgress}%`
                    },
                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                        className: "absolute right-0 top-0 w-20 h-full bg-gradient-to-l from-white/40 to-transparent"
                    })
                })
            }),
            scrollProgress > 5 && /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                className: "fixed top-4 right-2 z-50 px-3 py-1 bg-slate-900/80 backdrop-blur-sm border border-slate-700/50 rounded-full text-xs font-semibold text-slate-300 mr-4",
                children: [
                    Math.round(scrollProgress),
                    "%"
                ]
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $bd34df4266009e3c$export$2e2bcd8739ae039), {
                activities: activities,
                currentActivity: currentActivity,
                setCurrentActivity: setCurrentActivity
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 pt-20 pb-32 px-6",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "flex flex-col justify-center items-center mb-8",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "text-white items-center gap-6 flex self-center w-30 mx-auto mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("svg", {
                                            viewBox: "0 0 32 32",
                                            "aria-hidden": "true",
                                            preserveAspectRatio: "xMinYMid meet",
                                            className: "w-[32px]",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("rect", {
                                                    clipPath: "url(#:R35dba:-clip)",
                                                    className: "h-8 transition-all duration-300 fill-white w-0 group-hover/logo:w-8"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("use", {
                                                    href: "#:R35dba:-path",
                                                    className: "stroke-white",
                                                    fill: "none",
                                                    strokeWidth: "1.5"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("defs", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("path", {
                                                            id: ":R35dba:-path",
                                                            d: "M3.25 26v.75H7c1.305 0 2.384-.21 3.346-.627.96-.415 1.763-1.02 2.536-1.752.695-.657 1.39-1.443 2.152-2.306l.233-.263c.864-.975 1.843-2.068 3.071-3.266 1.209-1.18 2.881-1.786 4.621-1.786h5.791V5.25H25c-1.305 0-2.384.21-3.346.627-.96.415-1.763 1.02-2.536 1.751-.695.658-1.39 1.444-2.152 2.307l-.233.263c-.864.975-1.843 2.068-3.071 3.266-1.209 1.18-2.881 1.786-4.621 1.786H3.25V26Z"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("clipPath", {
                                                            id: ":R35dba:-clip",
                                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("use", {
                                                                href: "#:R35dba:-path"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "100",
                                            height: "100",
                                            viewBox: "0 0 330 32",
                                            "aria-hidden": "true",
                                            fill: "currentColor",
                                            className: "scale-[1.3] transform h-8 block",
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("g", {
                                                id: "Shogun_Logo",
                                                "data-name": "Shogun Logo",
                                                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("text", {
                                                    id: "Shogun",
                                                    className: "select-none font-display text-[64px] font-bold transition-all hover:text-blue-600 text-white cls-1",
                                                    x: "0",
                                                    y: "32.827",
                                                    children: "Shogun.\xae"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "inline-flex items-center gap-2 px-4 py-2 bg-indigo-500/10 border border-indigo-500/20 rounded-full backdrop-blur-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $9226682eb372e291$export$2e2bcd8739ae039), {
                                            className: "w-4 h-4 text-indigo-400"
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                            className: "text-sm font-semibold text-indigo-300",
                                            children: "Premium Domains"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "text-center mb-12",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("h1", {
                                    className: "text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-none",
                                    children: [
                                        "Own The Most Valuable",
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("br", {}),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                            className: "bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400",
                                            children: "Real Estate Domain"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    className: "text-lg md:text-2xl text-slate-300 mb-12 max-w-3xl mx-auto leading-relaxed",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                            children: "realtor.io"
                                        }),
                                        " represents the pinnacle of digital real estate. Instant credibility, massive traffic, and unmatched brand recognition."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("img", {
                                    src: $cd93687958c8007e$var$LogoImageUrl,
                                    className: "mx-auto w-10",
                                    alt: "REALTOR.IO"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                    className: "inline-flex items-baseline gap-3 mb-12",
                                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                        style: {
                                            fontFamily: "Special Gothic Expanded One"
                                        },
                                        className: "text-5xl md:text-6xl lg:text-7xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-400",
                                        children: "$627,000"
                                    })
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "flex flex-col sm:flex-row gap-4 justify-center items-center mb-12",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("a", {
                                            // onClick={handleBuyNow}
                                            href: "https://buy.stripe.com/7sY00aarSfum6Hxe6P7N600",
                                            className: "group relative px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold border border-black/10 border-2 rounded-xl shadow-2xl shadow-indigo-500/50 hover:shadow-indigo-500/80 transform transition-all duration-300",
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("span", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $784b3f579e3d10b5$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5"
                                                    }),
                                                    "Secure Purchase Now",
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $490842de9f509506$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 group-hover:translate-x-1 transition-transform"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("a", {
                                            href: "mailto:j.c@realtor.io",
                                            className: "px-8 py-4 border-2 border-indigo-500/50 text-indigo-300 font-semibold rounded-xl hover:bg-indigo-500/10 transition-all duration-300",
                                            children: "Talk to Specialist"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "flex flex-wrap justify-center gap-6 text-sm text-slate-400",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $52eca6c4d4790f60$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4 text-green-400"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "Instant Transfer"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $52eca6c4d4790f60$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4 text-green-400"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "Secure Escrow"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $52eca6c4d4790f60$export$2e2bcd8739ae039), {
                                                    className: "w-4 h-4 text-green-400"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "100% Guaranteed"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-12 border-y border-slate-800/50 bg-slate-900/30 backdrop-blur-sm",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                    className: "max-w-6xl mx-auto px-6",
                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-8 text-center",
                        children: stats.map((stat, idx)=>/*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                        className: "text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400 mb-2",
                                        children: stat.value
                                    }),
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                        className: "text-slate-400",
                                        children: stat.label
                                    })
                                ]
                            }, idx))
                    })
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-20 px-6",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "text-center mb-16",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h2", {
                                    className: "text-3xl md:text-5xl font-bold mb-4",
                                    children: "Why This Domain Changes Everything"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("p", {
                                    className: "text-xl text-slate-400",
                                    children: "The competitive advantages are undeniable"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6",
                            children: features.map((feature, idx)=>{
                                const Icon = feature.icon;
                                return /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "group p-8 bg-gradient-to-br from-slate-800/50 to-slate-900/50 rounded-2xl border border-slate-700/50 hover:border-indigo-500/50 transition-all duration-300 hover:transform hover:scale-105",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                            className: "mb-6",
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                className: "inline-flex p-3 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-xl border border-indigo-500/30",
                                                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)(Icon, {
                                                    className: "w-6 h-6 text-indigo-400"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h3", {
                                            className: "text-xl font-bold mb-3",
                                            children: feature.title
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("p", {
                                            className: "text-slate-400 leading-relaxed",
                                            children: feature.desc
                                        })
                                    ]
                                }, idx);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-20 px-6",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "text-center mb-12",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h2", {
                                    className: "text-3xl md:text-4xl font-bold mb-4",
                                    children: "Calculate Your ROI"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    className: "text-xl text-slate-400",
                                    children: [
                                        "See how realtor.io could transform your business with a ",
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                            children: "$5M"
                                        }),
                                        " seed investment."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("style", {
                            children: `
            input[type="range"] {
              -webkit-appearance: none;
              appearance: none;
              background: transparent;
              cursor: pointer;
            }

            input[type="range"]::-webkit-slider-track {
              background: linear-gradient(to right, #4f46e5, #7c3aed, #db2777);
              height: 8px;
              border-radius: 9999px;
            }

            input[type="range"]::-moz-range-track {
              background: linear-gradient(to right, #4f46e5, #7c3aed, #db2777);
              height: 8px;
              border-radius: 9999px;
            }

            input[type="range"]::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: linear-gradient(135deg, #6366f1, #a855f7);
              border: 2px solid white;
              box-shadow: 0 0 10px rgba(99, 102, 241, 0.5);
              cursor: pointer;
              margin-top: -6px;
            }

            input[type="range"]::-moz-range-thumb {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: linear-gradient(135deg, #6366f1, #a855f7);
              border: 2px solid white;
              box-shadow: 0 0 10px rgba(99, 102, 241, 0.5);
              cursor: pointer;
            }

            input[type="range"]:hover::-webkit-slider-thumb {
              box-shadow: 0 0 15px rgba(99, 102, 241, 0.8);
              transform: scale(1.1);
            }

            input[type="range"]:hover::-moz-range-thumb {
              box-shadow: 0 0 15px rgba(99, 102, 241, 0.8);
              transform: scale(1.1);
            }
          `
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 gap-8",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "select-none bg-slate-900/50 backdrop-blur-sm rounded-2xl border border-slate-700/50 p-8",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h3", {
                                            style: {
                                                fontFamily: "Special Gothic Expanded One"
                                            },
                                            className: "text-lg mb-6 text-slate-200",
                                            children: "Your Current Metrics"
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "space-y-6",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex justify-between mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("label", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "Monthly Website Traffic"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    className: "text-sm font-semibold text-white",
                                                                    children: calcValues.traffic.toLocaleString()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("input", {
                                                            type: "range",
                                                            min: "1000",
                                                            max: "50000",
                                                            step: "1000",
                                                            value: calcValues.traffic,
                                                            onChange: (e)=>setCalcValues({
                                                                    ...calcValues,
                                                                    traffic: parseInt(e.target.value)
                                                                }),
                                                            className: "w-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex justify-between text-xs text-slate-500 mt-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    children: "1K"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    children: "50K"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex justify-between mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("label", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "Average Lead Value"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("span", {
                                                                    className: "text-sm font-semibold text-white",
                                                                    children: [
                                                                        "$",
                                                                        calcValues.leadValue.toLocaleString()
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("input", {
                                                            type: "range",
                                                            min: "100",
                                                            max: "2000",
                                                            step: "50",
                                                            value: calcValues.leadValue,
                                                            onChange: (e)=>setCalcValues({
                                                                    ...calcValues,
                                                                    leadValue: parseInt(e.target.value)
                                                                }),
                                                            className: "w-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex justify-between text-xs text-slate-500 mt-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    children: "$100"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    children: "$2,000"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex justify-between mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("label", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "Conversion Rate"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("span", {
                                                                    className: "text-sm font-semibold text-white",
                                                                    children: [
                                                                        calcValues.conversionRate,
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("input", {
                                                            type: "range",
                                                            min: "0.5",
                                                            max: "10",
                                                            step: "0.5",
                                                            value: calcValues.conversionRate,
                                                            onChange: (e)=>setCalcValues({
                                                                    ...calcValues,
                                                                    conversionRate: parseFloat(e.target.value)
                                                                }),
                                                            className: "w-full"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex justify-between text-xs text-slate-500 mt-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    children: "0.5%"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    children: "10%"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                            className: "mt-6 p-4 bg-indigo-500/10 border border-indigo-500/20 rounded-xl",
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                                className: "text-xs text-slate-400 leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                                        className: "text-indigo-300",
                                                        children: "Assumption:"
                                                    }),
                                                    " Premium domains like realtor.io typically generate 25x more organic traffic due to brand recognition and SEO authority."
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "select-none bg-gradient-to-br from-indigo-600/20 to-purple-600/20 backdrop-blur-sm rounded-2xl border border-indigo-500/30 p-8",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h3", {
                                            style: {
                                                fontFamily: "Special Gothic Expanded One"
                                            },
                                            className: "text-lg mb-6 text-white",
                                            children: "With realtor.io"
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "space-y-6",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    className: "p-4 bg-black/20 rounded-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex items-center gap-3 mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $1258fca0762ab423$export$2e2bcd8739ae039), {
                                                                    className: "w-5 h-5 text-green-400"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "Projected Monthly Traffic"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                            className: "text-3xl font-bold text-white",
                                                            children: projectedTraffic.toLocaleString()
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "text-xs text-green-400 mt-1",
                                                            children: [
                                                                "+",
                                                                ((trafficMultiplier - 1) * 100).toFixed(0),
                                                                "% increase"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    className: "p-4 bg-black/20 rounded-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex items-center gap-3 mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $9e9a56228bcf9155$export$2e2bcd8739ae039), {
                                                                    className: "w-5 h-5 text-indigo-400"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "Projected Monthly Revenue"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "text-3xl font-bold text-white",
                                                            children: [
                                                                "$",
                                                                monthlyRevenue.toLocaleString(undefined, {
                                                                    maximumFractionDigits: 0
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    className: "p-4 bg-black/20 rounded-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex items-center gap-3 mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $99823a0e7d4bef74$export$2e2bcd8739ae039), {
                                                                    className: "w-5 h-5 text-purple-400"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "Projected Annual Revenue"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "text-3xl font-bold text-white",
                                                            children: [
                                                                "$",
                                                                (annualRevenue / 1000000).toFixed(1),
                                                                "M"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    className: "p-4 bg-black/20 rounded-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "flex items-center gap-3 mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $daf06ec5650a1b91$export$2e2bcd8739ae039), {
                                                                    className: "w-5 h-5 text-yellow-400"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                                    className: "text-sm text-slate-400",
                                                                    children: "ROI Timeline"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "text-3xl font-bold text-white",
                                                            children: [
                                                                roiMonths.toFixed(1),
                                                                " months"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "text-xs text-slate-400 mt-1",
                                                            children: [
                                                                "To recoup $",
                                                                (domainCost / 1000000).toFixed(1),
                                                                "M investment"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("a", {
                                            // onClick={handleBuyNow}
                                            href: "https://buy.stripe.com/7sY00aarSfum6Hxe6P7N600",
                                            className: "flex justify-center w-full mt-6 px-6 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl shadow hover:shadow-md shadow-[rgba(0,0,0,0.3)] transform transition-all duration-300",
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("span", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $784b3f579e3d10b5$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5"
                                                    }),
                                                    "Secure Purchase Now"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-20 px-6 bg-slate-900/30",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "text-center mb-12",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h2", {
                                    className: "text-3xl md:text-4xl font-bold mb-4",
                                    children: "Traffic Trends & Market Demand"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("p", {
                                    className: "text-xl text-slate-400",
                                    children: "Consistent growth in search volume over the past 12 months"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "bg-gradient-to-br from-slate-800/50 to-slate-900/50 rounded-3xl border border-slate-700/50 p-8 md:p-12 backdrop-blur-sm",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "grid grid-cols-3 gap-6 mb-8",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "text-3xl md:text-4xl font-bold text-green-400 mb-2",
                                                    children: "+127%"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "text-sm text-slate-400",
                                                    children: "Year over Year"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "text-3xl md:text-4xl font-bold text-indigo-400 mb-2",
                                                    children: "100K+"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "text-sm text-slate-400",
                                                    children: "Monthly Searches"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "text-3xl md:text-4xl font-bold text-purple-400 mb-2",
                                                    children: "8.2M"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "text-sm text-slate-400",
                                                    children: "Annual Volume"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "relative h-64 md:h-80",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "absolute left-0 top-0 bottom-0 flex flex-col justify-between text-xs text-slate-500 pr-4",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "120K"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "90K"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "60K"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "30K"
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    children: "0"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                            className: "ml-12 h-full relative",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: "absolute inset-0 flex flex-col justify-between",
                                                    children: [
                                                        ...Array(5)
                                                    ].map((_, i)=>/*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                            className: "border-t border-slate-700/30"
                                                        }, i))
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("svg", {
                                                    className: "absolute inset-0 w-full h-full",
                                                    viewBox: "0 0 100 100",
                                                    preserveAspectRatio: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("defs", {
                                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("linearGradient", {
                                                                id: "graphGradient",
                                                                x1: "0%",
                                                                y1: "0%",
                                                                x2: "0%",
                                                                y2: "100%",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("stop", {
                                                                        offset: "0%",
                                                                        stopColor: "#6366f1",
                                                                        stopOpacity: "0.4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("stop", {
                                                                        offset: "100%",
                                                                        stopColor: "#6366f1",
                                                                        stopOpacity: "0.05"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("path", {
                                                            d: "M 0,100 L 0,75 Q 8.33,71 16.66,67 T 33.33,58 T 50,42 T 66.66,33 T 83.33,25 L 100,17 L 100,100 Z",
                                                            fill: "url(#graphGradient)"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("path", {
                                                            d: "M 0,75 Q 8.33,71 16.66,67 T 33.33,58 T 50,42 T 66.66,33 T 83.33,25 L 100,17",
                                                            fill: "none",
                                                            stroke: "#6366f1",
                                                            strokeWidth: "0.8",
                                                            className: "drop-shadow-lg",
                                                            style: {
                                                                filter: 'drop-shadow(0 0 8px rgba(99, 102, 241, 0.6))'
                                                            }
                                                        })
                                                    ]
                                                }),
                                                [
                                                    {
                                                        x: 0,
                                                        y: 75
                                                    },
                                                    {
                                                        x: 16.66,
                                                        y: 67
                                                    },
                                                    {
                                                        x: 33.33,
                                                        y: 58
                                                    },
                                                    {
                                                        x: 50,
                                                        y: 42
                                                    },
                                                    {
                                                        x: 66.66,
                                                        y: 33
                                                    },
                                                    {
                                                        x: 83.33,
                                                        y: 25
                                                    },
                                                    {
                                                        x: 100,
                                                        y: 17
                                                    }
                                                ].map((point, i)=>/*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                        className: "absolute",
                                                        style: {
                                                            left: `${point.x}%`,
                                                            top: `${point.y}%`,
                                                            transform: 'translate(-50%, -50%)'
                                                        },
                                                        children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                                    className: "w-3 h-3 bg-indigo-500 rounded-full shadow-lg"
                                                                }),
                                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                                    className: "absolute inset-0 w-5 h-5 -m-1 border-2 border-indigo-500 rounded-full opacity-30 animate-pulse"
                                                                })
                                                            ]
                                                        })
                                                    }, i)),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                    className: "absolute bottom-0 left-0 right-0 -mb-8 flex justify-between text-xs text-slate-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "Jan"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "Mar"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "May"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "Jul"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "Sep"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "Nov"
                                                        }),
                                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                            children: "Dec"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "mt-12 flex items-center justify-center gap-3 p-4 bg-indigo-500/10 border border-indigo-500/20 rounded-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $1258fca0762ab423$export$2e2bcd8739ae039), {
                                            className: "w-5 h-5 text-indigo-400"
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("span", {
                                            className: "text-sm text-slate-300",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                                    className: "text-indigo-300",
                                                    children: "Trending upward:"
                                                }),
                                                " Search interest has grown 127% year-over-year, indicating increasing market value"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-20 px-6 bg-slate-900/30",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-4xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                            className: "mx-auto w-72",
                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                className: "inline-flex items-baseline gap-3 mb-2",
                                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                    style: {
                                        fontFamily: "Special Gothic Expanded One"
                                    },
                                    className: "text-3xl md:text-4xl lg:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-br from-30% from-white via-purple-500 to-indigo-800",
                                    children: "realtor.io"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h2", {
                            className: "text-3xl md:text-4xl font-bold mb-12 text-center",
                            children: "Domain Specifications"
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                            children: [
                                {
                                    label: 'Extension',
                                    value: '.IO'
                                },
                                {
                                    label: 'Length',
                                    value: '7 characters'
                                },
                                {
                                    label: 'Category',
                                    value: 'Real Estate'
                                },
                                {
                                    label: 'Status',
                                    value: 'Available',
                                    highlight: true
                                }
                            ].map((item, idx)=>/*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "flex justify-between items-center p-5 bg-slate-800/50 rounded-xl border border-slate-700/50",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                            className: "text-slate-400",
                                            children: item.label
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                            className: `font-semibold ${item.highlight ? 'text-green-400' : 'text-white'}`,
                                            children: item.value
                                        })
                                    ]
                                }, idx))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-20 px-6 bg-black",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-4xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "text-center mb-12",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h2", {
                                    className: "text-3xl md:text-4xl font-bold mb-4",
                                    children: "Frequently Asked Questions"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("p", {
                                    className: "text-xl text-slate-400",
                                    children: "Everything you need to know about purchasing this domain"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                            className: "space-y-1",
                            children: faqs.map((faq, idx)=>/*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "overflow-hidden transition-all duration-300",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("button", {
                                            onClick: ()=>setOpenFaq(openFaq === idx ? null : idx),
                                            className: "w-full px-4 py-3 flex items-center justify-between gap-4 text-left group hover:bg-slate-800/30 rounded-lg transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                                    className: "text-sm font-medium text-slate-300 group-hover:text-white transition-colors",
                                                    children: faq.question
                                                }),
                                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                    className: `flex-shrink-0 transition-transform duration-300 ${openFaq === idx ? 'rotate-180' : ''}`,
                                                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $1b4777838600eaef$export$2e2bcd8739ae039), {
                                                        className: "w-3 h-3 text-slate-500 rotate-90"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                            className: `transition-all duration-300 ease-in-out ${openFaq === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`,
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                                className: "px-4 pb-3 text-xs text-slate-400 leading-snug",
                                                children: faq.answer
                                            })
                                        })
                                    ]
                                }, idx))
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "mt-12 relative overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                    className: "absolute inset-0 bg-gradient-to-r from-indigo-600/20 via-purple-600/20 to-indigo-600/20 blur-xl"
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                                    className: "relative p-8 bg-gradient-to-r from-indigo-500/10 to-purple-500/10 rounded-2xl border border-indigo-500/30 backdrop-blur-sm",
                                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                        className: "flex flex-col md:flex-row items-center justify-between gap-6",
                                        children: [
                                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                                className: "text-center md:text-left",
                                                children: [
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h3", {
                                                        className: "text-xl font-bold text-white mb-2",
                                                        children: "Still have questions?"
                                                    }),
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("p", {
                                                        className: "text-sm text-slate-400",
                                                        children: "Our domain specialists are available 24/7 to help you"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("a", {
                                                href: "mailto:j.c@realtor.io",
                                                className: "group px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl shadow shadow-black/70 transform transition-all duration-300 flex items-center gap-2",
                                                children: [
                                                    "Get in Touch",
                                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $490842de9f509506$export$2e2bcd8739ae039), {
                                                        className: "w-4 h-4 group-hover:translate-x-1 transition-transform"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("section", {
                className: "relative z-10 py-20 px-6",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                    className: "max-w-4xl mx-auto text-center",
                    children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                        className: "p-12 bg-gradient-to-br from-indigo-600/20 to-purple-600/20 rounded-3xl border border-indigo-500/30 backdrop-blur-sm",
                        children: [
                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $62f4f3057600d676$export$2e2bcd8739ae039), {
                                className: "w-12 h-12 mx-auto mb-6 text-indigo-400"
                            }),
                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("h2", {
                                className: "text-2xl sm:text-3xl md:text-5xl font-bold mb-6",
                                children: "Ready to Dominate Real Estate?"
                            }),
                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                className: "text-lg sm:text-xl text-slate-300 mb-8",
                                children: [
                                    "Secure realtor.io today and own the most recognizable domain in the industry. The keyword ",
                                    /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("em", {
                                        children: "realtor"
                                    }),
                                    " receives a significant amount of searches per month on Google\xae"
                                ]
                            }),
                            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("a", {
                                // onClick={handleBuyNow}
                                href: "https://buy.stripe.com/7sY00aarSfum6Hxe6P7N600",
                                className: "inline-flex group px-6 sm:px-10 py-5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-lg font-semibold rounded-xl shadow hover:shadow-md shadow-black/50 transform transition-all duration-300",
                                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                    className: "flex items-center gap-3",
                                    children: "Buy for $627,000"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("footer", {
                className: "relative z-10 border-t border-slate-800/50 py-12 px-6",
                children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "flex flex-col items-center mb-8",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    className: "text-slate-500 text-sm mb-6",
                                    children: [
                                        "\xa9 2025 ",
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                            children: "SHOGUN.IO"
                                        }),
                                        "\xae Domain Marketplace. All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                                    className: "flex items-center gap-3 px-6 py-3 bg-slate-900/50 rounded-lg border border-slate-800/50",
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("span", {
                                            className: "text-slate-400 text-sm",
                                            children: "Powered by"
                                        }),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("svg", {
                                            className: "h-6",
                                            viewBox: "0 0 60 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("path", {
                                                d: "M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.65 7.6zM40 8.95c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 0 1-4.27-4.24l.01-13.17 4.02-.86v3.54h3.14V9.1h-3.13v5.85zm-4.91.7c0 2.97-2.31 4.66-5.73 4.66a11.2 11.2 0 0 1-4.46-.93v-3.93c1.38.75 3.1 1.31 4.46 1.31.92 0 1.53-.24 1.53-1C6.26 13.77 0 14.51 0 9.95 0 7.04 2.28 5.3 5.62 5.3c1.36 0 2.72.2 4.09.75v3.88a9.23 9.23 0 0 0-4.1-1.06c-.86 0-1.44.25-1.44.93 0 1.85 6.29.97 6.29 5.88z",
                                                fill: "#6772E5"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("div", {
                            className: "max-w-4xl mx-auto space-y-4 text-xs text-slate-600 leading-relaxed",
                            children: [
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                            className: "text-slate-500",
                                            children: "Legal Disclaimer:"
                                        }),
                                        " This domain sale is subject to verification and approval. All transactions are processed through secure escrow services to protect both buyer and seller. The purchase price is payable in full upon acceptance of offer. Domain transfer will be initiated within 24-48 hours of payment confirmation and may take 5-7 business days to complete depending on registrar processing times."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                            className: "text-slate-500",
                                            children: "Purchase Terms:"
                                        }),
                                        ' By clicking "Buy Now" you agree to purchase the domain "realtor.io" at the listed price of $627,000 USD. Payment is processed securely through Stripe. All sales are final and non-refundable once the domain transfer process has begun. The domain is sold "as-is" with all existing traffic, SEO value, and brand recognition included. Seller makes no warranties regarding future performance, traffic levels, or revenue potential.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("strong", {
                                            className: "text-slate-500",
                                            children: "Transfer Process:"
                                        }),
                                        " Upon successful payment, you will receive transfer authorization codes and detailed instructions via email. Our domain specialists will guide you through the entire transfer process. Transfer fees charged by registrars (if any) are the responsibility of the buyer. Domain ownership will be transferred to the registrar account specified by the buyer during checkout."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)("p", {
                                    className: "text-slate-700 text-[10px]",
                                    children: [
                                        "This Site and the Services are available only to individuals or entities (\u201CUsers\u201D) who can form legally binding contracts under applicable law. By using this Site or the Services, you represent and warrant that you are (i) at least eighteen (18) years of age, (ii) otherwise recognized as being able to form legally binding contracts under applicable law, and/or (iii) are not a person barred from purchasing or receiving the Services found under the laws of the United States or other applicable jurisdiction.",
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("br", {}),
                                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("br", {}),
                                        "For expired domain names purchased through your account, you agree that you are responsible for payment within forty-eight (48) hours of auction close for the successful bid amount plus the one (1) year renewal or transfer fee (from the end of the domain name\u2019s previous registration period), plus ICANN fee, if applicable, or any valid payment method associated with the account, will be charged on the third day following the auction close. If we are unable to collect payment, you may lose the rights to purchase the domain name."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("div", {
                            className: "max-w-4xl mx-auto my-2 flex gap-2 items-center",
                            children: /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)("img", {
                                src: $cd93687958c8007e$var$JLogoImageUrl,
                                className: "w-10",
                                alt: "built by JC\xae"
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $3xFFA = parcelRequire("3xFFA");
"use client";
// package.json
var $a3cc47026fbd254a$var$name = "@vercel/analytics";
var $a3cc47026fbd254a$var$version = "1.5.0";
// src/queue.ts
var $a3cc47026fbd254a$var$initQueue = ()=>{
    if (window.va) return;
    window.va = function a(...params) {
        (window.vaq = window.vaq || []).push(params);
    };
};
// src/utils.ts
function $a3cc47026fbd254a$var$isBrowser() {
    return typeof window !== "undefined";
}
function $a3cc47026fbd254a$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $a3cc47026fbd254a$var$setMode(mode = "auto") {
    if (mode === "auto") {
        window.vam = $a3cc47026fbd254a$var$detectEnvironment();
        return;
    }
    window.vam = mode;
}
function $a3cc47026fbd254a$var$getMode() {
    const mode = $a3cc47026fbd254a$var$isBrowser() ? window.vam : $a3cc47026fbd254a$var$detectEnvironment();
    return mode || "production";
}
function $a3cc47026fbd254a$var$isProduction() {
    return $a3cc47026fbd254a$var$getMode() === "production";
}
function $a3cc47026fbd254a$var$isDevelopment() {
    return $a3cc47026fbd254a$var$getMode() === "development";
}
function $a3cc47026fbd254a$var$removeKey(key, { [key]: _, ...rest }) {
    return rest;
}
function $a3cc47026fbd254a$var$parseProperties(properties, options) {
    if (!properties) return void 0;
    let props = properties;
    const errorProperties = [];
    for (const [key, value] of Object.entries(properties))if (typeof value === "object" && value !== null) {
        if (options.strip) props = $a3cc47026fbd254a$var$removeKey(key, props);
        else errorProperties.push(key);
    }
    if (errorProperties.length > 0 && !options.strip) throw Error(`The following properties are not valid: ${errorProperties.join(", ")}. Only strings, numbers, booleans, and null are allowed.`);
    return props;
}
function $a3cc47026fbd254a$var$getScriptSrc(props) {
    if (props.scriptSrc) return props.scriptSrc;
    if ($a3cc47026fbd254a$var$isDevelopment()) return "https://va.vercel-scripts.com/v1/script.debug.js";
    if (props.basePath) return `${props.basePath}/insights/script.js`;
    return "/_vercel/insights/script.js";
}
// src/generic.ts
function $a3cc47026fbd254a$var$inject(props = {
    debug: true
}) {
    var _a;
    if (!$a3cc47026fbd254a$var$isBrowser()) return;
    $a3cc47026fbd254a$var$setMode(props.mode);
    $a3cc47026fbd254a$var$initQueue();
    if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    const src = $a3cc47026fbd254a$var$getScriptSrc(props);
    if (document.head.querySelector(`script[src*="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $a3cc47026fbd254a$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $a3cc47026fbd254a$var$version;
    if (props.disableAutoTrack) script.dataset.disableAutoTrack = "1";
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    else if (props.basePath) script.dataset.endpoint = `${props.basePath}/insights`;
    if (props.dsn) script.dataset.dsn = props.dsn;
    script.onerror = ()=>{
        const errorMessage = $a3cc47026fbd254a$var$isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
        console.log(`[Vercel Web Analytics] Failed to load script from ${src}. ${errorMessage}`);
    };
    if ($a3cc47026fbd254a$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    document.head.appendChild(script);
}
function $a3cc47026fbd254a$export$6b2a7d5132615086(name2, properties, options) {
    var _a, _b;
    if (!$a3cc47026fbd254a$var$isBrowser()) {
        const msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";
        if ($a3cc47026fbd254a$var$isProduction()) console.warn(msg);
        else throw new Error(msg);
        return;
    }
    if (!properties) {
        (_a = window.va) == null || _a.call(window, "event", {
            name: name2,
            options: options
        });
        return;
    }
    try {
        const props = $a3cc47026fbd254a$var$parseProperties(properties, {
            strip: $a3cc47026fbd254a$var$isProduction()
        });
        (_b = window.va) == null || _b.call(window, "event", {
            name: name2,
            data: props,
            options: options
        });
    } catch (err) {
        if (err instanceof Error && $a3cc47026fbd254a$var$isDevelopment()) console.error(err);
    }
}
function $a3cc47026fbd254a$var$pageview({ route: route, path: path }) {
    var _a;
    (_a = window.va) == null || _a.call(window, "pageview", {
        route: route,
        path: path
    });
}
// src/react/utils.ts
function $a3cc47026fbd254a$var$getBasePath() {
    return void 0;
}
// src/react/index.tsx
function $a3cc47026fbd254a$export$2b3af6baec22bd98(props) {
    (0, $3xFFA.useEffect)(()=>{
        var _a;
        if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    }, [
        props.beforeSend
    ]);
    (0, $3xFFA.useEffect)(()=>{
        $a3cc47026fbd254a$var$inject({
            framework: props.framework || "react",
            basePath: props.basePath ?? $a3cc47026fbd254a$var$getBasePath(),
            ...props.route !== void 0 && {
                disableAutoTrack: true
            },
            ...props
        });
    }, []);
    (0, $3xFFA.useEffect)(()=>{
        if (props.route && props.path) $a3cc47026fbd254a$var$pageview({
            route: props.route,
            path: props.path
        });
    }, [
        props.route,
        props.path
    ]);
    return null;
}


let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $0f51dce6f3d66152$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $0743a88a30c3c026$export$25062201e9e25d76)((0, $3xFFA.StrictMode), {
    children: [
        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $cd93687958c8007e$export$86fbec116b87613f), {}),
        /*#__PURE__*/ (0, $0743a88a30c3c026$export$34b9dba7ce09269b)((0, $a3cc47026fbd254a$export$2b3af6baec22bd98), {})
    ]
}));


//# sourceMappingURL=path0.0ac059f7.js.map
